/* tslint:disable */
import * as t from "./graphql.schema";

import gql from 'graphql-tag';
import * as Urql from 'polygraphql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const UserPermisionsFragmentDoc = gql`
    fragment UserPermisions on Permission {
  name
}
    `;
export const AuditLogFragmentDoc = gql`
    fragment auditLog on AuditLog {
  id
  userId
  username
  logTime
  eventType
  eventDetails
  loginType
  publicIpAddress
  authorized
}
    `;
export const AccountListMergeRequestsFragmentDoc = gql`
    fragment AccountListMergeRequests on MergeEntityRequest {
  id
  createdAt
  acceptedAt
  acceptedById
  cancelledAt
  cancelledById
  confirmedAt
  confirmedById
  mergeFromId
  mergeFromType
  mergeToId
  mergeToType
  rejectedAt
  rejectedById
  updatedAt
}
    `;
export const PermisionRolesFragmentDoc = gql`
    fragment PermisionRoles on Role {
  name
  permissions {
    name
  }
}
    `;
export const PermisionsGrantsFragmentDoc = gql`
    fragment PermisionsGrants on Grant {
  resourceId
  resourceType
  roles {
    name
    permissions {
      name
    }
    tags
  }
  permissions {
    name
  }
}
    `;
export const ConnectedDeviceFragmentDoc = gql`
    fragment ConnectedDevice on Device {
  id
  name
  serialNumber
  softwareVersion
  lastDetected
  hardwareModel
  hardwareProduct
  hardwareRevision
  macAddress
  tenant {
    id
  }
  connected
  site {
    id
    name
  }
  bandwidth {
    endTime
    pingLatencyMs
    pingJitterMs
    pingLossPercent
    uploadMbps
    downloadMbps
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  user_id
  email
  name
  picture
  created_at
  blocked
  last_login
  logins_count
  last_ip
  given_name
  family_name
  identities {
    connection
    isSocial
  }
  user_metadata {
    info {
      defaultInventoryView
    }
  }
  connections {
    ...ConnectedDevice
    connections {
      ...ConnectedDevice
    }
  }
}
    ${ConnectedDeviceFragmentDoc}`;
export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  user_id
  email
  name
  email_verified
  picture
  created_at
  phone_number
  last_login
  logins_count
  blocked
}
    `;
export const UsersListConnectionFragmentDoc = gql`
    fragment UsersListConnection on UserConnection {
  total: count
  pageInfo {
    hasNextPage
    endCursor
  }
  searchData: edges {
    cursor
    node {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;
export const CommonActionConfigurationsFragmentDoc = gql`
    fragment CommonActionConfigurations on ActionConfiguration {
  id
  enabled
  actionType {
    id
    type
  }
  rate
  allowedRates
}
    `;
export const CommonAudienceFragmentDoc = gql`
    fragment CommonAudience on Audience {
  id
  enabled
  recipients {
    id
    confirmed
    email
  }
  actionConfigurations {
    ...CommonActionConfigurations
  }
}
    ${CommonActionConfigurationsFragmentDoc}`;
export const ServiceNowHookPageFragmentDoc = gql`
    fragment ServiceNowHookPage on ServiceNowWebhook {
  enabled
  id
  name
  url
  username
  lastErrorBody: last_error_body
  lastErrorMessage: last_error_message
  lastErrorStatusCode: last_error_status_code
  lastErrorTime: last_error_time
  succeedingSince: succeeding_since
  actionConfigurations {
    allowedRates
    enabled
    id
    rate
    actionType {
      id
      type
    }
  }
}
    `;
export const TeamsHookPageFragmentDoc = gql`
    fragment TeamsHookPage on TeamsHook {
  id
  name
  url
  enabled
  actionConfigurations {
    id
    enabled
    rate
    allowedRates
    actionType {
      id
      type
    }
  }
}
    `;
export const AccountDetailFragmentDoc = gql`
    fragment AccountDetail on ProvisioningAccount {
  uuid
  username
  password
  description
  type
  isDisabled
  downloadPath
  provisioningUri
}
    `;
export const RoomDeviceFragmentDoc = gql`
    fragment RoomDevice on Device {
  id
  name
  macAddress
  hardwareModel
  softwareVersion
  internalIp
  connected
  model {
    id
    name
  }
}
    `;
export const SiteForTenantFragmentDoc = gql`
    fragment SiteForTenant on Site {
  id
  name
  rooms {
    id
    name
    devices {
      ...RoomDevice
    }
  }
  address {
    city
    region
    country
  }
}
    ${RoomDeviceFragmentDoc}`;
export const RoomForTenantFragmentDoc = gql`
    fragment RoomForTenant on Room {
  id
  name
  devices {
    ...RoomDevice
  }
}
    ${RoomDeviceFragmentDoc}`;
export const TrialUserSubscriptionDataFragmentDoc = gql`
    fragment TrialUserSubscriptionData on ClaritiTrialUserSubscription {
  id
  meetingUrl
  meetingRoomId
}
    `;
export const TrialConferenceReportDataFragmentDoc = gql`
    fragment TrialConferenceReportData on ClaritiTrialConferenceReport {
  conferenceIdentifier
  conferenceRoomIdentifier
  endTime
  entityTag
  hostName
  id
  numberOfParticipants
  participantsDetails
  startTime
  subscriptionReportId
}
    `;
export const TrialUsageStatsDataFragmentDoc = gql`
    fragment TrialUsageStatsData on ClaritiTrialUsageStats {
  averageNumberOfParticipants
  conferenceReports {
    ...TrialConferenceReportData
  }
  conferencesUsageCounter
  maxNumberOfParticipants
  minNumberOfParticipants
  totalDurationMinutes
  totalNumberOfParticipants
}
    ${TrialConferenceReportDataFragmentDoc}`;
export const TrialUserInfoDataFragmentDoc = gql`
    fragment TrialUserInfoData on ClaritiTrialUserInfo {
  email
  familyName
  givenName
  name
}
    `;
export const TrialSubscriptionReportDataFragmentDoc = gql`
    fragment TrialSubscriptionReportData on ClaritiTrialSubscriptionReport {
  aboutToExpireEmailSent
  browserType
  createdAt
  eulaAcceptanceDate
  eulaAccepted
  expired
  id
  latestUse
  meetingRoomId
  meetingUrl
  subscriptionDate
  subscriptionExpiredEmailSent
  usageStats {
    ...TrialUsageStatsData
  }
  user {
    ...TrialUserInfoData
  }
  welcomeEmailSent
}
    ${TrialUsageStatsDataFragmentDoc}
${TrialUserInfoDataFragmentDoc}`;
export const TrialSubscriptionReportDataEdgeFragmentDoc = gql`
    fragment TrialSubscriptionReportDataEdge on ClaritiTrialSubscriptionReportConnectionEdge {
  cursor
  node {
    ...TrialSubscriptionReportData
  }
}
    ${TrialSubscriptionReportDataFragmentDoc}`;
export const TrialSubscriptionReportDataConnectionFragmentDoc = gql`
    fragment TrialSubscriptionReportDataConnection on ClaritiTrialSubscriptionReportConnection {
  total
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    ...TrialSubscriptionReportDataEdge
  }
}
    ${TrialSubscriptionReportDataEdgeFragmentDoc}`;
export const AggregateFieldsFragmentDoc = gql`
    fragment AggregateFields on Aggregate {
  field
  buckets {
    __typename
    ... on KeyBucket {
      key
    }
    ... on FieldMissingBucket {
      fieldMissing
    }
    count
  }
}
    `;
export const InsightChartMetaFieldsFragmentDoc = gql`
    fragment insightChartMetaFields on InsightChartMeta {
  topic
  aggType
  timeScope
  increment
  childCount
  otherCount
}
    `;
export const MeetingRecordAggregateChartMetaFieldsFragmentDoc = gql`
    fragment meetingRecordAggregateChartMetaFields on MeetingRecordAggregateChartMeta {
  test
}
    `;
export const ChartMetaFieldsFragmentDoc = gql`
    fragment chartMetaFields on ChartMeta {
  __typename
  ...insightChartMetaFields
  ...meetingRecordAggregateChartMetaFields
}
    ${InsightChartMetaFieldsFragmentDoc}
${MeetingRecordAggregateChartMetaFieldsFragmentDoc}`;
export const InsightSeriesMetaFieldsFragmentDoc = gql`
    fragment insightSeriesMetaFields on InsightSeriesMeta {
  seriesType
  locationScope
  object {
    __typename
    ... on Site {
      siteName: name
      id
    }
    ... on Room {
      roomName: name
      id
    }
    ... on Tenant {
      tenantName: name
      id
    }
    ... on Device {
      deviceName: name
      id
    }
    ... on Other {
      id
    }
  }
}
    `;
export const MeetingRecordAggregateSeriesMetaFieldsFragmentDoc = gql`
    fragment meetingRecordAggregateSeriesMetaFields on MeetingRecordAggregateSeriesMeta {
  test
}
    `;
export const SeriesMetaFieldsFragmentDoc = gql`
    fragment seriesMetaFields on SeriesMeta {
  __typename
  ...insightSeriesMetaFields
  ...meetingRecordAggregateSeriesMetaFields
}
    ${InsightSeriesMetaFieldsFragmentDoc}
${MeetingRecordAggregateSeriesMetaFieldsFragmentDoc}`;
export const ChartFieldsFragmentDoc = gql`
    fragment chartFields on Chart {
  meta {
    ...chartMetaFields
  }
  series {
    name
    meta {
      ...seriesMetaFields
    }
    data {
      x
      y
    }
  }
}
    ${ChartMetaFieldsFragmentDoc}
${SeriesMetaFieldsFragmentDoc}`;
export const DetailFieldsFragmentDoc = gql`
    fragment detailFields on TopicIndicator {
  id
  type
  topic {
    id
    type
    higherIsBetter
    category
  }
  timeScope
  locationScope
  timePeriodStart
  deviceType
  room {
    name
    id
  }
  site {
    name
    id
  }
  tenant {
    name
    id
  }
  model
  version
  device {
    name
    id
  }
  modelVersion
  family
  indicator {
    ... on AverageIndicator {
      __typename
      average
    }
    ... on CountOfTotalIndicator {
      __typename
      count
      total
      percentage
    }
    ... on CountAverageIndicator {
      __typename
      count
      average
    }
  }
  locationScope
  trendingUpward
  previous {
    ... on AverageIndicator {
      __typename
      average
    }
    ... on CountOfTotalIndicator {
      __typename
      count
      total
      percentage
    }
    ... on CountAverageIndicator {
      __typename
      count
      average
    }
  }
  tenantAverage
  tenantPercentile
  globalAverage
  globalPercentile
  previousTenantPercentile
  previousGlobalPercentile
}
    `;
export const InsightDetailsFragmentDoc = gql`
    fragment insightDetails on TopicIndicator {
  ...detailFields
  recommendedDetail {
    locationScope
    connection {
      count
      edges {
        node {
          ...detailFields
        }
      }
    }
  }
}
    ${DetailFieldsFragmentDoc}`;
export const SimilarInsightsFragmentDoc = gql`
    fragment similarInsights on TopicIndicator {
  id
  type
  topic {
    id
    type
    higherIsBetter
  }
  timeScope
  locationScope
  deviceType
  device {
    name
    id
  }
  room {
    name
    id
  }
  site {
    name
    id
  }
  tenant {
    name
    id
  }
  model
  version
  modelVersion
  family
  indicator {
    ... on AverageIndicator {
      average
    }
    ... on CountOfTotalIndicator {
      count
      total
      percentage
    }
    ... on CountAverageIndicator {
      count
      average
    }
  }
  locationScope
  timePeriodStart
}
    `;
export const PriorityFieldsNonFederatedFragmentDoc = gql`
    fragment PriorityFieldsNonFederated on TopicIndicator {
  topic {
    higherIsBetter
  }
}
    `;
export const ContinuingPageFragmentDoc = gql`
    fragment ContinuingPage on PageInfo {
  endCursor
  hasNextPage
}
    `;
export const AllIndicatorsFragmentDoc = gql`
    fragment AllIndicators on Indicator {
  __typename
  ... on AverageIndicator {
    average
  }
  ... on CountOfTotalIndicator {
    count
    total
    percentage
  }
  ... on CountAverageIndicator {
    count
    average
  }
}
    `;
export const PriorityFieldsFragmentDoc = gql`
    fragment PriorityFields on TopicIndicator {
  id
  type
  topic {
    id
    higherIsBetter
    category
  }
  timeScope
  locationScope
  timePeriodStart
  deviceType
  room {
    name
    id
  }
  site {
    name
    id
  }
  tenant {
    name
    id
  }
  model
  version
  device {
    name
    id
  }
  modelVersion
  family
  trendingUpward
  notability
  indicator {
    ...AllIndicators
  }
  previous {
    ...AllIndicators
  }
}
    ${AllIndicatorsFragmentDoc}`;
export const PaginatedIndicatorsFragmentDoc = gql`
    fragment PaginatedIndicators on TopicIndicatorConnection {
  pageInfo {
    ...ContinuingPage
  }
  edges {
    cursor
    node {
      ...PriorityFields
    }
  }
}
    ${ContinuingPageFragmentDoc}
${PriorityFieldsFragmentDoc}`;
export const SiteBucketFragmentDoc = gql`
    fragment SiteBucket on Aggregate {
  field
  buckets {
    __typename
    ... on KeyBucket {
      site: key
    }
    ... on FieldMissingBucket {
      fieldMissing
    }
  }
}
    `;
export const VersionBucketFragmentDoc = gql`
    fragment VersionBucket on Aggregate {
  field
  buckets {
    __typename
    ... on KeyBucket {
      versionCount: count
      updateVersion: key
      sites: aggregates {
        ...SiteBucket
      }
    }
    ... on FieldMissingBucket {
      fieldMissing
    }
  }
}
    ${SiteBucketFragmentDoc}`;
export const GroupFragmentDoc = gql`
    fragment Group on GroupDto {
  id
  name
  createdAt
  deviceSerials
  policies
}
    `;
export const GroupDeviceFragmentDoc = gql`
    fragment GroupDevice on Device {
  id
  name
  serialNumber
  hardwareModel
  softwareVersion
  site {
    id
    name
  }
  connected
  supportsSettings
  supportsSoftwareUpdate
  provisioningEnabled
  lastConfigRequestDate
  entityConnections(params: {directional: true}) {
    edges {
      node {
        entityId
        targetEntityId
        type
        connected
      }
    }
  }
}
    `;
export const GroupPolicyFragmentDoc = gql`
    fragment GroupPolicy on Policy {
  policyId
  name
  configurationAttributes {
    name
  }
  deviceModel
  deviceModelUuid
}
    `;
export const DeviceUserInfoFragmentDoc = gql`
    fragment DeviceUserInfo on User {
  user_id
  name
  email
  last_login
  connections {
    ...ConnectedDevice
    connections {
      ...ConnectedDevice
    }
  }
}
    ${ConnectedDeviceFragmentDoc}`;
export const NetworkDiagnosticFragmentDoc = gql`
    fragment NetworkDiagnostic on Device {
  bandwidth {
    downloadMbps
    endTime
    pingJitterMs
    pingLatencyMs
    pingLossPercent
    uploadMbps
  }
}
    `;
export const EntityConnectionsConnectedStateFragmentDoc = gql`
    fragment EntityConnectionsConnectedState on Device {
  entityConnections(params: {directional: true}) {
    edges {
      node {
        entityId
        targetEntityId
        type
        connected
      }
    }
  }
}
    `;
export const DevicesCardPropsFragmentDoc = gql`
    fragment devicesCardProps on Device {
  macAddress
  internalIp
  serialNumber
  softwareVersion
  softwareBuild
  lastDetected
  proxyAgent
  site {
    id
    name
  }
  hardwareModel
  room {
    id
    name
  }
  id
  name
  connected
  provisioningEnabled
  lastConfigRequestDate
  dateRegistered
  activeApplicationName
  supportsSettings
  supportsSoftwareUpdate
  hasPeripherals
  allPeripheralsLinked
  ...EntityConnectionsConnectedState
}
    ${EntityConnectionsConnectedStateFragmentDoc}`;
export const DeviceConfigParamFragmentDoc = gql`
    fragment DeviceConfigParam on ExtendedConfigParam {
  name
  friendlyName
  value
  type
  categories
  exportConfigType
}
    `;
export const NetworkSettingsFragmentDoc = gql`
    fragment networkSettings on PolyOSConfig {
  content {
    conference {
      qualityPreference
    }
  }
  qos {
    tosType
    intServ {
      video
      audio
      fecc
      oam
    }
    diffServ {
      video
      audio
      fecc
      oam
    }
    mtuSize
    mtuMode
    LPR {
      enable
    }
    rsvp {
      enable
    }
    dynamicBandwidth {
      enable
    }
  }
}
    `;
export const CalendarSettingsFragmentDoc = gql`
    fragment calendarSettings on PolyOSConfig {
  exchange {
    enable
    auth {
      domain
      email
      password
      userName
    }
    server {
      url
    }
    meeting {
      reminderInterval
      reminderSound {
        enable
      }
    }
    showPrivateMeeting
  }
}
    `;
export const DisplaySettingsFragmentDoc = gql`
    fragment displaySettings on PolyOSConfig {
  video {
    monitor {
      ONE {
        display
      }
      TWO {
        display
      }
    }
  }
  homeScreen {
    backgroundImage
  }
}
    `;
export const CallServerSettingsFragmentDoc = gql`
    fragment callServerSettings on PolyOSConfig {
  voIpProt {
    H323 {
      enable
      e164
      gk {
        auth {
          enable
          password
          userId
        }
        ipAddress
        mode
      }
      name
    }
    SIP {
      enable
      auth {
        userId
        password
      }
      bfcpTransportPreference
      forceConnectionReuse
      proxyServer
      registrarServer
      registrarServerType
      serverType
      transport
      userName
    }
  }
}
    `;
export const UpgradeSettingsFragmentDoc = gql`
    fragment upgradeSettings on PolyOSConfig {
  upgrade {
    auto {
      enable
      server {
        type
        address
      }
      polling {
        interval
      }
      timeFrame {
        enable
        startTime
        stopTime
      }
    }
  }
}
    `;
export const DateTimeSettingsFragmentDoc = gql`
    fragment dateTimeSettings on PolyOSConfig {
  device {
    local {
      timezone
      autoDaylightSavings {
        enable
      }
      datetime {
        date {
          format
        }
        time {
          TWO4HourClock
        }
      }
      ntpServer {
        address
        mode
      }
    }
  }
}
    `;
export const SwSupportUpdatePathFragmentDoc = gql`
    fragment swSupportUpdatePath on SoftwareSupportUpdatePath {
  deviceModel
  swPath
}
    `;
export const PolicyFragmentDoc = gql`
    fragment policy on Policy {
  policyId
  name
  tenantId
  deviceId
  deviceType
  deviceModelUuid
  deviceModel
  siteId
  groupId
  policyType
  policyDeploymentScope
  configurationAttributes {
    name
    currentValue
    paramArray {
      replace1
      currentValue
    }
    param2DArray {
      replace1
      replace2
      currentValue
    }
  }
  swUpdatePath
  customSwUpdatePath
  customSwSupportUpdatePath {
    ...swSupportUpdatePath
  }
  swUpdateSource
}
    ${SwSupportUpdatePathFragmentDoc}`;
export const ExternalPolicyFragmentDoc = gql`
    fragment ExternalPolicy on Policy {
  lastSuccessfullyUpdated
  lastSuccessfullyUpdatedTime
}
    `;
export const DeviceParameterFragmentDoc = gql`
    fragment DeviceParameter on DeviceParameterDTO {
  displayName
  modelName
  name
  friendlyName
  paramType
  type
  defaultValue
  help
  templates
  callback
  accessType
  categories
  grouping
  groupingOrder
  lensUserType
  lensConditional
  lensConditionalValue
  languageKey
  min
  max
  enumVal {
    value
    friendlyValue
    featureCategory
  }
  numReplace1Max
  numReplace2Max
  param2DArray
  paramArray
  featureCategory
}
    `;
export const ExtendedDeviceParameterFragmentDoc = gql`
    fragment ExtendedDeviceParameter on ExtendedDeviceParameterDTO {
  name
  policyAttribute {
    name
    currentValue
    paramArray {
      replace1
      currentValue
    }
    param2DArray {
      replace1
      replace2
      currentValue
    }
  }
  policyDeploymentScope
  metadata {
    ...DeviceParameter
  }
}
    ${DeviceParameterFragmentDoc}`;
export const UpdateImageFragmentDoc = gql`
    fragment UpdateImage on EpUpdateImage {
  imageType
  imagePolicyType
  imageVersion
  fileName
  description
  directory
  status
  size
  swSupportUpdatePath {
    ...swSupportUpdatePath
  }
}
    ${SwSupportUpdatePathFragmentDoc}`;
export const DeviceCertificateFragmentDoc = gql`
    fragment deviceCertificate on CertificateResponse {
  success
  deviceId
  error
  subjectCN
  issuerCN
  expiry
  checksum
  sans
}
    `;
export const TenantRelayDeviceFragmentDoc = gql`
    fragment tenantRelayDevice on Device {
  id
  tenantId
  name
  hardwareModel
}
    `;
export const DeviceWithConnectionsFragmentDoc = gql`
    fragment DeviceWithConnections on Device {
  ...ConnectedDevice
  connections {
    ...ConnectedDevice
  }
}
    ${ConnectedDeviceFragmentDoc}`;
export const ConnectedDevicesFragmentDoc = gql`
    fragment ConnectedDevices on Device {
  connections {
    ...DeviceWithConnections
  }
}
    ${DeviceWithConnectionsFragmentDoc}`;
export const ConnectedEntityFragmentDoc = gql`
    fragment ConnectedEntity on Device {
  id
  name
  serialNumber
  softwareVersion
  lastDetected
  hardwareModel
  hardwareRevision
  macAddress
  tenant {
    id
  }
  connected
  site {
    id
    name
  }
  lastConfigRequestDate
  supportsSettings
  supportsSoftwareUpdate
  provisioningEnabled
}
    `;
export const EntityConnectionFragmentDoc = gql`
    fragment EntityConnection on EntityConnection {
  entityId
  targetEntityId
  targetEntity {
    ...ConnectedEntity
  }
  type
  connected
  createdOn
  updatedOn
}
    ${ConnectedEntityFragmentDoc}`;
export const EntityConnectionsFragmentDoc = gql`
    fragment EntityConnections on Device {
  entityConnections(params: {directional: true}) {
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...EntityConnection
      }
      cursor
    }
  }
}
    ${EntityConnectionFragmentDoc}`;
export const DeviceFragmentDoc = gql`
    fragment device on Device {
  id
  name
  tenant {
    id
  }
  user {
    user_id
    name
  }
  organization
  hardwareModel
  hardwareFamily
  hasPeripherals
  allPeripheralsLinked
  softwareVersion
  proxyAgent
  lastDetected
  softwareBuild
  externalIp
  internalIp
  macAddress
  serialNumber
  connected
  product {
    id
  }
  model {
    id
  }
  site {
    id
    name
    address {
      formattedAddress
      address1
      country
      city
      region
      postalCode
    }
  }
  room {
    id
    name
    floor
  }
  provisioningEnabled
  lastConfigRequestDate
  activeApplicationName
  dateRegistered
  ...ConnectedDevices
  ...EntityConnections
  supportsSettings
  supportsSoftwareUpdate
}
    ${ConnectedDevicesFragmentDoc}
${EntityConnectionsFragmentDoc}`;
export const DeviceLineFragmentDoc = gql`
    fragment DeviceLine on C10OutputServiceInformation {
  deviceid {
    value
  }
  lineid {
    value
  }
  serveraddr {
    value
  }
  status {
    value
  }
  linetype {
    value
  }
  regtype {
    value
  }
  userid {
    value
  }
  email {
    value
  }
  expiry {
    value
  }
  displayname {
    value
  }
  sipport {
    value
  }
  sipaddr {
    value
  }
  siptranport {
    value
  }
  sipaccountname {
    value
  }
  sipdomainname {
    value
  }
  sipusername {
    value
  }
  srvplatform {
    value
  }
  failurereason {
    value
  }
  outboundproxy {
    value
  }
  outboundproxytransport {
    value
  }
  uploadtime {
    value
  }
  versioninfo {
    value
  }
  registeredip {
    value
  }
  domain {
    value
  }
  authtype {
    value
  }
  basedn {
    value
  }
  defaultgroup {
    value
  }
  enablessl {
    value
  }
  globalserver {
    value
  }
  serverport {
    value
  }
}
    `;
export const C10PdiFragmentDoc = gql`
    fragment C10PDI on C10PrimaryDeviceInformation {
  reboottype {
    value
  }
  regioncode {
    value
  }
  powersource {
    value
  }
  softwarebuild {
    value
  }
  hardwarepn {
    value
  }
  versioninfo {
    value
  }
  updaterversion {
    value
  }
  uploadtime {
    value
  }
  hostos {
    value
  }
  hostosbuild {
    value
  }
  hostosversion {
    value
  }
  productname {
    value
  }
  hosthardware {
    value
  }
  eventmonotonictime {
    value
  }
  productid {
    value
  }
  proxyagent {
    value
  }
  proxyagentversion {
    value
  }
  proxyagentid {
    value
  }
  featurevariation {
    value
  }
  devicesignature {
    value
  }
  softwarerelease {
    value
  }
  serialnumber {
    value
  }
  hardwaremodel {
    value
  }
  offsetgmt {
    value
  }
  macaddress {
    value
  }
  productfamily {
    value
  }
  deviceid {
    value
  }
  hardwarerevision {
    value
  }
  manufacturer {
    value
  }
}
    `;
export const OsStateFragmentDoc = gql`
    fragment OSState on Device {
  id
  connected
  softwareVersion
  softwareBuild
  availableOSs {
    version {
      id
      version
      displayName
    }
  }
  currentOSState {
    updateStatus {
      maxTime
      percentage
      percentageComplete
      progressState
      softUpdateStage
      softUpdateStatus
    }
  }
}
    `;
export const AccessTokenDataFragmentDoc = gql`
    fragment AccessTokenData on ns_ls_ClientAuthToken {
  creationTime
  lastModifiedTime
  lastUsedTime
  recordId
  tenantId
  token
}
    `;
export const AccessTokenDataEdgeFragmentDoc = gql`
    fragment AccessTokenDataEdge on ns_ls_ClientAuthTokenEdge {
  cursor
  node {
    ...AccessTokenData
  }
}
    ${AccessTokenDataFragmentDoc}`;
export const AccessTokenDataConnectionFragmentDoc = gql`
    fragment AccessTokenDataConnection on ns_ls_ClientAuthTokenConnection {
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    ...AccessTokenDataEdge
  }
}
    ${AccessTokenDataEdgeFragmentDoc}`;
export const AuditEventDataFragmentDoc = gql`
    fragment AuditEventData on ns_ls_AuditEvent {
  additionalInfo
  creationTime
  entitlementName
  etag
  eventTime
  eventType
  instanceName
  newValue
  onObjectId
  previousValue
  recordId
  tenantId
  userName
}
    `;
export const AuditEventDataEdgeFragmentDoc = gql`
    fragment AuditEventDataEdge on ns_ls_AuditEventEdge {
  cursor
  node {
    ...AuditEventData
  }
}
    ${AuditEventDataFragmentDoc}`;
export const AuditEventDataConnectionFragmentDoc = gql`
    fragment AuditEventDataConnection on ns_ls_AuditEventConnection {
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    ...AuditEventDataEdge
  }
}
    ${AuditEventDataEdgeFragmentDoc}`;
export const EntitlementGroupingAssignmentSetDataFragmentDoc = gql`
    fragment EntitlementGroupingAssignmentSetData on ns_ls_EntitlementGroupingAssignmentSet {
  assignedToTenant
  assignedValueSum
  awaitingReassignEntitlementIds
  awaitingReassignValueSum
  awaitingReleaseValueSum
  entitlementIds
  groupingId
  orphanedCount
  orphanedValueSum
  recordId
  totalAssignedValueSum
  usedValueSum
  valueSum
}
    `;
export const EntitlementDataFragmentDoc = gql`
    fragment EntitlementData on ns_ls_Entitlement {
  activationCode
  assignedToRecordId
  begins
  creationTime
  etag
  expires
  groupingId
  lastModifiedTime
  mappingId1
  mappingId2
  name
  pendingAssignedToRecordId
  productId
  productVersion
  recordId
  state
  stringValue
  tenantId
  assignedToTenant
  type
  value
  valueType
}
    `;
export const EntitlementGroupingSetDataFragmentDoc = gql`
    fragment EntitlementGroupingSetData on ns_ls_EntitlementGroupingSet {
  assignedToTenant
  assignedValueSum
  assignmentGroupingSets {
    ...EntitlementGroupingAssignmentSetData
  }
  assignmentRecordIds
  availableValueSum
  awaitingReassignValueSum
  awaitingReleaseValueSum
  entitlements {
    ...EntitlementData
  }
  groupingId
  isBoolean
  isUnlimitedBoolean
  normalValueSum
  orphanedCount
  orphanedValueSum
  totalAssignedValueSum
  usedValueSum
  valueSum
}
    ${EntitlementGroupingAssignmentSetDataFragmentDoc}
${EntitlementDataFragmentDoc}`;
export const EntitlementGroupingSetConnectionFragmentDoc = gql`
    fragment EntitlementGroupingSetConnection on ns_ls_EntitlementGroupingSetConnection {
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    cursor
    node {
      ...EntitlementGroupingSetData
    }
  }
}
    ${EntitlementGroupingSetDataFragmentDoc}`;
export const InstanceDataFragmentDoc = gql`
    fragment InstanceData on ns_ls_Instance {
  creationTime
  entitlements
  etag
  hasEncodedLicense
  hasInitialEncodedRequest
  hasServerChainToken
  hostname
  instanceId
  lastLicenseExpires
  lastLicenseHadExpiredEntitlements
  lastLicensedTime
  lastModifiedTime
  macs
  niceName
  pendingEntitlements
  productId
  productVersion
  recordId
  serialNumber
  tenantId
  useAlternateLicencing
}
    `;
export const InstanceListConnectionFragmentDoc = gql`
    fragment InstanceListConnection on ns_ls_InstanceConnection {
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    cursor
    node {
      ...InstanceData
    }
  }
}
    ${InstanceDataFragmentDoc}`;
export const ProductLatestVersionDataFragmentDoc = gql`
    fragment ProductLatestVersionData on ns_ls_ProductLatestVersion {
  productId
  latestVersion
}
    `;
export const ProductLatestVersionListDataFragmentDoc = gql`
    fragment ProductLatestVersionListData on ns_ls_ProductLatestVersionList {
  latestVersions {
    ...ProductLatestVersionData
  }
}
    ${ProductLatestVersionDataFragmentDoc}`;
export const ProductVersionsDataFragmentDoc = gql`
    fragment ProductVersionsData on ns_ls_ProductVersions {
  productId
  versions
}
    `;
export const ProductSoftwareEntryDataFragmentDoc = gql`
    fragment ProductSoftwareEntryData on ns_ls_SoftwareEntry {
  artifactName
  fileSize
  lastModifiedTime
  url
}
    `;
export const ProductSoftwareCatalogDataFragmentDoc = gql`
    fragment ProductSoftwareCatalogData on ns_ls_SoftwareCatalog {
  productId
  version
  softwareArtifacts {
    ...ProductSoftwareEntryData
  }
}
    ${ProductSoftwareEntryDataFragmentDoc}`;
export const AvailableLicenseFragmentDoc = gql`
    fragment availableLicense on License {
  licenseKey
  quantity
  endDate
  models
}
    `;
export const HardwareModelFragmentDoc = gql`
    fragment hardwareModel on HardwareModel {
  id
  name
  aliases
  supportsProvisioning
  supportsPolicies
  skus {
    id
  }
}
    `;
export const ResourceFileFragmentDoc = gql`
    fragment ResourceFile on ResourceFileDTO {
  tenantId
  fileName
  fileSize
  uploadedBy
  uploadedTime
}
    `;
export const MtrRoomDeviceFragmentDoc = gql`
    fragment MTRRoomDevice on Device {
  ...RoomDevice
  model {
    id
    name
    images {
      url
    }
    hardwareFamily {
      id
    }
  }
  product {
    id
  }
  serialNumber
}
    ${RoomDeviceFragmentDoc}`;
export const RoomDataFragmentDoc = gql`
    fragment RoomData on Room {
  __typename
  id
  name
  floor
  capacity
  site {
    id
    name
  }
  devices {
    ...RoomDevice
  }
}
    ${RoomDeviceFragmentDoc}`;
export const SitesListEdgesFragmentDoc = gql`
    fragment SitesListEdges on SiteConnectionEdge {
  cursor
  node {
    id
    name
    roomCount
    deviceCount
    devicesOnlinePercentage
  }
}
    `;
export const SiteOnRoomFragmentDoc = gql`
    fragment SiteOnRoom on Site {
  id
  name
}
    `;
export const RoomsListEdgesFragmentDoc = gql`
    fragment RoomsListEdges on RoomConnectionEdge {
  cursor
  node {
    id
    name
    site {
      ...SiteOnRoom
    }
    deviceCount
    devicesOnlinePercentage
    capacity
  }
}
    ${SiteOnRoomFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment product on HardwareProduct {
  id
  name
  images {
    id
    url
  }
  hardwareModel {
    id
    name
    hardwareFamily {
      id
      name
    }
    hardwareManufacturer {
      id
      name
    }
  }
}
    `;
export const TenantsListDocument = gql`
    query TenantsList($from: Int = 0, $limit: Int = 100, $namePrefix: String, $tenantType: TenantType) {
  tenants(from: $from, limit: $limit, namePrefix: $namePrefix, tenantType: $tenantType, sort: {fields: [{name: "name", direction: ASC}, {name: "id", direction: ASC}]}) {
    id
    name
    type
    sites(after: "0") {
      count
    }
    rooms(after: "0") {
      count
    }
  }
}
    `;

export function useTenantsListQuery(options: Omit<Urql.UseQueryArgs<TenantsListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantsListQuery>({ query: TenantsListDocument, ...options });
};
export const TenantCreationDateDocument = gql`
    query TenantCreationDate($id: ID!) {
  tenant(id: $id) {
    id
    createdAt
  }
}
    `;

export function useTenantCreationDateQuery(options: Omit<Urql.UseQueryArgs<TenantCreationDateQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantCreationDateQuery>({ query: TenantCreationDateDocument, ...options });
};
export const RolesAndPermisionsDocument = gql`
    query RolesAndPermisions($accessorId: ID!) {
  accessor(accessorId: $accessorId) {
    id
    grants {
      resourceId
      resourceType
      roles {
        name
      }
      permissions {
        ...UserPermisions
      }
    }
  }
  roles {
    name
    permissions {
      ...UserPermisions
    }
  }
}
    ${UserPermisionsFragmentDoc}`;

export function useRolesAndPermisionsQuery(options: Omit<Urql.UseQueryArgs<RolesAndPermisionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RolesAndPermisionsQuery>({ query: RolesAndPermisionsDocument, ...options });
};
export const AcceptInviteDocument = gql`
    mutation acceptInvite($code: ID!) {
  acceptUserInvite(code: $code) {
    invite {
      tenant_id
    }
  }
}
    `;

export function useAcceptInviteMutation() {
  return Urql.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument);
};
export const AccountsListDocument = gql`
    query AccountsList($from: Int = 0, $limit: Int = 100, $namePrefix: String, $tenantType: TenantType, $sort: TenantSort = {fields: [{name: "name", direction: ASC}]}) {
  tenants(from: $from, limit: $limit, namePrefix: $namePrefix, tenantType: $tenantType, sort: $sort) {
    id
    name
    type
    sites(after: "0") {
      count
    }
    rooms(after: "0") {
      count
    }
    deviceCount
    memberCount
  }
}
    `;

export function useAccountsListQuery(options: Omit<Urql.UseQueryArgs<AccountsListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AccountsListQuery>({ query: AccountsListDocument, ...options });
};
export const AuditLogsDocument = gql`
    query AuditLogs($filter: LogFilter, $from: Int, $limit: Int, $sort: Sort, $tenantId: String!) {
  getAuditLogs(filter: $filter, from: $from, limit: $limit, sort: $sort, tenantId: $tenantId) {
    ...auditLog
  }
}
    ${AuditLogFragmentDoc}`;

export function useAuditLogsQuery(options: Omit<Urql.UseQueryArgs<AuditLogsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AuditLogsQuery>({ query: AuditLogsDocument, ...options });
};
export const ConsolidateAndRenameAccountsDocument = gql`
    mutation ConsolidateAndRenameAccounts($fromId: ID!, $toId: ID!, $input: UpdateTenantInput!) {
  mergeInternalTenants(mergeFromTenantId: $fromId, mergeToTenantId: $toId) {
    mergeRequest {
      id
    }
  }
  updateTenant(id: $toId, input: $input) {
    tenant {
      id
    }
  }
}
    `;

export function useConsolidateAndRenameAccountsMutation() {
  return Urql.useMutation<ConsolidateAndRenameAccountsMutation, ConsolidateAndRenameAccountsMutationVariables>(ConsolidateAndRenameAccountsDocument);
};
export const DualTenantUserCountsDocument = gql`
    query DualTenantUserCounts($tenant1Id: String!, $tenant2Id: String!) {
  tenant1: users(params: {grants: [{resourceId: $tenant1Id}]}, first: 1) {
    total: count
  }
  tenant2: users(params: {grants: [{resourceId: $tenant2Id}]}, first: 1) {
    total: count
  }
  common: users(params: {grants: [{resourceId: $tenant1Id}, {resourceId: $tenant2Id}]}, first: 1) {
    total: count
  }
}
    `;

export function useDualTenantUserCountsQuery(options: Omit<Urql.UseQueryArgs<DualTenantUserCountsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DualTenantUserCountsQuery>({ query: DualTenantUserCountsDocument, ...options });
};
export const DeleteTenantDocument = gql`
    mutation deleteTenant($tenantId: ID!) {
  deleteTenant(id: $tenantId) {
    id
  }
}
    `;

export function useDeleteTenantMutation() {
  return Urql.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument);
};
export const DeviceCountForTenantDocument = gql`
    query DeviceCountForTenant($tenantId: String!) {
  deviceCount: countDevices(filter: {eq: $tenantId, field: "tenantId"})
}
    `;

export function useDeviceCountForTenantQuery(options: Omit<Urql.UseQueryArgs<DeviceCountForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceCountForTenantQuery>({ query: DeviceCountForTenantDocument, ...options });
};
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: ID!, $input: UpdateTenantInput!) {
  updateTenant(id: $id, input: $input) {
    account: tenant {
      id
      name
      type
    }
  }
}
    `;

export function useUpdateTenantMutation() {
  return Urql.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument);
};
export const TenantIntegrationsDocument = gql`
    query TenantIntegrations($tenantId: ID!, $integration: TenantIntegrationInput) {
  tenantIntegrations(tenantId: $tenantId, integration: $integration) {
    id
    integrationType
    detail {
      MicrosoftTenantId
      scopes
    }
  }
}
    `;

export function useTenantIntegrationsQuery(options: Omit<Urql.UseQueryArgs<TenantIntegrationsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantIntegrationsQuery>({ query: TenantIntegrationsDocument, ...options });
};
export const CreateTenantIntegrationDocument = gql`
    mutation CreateTenantIntegration($tenantId: ID!, $integration: TenantIntegrationInput!) {
  createTenantIntegration(tenantId: $tenantId, integration: $integration) {
    integration {
      id
    }
  }
}
    `;

export function useCreateTenantIntegrationMutation() {
  return Urql.useMutation<CreateTenantIntegrationMutation, CreateTenantIntegrationMutationVariables>(CreateTenantIntegrationDocument);
};
export const DeleteTenantIntegrationDocument = gql`
    mutation DeleteTenantIntegration($tenantId: ID!, $integration: TenantIntegrationInput!) {
  deleteTenantIntegration(tenantId: $tenantId, integration: $integration) {
    id
  }
}
    `;

export function useDeleteTenantIntegrationMutation() {
  return Urql.useMutation<DeleteTenantIntegrationMutation, DeleteTenantIntegrationMutationVariables>(DeleteTenantIntegrationDocument);
};
export const CountAccountsDocument = gql`
    query CountAccounts {
  tenantCount
}
    `;

export function useCountAccountsQuery(options: Omit<Urql.UseQueryArgs<CountAccountsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CountAccountsQuery>({ query: CountAccountsDocument, ...options });
};
export const RequestsMadeDocument = gql`
    query RequestsMade($entityId: String) {
  mergeEntityRequests(entityId: $entityId) {
    mergeRequests {
      from {
        ...AccountListMergeRequests
      }
      to {
        ...AccountListMergeRequests
      }
    }
  }
}
    ${AccountListMergeRequestsFragmentDoc}`;

export function useRequestsMadeQuery(options: Omit<Urql.UseQueryArgs<RequestsMadeQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RequestsMadeQuery>({ query: RequestsMadeDocument, ...options });
};
export const AccessorDocument = gql`
    query Accessor($accessorId: ID!) {
  accessor(accessorId: $accessorId) {
    id
    grants {
      resourceId
      resourceType
      roles {
        name
        tags
      }
    }
  }
}
    `;

export function useAccessorQuery(options: Omit<Urql.UseQueryArgs<AccessorQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AccessorQuery>({ query: AccessorDocument, ...options });
};
export const InviteMemberDocument = gql`
    mutation InviteMember($emails: [String!]!, $tenant_id: ID!, $role: String!) {
  inviteUser(emails: $emails, tenant_id: $tenant_id, role: $role) {
    invites {
      success
      email
      error
    }
  }
}
    `;

export function useInviteMemberMutation() {
  return Urql.useMutation<InviteMemberMutation, InviteMemberMutationVariables>(InviteMemberDocument);
};
export const GrantRoleDocument = gql`
    mutation GrantRole($accessorId: ID!, $resourceId: ID!, $role: String!) {
  grantRole(accessorId: $accessorId, resourceId: $resourceId, role: $role) {
    id
    grants {
      resourceId
      resourceType
      permissions {
        name
      }
      roles {
        name
      }
    }
  }
}
    `;

export function useGrantRoleMutation() {
  return Urql.useMutation<GrantRoleMutation, GrantRoleMutationVariables>(GrantRoleDocument);
};
export const RevokeRoleDocument = gql`
    mutation RevokeRole($accessorId: ID!, $resourceId: ID!, $role: String!) {
  revokeRole(accessorId: $accessorId, resourceId: $resourceId, role: $role) {
    id
    grants {
      resourceId
      roles {
        name
      }
    }
  }
}
    `;

export function useRevokeRoleMutation() {
  return Urql.useMutation<RevokeRoleMutation, RevokeRoleMutationVariables>(RevokeRoleDocument);
};
export const PermissionsDocument = gql`
    query Permissions($accessorId: ID!, $tags: [String!]) {
  loggedInUser: accessor(accessorId: $accessorId) {
    id
    grants {
      ...PermisionsGrants
    }
  }
  tenants {
    id
    name
  }
  roles(tags: $tags) {
    ...PermisionRoles
  }
}
    ${PermisionsGrantsFragmentDoc}
${PermisionRolesFragmentDoc}`;

export function usePermissionsQuery(options: Omit<Urql.UseQueryArgs<PermissionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PermissionsQuery>({ query: PermissionsDocument, ...options });
};
export const RemoveUserFromAccountDocument = gql`
    mutation removeUserFromAccount($id: ID!, $tid: ID!) {
  disassociateWithResource(accessorId: $id, resourceId: $tid) {
    id
    grants {
      resourceId
      roles {
        name
      }
      permissions {
        name
      }
    }
  }
}
    `;

export function useRemoveUserFromAccountMutation() {
  return Urql.useMutation<RemoveUserFromAccountMutation, RemoveUserFromAccountMutationVariables>(RemoveUserFromAccountDocument);
};
export const SwitchRoleDocument = gql`
    mutation switchRole($accessorId: ID!, $resourceId: ID!, $role: String, $resourceType: String, $tags: [String!]) {
  switchRole(accessorId: $accessorId, resourceId: $resourceId, role: $role, resourceType: $resourceType, tagFilters: {withTags: $tags}) {
    id
    grants {
      resourceId
      resourceType
      roles {
        name
        tags
      }
    }
  }
}
    `;

export function useSwitchRoleMutation() {
  return Urql.useMutation<SwitchRoleMutation, SwitchRoleMutationVariables>(SwitchRoleDocument);
};
export const UserByIdDocument = gql`
    query UserById($id: ID!) {
  user(id: $id) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

export function useUserByIdQuery(options: Omit<Urql.UseQueryArgs<UserByIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UserByIdQuery>({ query: UserByIdDocument, ...options });
};
export const UserDataByIdDocument = gql`
    query UserDataById($id: ID!) {
  user(id: $id) {
    user {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;

export function useUserDataByIdQuery(options: Omit<Urql.UseQueryArgs<UserDataByIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UserDataByIdQuery>({ query: UserDataByIdDocument, ...options });
};
export const RolesDocument = gql`
    query Roles($tags: [String!]) {
  roles(tags: $tags) {
    name
  }
}
    `;

export function useRolesQuery(options: Omit<Urql.UseQueryArgs<RolesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RolesQuery>({ query: RolesDocument, ...options });
};
export const TenantAccessorsDocument = gql`
    query TenantAccessors($params: AccessorSearchParams!) {
  accessors(params: $params) {
    id
    grants {
      resourceId
      roles {
        name
      }
    }
  }
}
    `;

export function useTenantAccessorsQuery(options: Omit<Urql.UseQueryArgs<TenantAccessorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantAccessorsQuery>({ query: TenantAccessorsDocument, ...options });
};
export const TenantDocument = gql`
    query Tenant($id: ID!) {
  tenant(id: $id) {
    id
    name
    type
    mockLicenseTenant
    type
  }
}
    `;

export function useTenantQuery(options: Omit<Urql.UseQueryArgs<TenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantQuery>({ query: TenantDocument, ...options });
};
export const UsersCountDocument = gql`
    query UsersCount($params: UserSearchParams!) {
  searchResult: users(params: $params) {
    count
  }
}
    `;

export function useUsersCountQuery(options: Omit<Urql.UseQueryArgs<UsersCountQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UsersCountQuery>({ query: UsersCountDocument, ...options });
};
export const UsersListDocument = gql`
    query UsersList($params: UserSearchParams!, $after: Cursor, $first: Int) {
  searchResult: users(params: $params, after: $after, first: $first) {
    ...UsersListConnection
  }
}
    ${UsersListConnectionFragmentDoc}`;

export function useUsersListQuery(options: Omit<Urql.UseQueryArgs<UsersListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UsersListQuery>({ query: UsersListDocument, ...options });
};
export const PendingInvitesListDocument = gql`
    query PendingInvitesList($tenantId: ID) {
  userInvitesByTenant(tenant_id: $tenantId) {
    invites {
      id
      email
      created_at
      tenant_id
      role_name
    }
  }
}
    `;

export function usePendingInvitesListQuery(options: Omit<Urql.UseQueryArgs<PendingInvitesListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PendingInvitesListQuery>({ query: PendingInvitesListDocument, ...options });
};
export const DeletePendingInviteDocument = gql`
    mutation DeletePendingInvite($inviteId: ID!) {
  cancelUserInvite(code: $inviteId) {
    invite {
      id
      email
    }
  }
}
    `;

export function useDeletePendingInviteMutation() {
  return Urql.useMutation<DeletePendingInviteMutation, DeletePendingInviteMutationVariables>(DeletePendingInviteDocument);
};
export const AudienceForTenantDocument = gql`
    query AudienceForTenant($tenantId: ID!) {
  tenant(id: $tenantId) {
    id
    name
    audience {
      ...CommonAudience
    }
  }
}
    ${CommonAudienceFragmentDoc}`;

export function useAudienceForTenantQuery(options: Omit<Urql.UseQueryArgs<AudienceForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AudienceForTenantQuery>({ query: AudienceForTenantDocument, ...options });
};
export const NcIntegrationsDocument = gql`
    query NCIntegrations($input: IntegrationsFilter) {
  notificationCenter {
    integrations(input: $input) {
      name
      actionConfigurations {
        type {
          id
          type
        }
        allowedRates
      }
    }
  }
}
    `;

export function useNcIntegrationsQuery(options: Omit<Urql.UseQueryArgs<NcIntegrationsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NcIntegrationsQuery>({ query: NcIntegrationsDocument, ...options });
};
export const AudienceForUserDocument = gql`
    query AudienceForUser($user_id: String!, $tid: ID!) {
  ncPoly {
    userAudience(input: {user_id: $user_id, tenantId: $tid}) {
      ...CommonAudience
    }
  }
}
    ${CommonAudienceFragmentDoc}`;

export function useAudienceForUserQuery(options: Omit<Urql.UseQueryArgs<AudienceForUserQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AudienceForUserQuery>({ query: AudienceForUserDocument, ...options });
};
export const EnableNotificationsForTenantDocument = gql`
    mutation EnableNotificationsForTenant($id: ID!) {
  ncEnableTenant(id: $id) {
    ...CommonAudience
  }
}
    ${CommonAudienceFragmentDoc}`;

export function useEnableNotificationsForTenantMutation() {
  return Urql.useMutation<EnableNotificationsForTenantMutation, EnableNotificationsForTenantMutationVariables>(EnableNotificationsForTenantDocument);
};
export const EnableNotificationsForUserDocument = gql`
    mutation EnableNotificationsForUser($user_id: String!, $tid: ID!) {
  ncEnableUser(input: {user_id: $user_id, tenantId: $tid}) {
    ...CommonAudience
  }
}
    ${CommonAudienceFragmentDoc}`;

export function useEnableNotificationsForUserMutation() {
  return Urql.useMutation<EnableNotificationsForUserMutation, EnableNotificationsForUserMutationVariables>(EnableNotificationsForUserDocument);
};
export const AddRecipientDocument = gql`
    mutation AddRecipient($audienceId: ID!, $email: Email!) {
  ncAddRecipient(input: {audienceId: $audienceId, email: $email}) {
    id
    confirmed
    email
  }
}
    `;

export function useAddRecipientMutation() {
  return Urql.useMutation<AddRecipientMutation, AddRecipientMutationVariables>(AddRecipientDocument);
};
export const RemoveRecipientDocument = gql`
    mutation RemoveRecipient($recipientId: ID!, $audienceId: ID!) {
  ncRemoveRecipient(input: {recipientId: $recipientId, audienceId: $audienceId}) {
    ...CommonAudience
  }
}
    ${CommonAudienceFragmentDoc}`;

export function useRemoveRecipientMutation() {
  return Urql.useMutation<RemoveRecipientMutation, RemoveRecipientMutationVariables>(RemoveRecipientDocument);
};
export const DisableNotificationsForTenantDocument = gql`
    mutation DisableNotificationsForTenant($id: ID!) {
  ncDisableTenant(id: $id) {
    id
    enabled
  }
}
    `;

export function useDisableNotificationsForTenantMutation() {
  return Urql.useMutation<DisableNotificationsForTenantMutation, DisableNotificationsForTenantMutationVariables>(DisableNotificationsForTenantDocument);
};
export const DisableNotificationsForUserDocument = gql`
    mutation DisableNotificationsForUser($user_id: String!, $tid: ID!) {
  ncDisableUser(input: {user_id: $user_id, tenantId: $tid}) {
    id
    enabled
  }
}
    `;

export function useDisableNotificationsForUserMutation() {
  return Urql.useMutation<DisableNotificationsForUserMutation, DisableNotificationsForUserMutationVariables>(DisableNotificationsForUserDocument);
};
export const EnableActionDocument = gql`
    mutation EnableAction($actionId: ID!, $audienceId: ID!) {
  ncEnableAction(input: {actionId: $actionId, audienceId: $audienceId}) {
    ...CommonActionConfigurations
  }
}
    ${CommonActionConfigurationsFragmentDoc}`;

export function useEnableActionMutation() {
  return Urql.useMutation<EnableActionMutation, EnableActionMutationVariables>(EnableActionDocument);
};
export const DisableActionDocument = gql`
    mutation DisableAction($actionId: ID!, $audienceId: ID!) {
  ncDisableAction(input: {actionId: $actionId, audienceId: $audienceId}) {
    ...CommonActionConfigurations
  }
}
    ${CommonActionConfigurationsFragmentDoc}`;

export function useDisableActionMutation() {
  return Urql.useMutation<DisableActionMutation, DisableActionMutationVariables>(DisableActionDocument);
};
export const SetActionFrequencyDocument = gql`
    mutation SetActionFrequency($actionId: ID!, $rate: Rate!) {
  ncSetFrequency(input: {actionId: $actionId, rate: $rate}) {
    ...CommonActionConfigurations
  }
}
    ${CommonActionConfigurationsFragmentDoc}`;

export function useSetActionFrequencyMutation() {
  return Urql.useMutation<SetActionFrequencyMutation, SetActionFrequencyMutationVariables>(SetActionFrequencyDocument);
};
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($id: ID!) {
  ncUnsubscribe(id: $id)
}
    `;

export function useUnsubscribeMutation() {
  return Urql.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument);
};
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($id: ID!) {
  ncConfirmEmail(id: $id)
}
    `;

export function useConfirmEmailMutation() {
  return Urql.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument);
};
export const ServiceNowHooksForTenantDocument = gql`
    query serviceNowHooksForTenant($id: ID!) {
  tenant(id: $id) {
    id
    serviceNowWebhooks {
      ...ServiceNowHookPage
    }
  }
}
    ${ServiceNowHookPageFragmentDoc}`;

export function useServiceNowHooksForTenantQuery(options: Omit<Urql.UseQueryArgs<ServiceNowHooksForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ServiceNowHooksForTenantQuery>({ query: ServiceNowHooksForTenantDocument, ...options });
};
export const GetServiceNowHookDocument = gql`
    query getServiceNowHook($id: ID!) {
  ncServiceNow {
    webhook(id: $id) {
      ...ServiceNowHookPage
    }
  }
}
    ${ServiceNowHookPageFragmentDoc}`;

export function useGetServiceNowHookQuery(options: Omit<Urql.UseQueryArgs<GetServiceNowHookQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetServiceNowHookQuery>({ query: GetServiceNowHookDocument, ...options });
};
export const CreateServiceNowWebhookForTenantDocument = gql`
    mutation CreateServiceNowWebhookForTenant($tenantId: ID!, $input: CreateServiceNowInput!) {
  ncCreateServiceNowWebhook(input: $input, tenantId: $tenantId) {
    ...ServiceNowHookPage
  }
}
    ${ServiceNowHookPageFragmentDoc}`;

export function useCreateServiceNowWebhookForTenantMutation() {
  return Urql.useMutation<CreateServiceNowWebhookForTenantMutation, CreateServiceNowWebhookForTenantMutationVariables>(CreateServiceNowWebhookForTenantDocument);
};
export const EnableServiceNowHookDocument = gql`
    mutation enableServiceNowHook($id: ID!) {
  ncEnableServiceNowWebhook(id: $id) {
    id
    enabled
  }
}
    `;

export function useEnableServiceNowHookMutation() {
  return Urql.useMutation<EnableServiceNowHookMutation, EnableServiceNowHookMutationVariables>(EnableServiceNowHookDocument);
};
export const DisableServiceNowHookDocument = gql`
    mutation disableServiceNowHook($id: ID!) {
  ncDisableServiceNowWebhook(id: $id) {
    id
    enabled
  }
}
    `;

export function useDisableServiceNowHookMutation() {
  return Urql.useMutation<DisableServiceNowHookMutation, DisableServiceNowHookMutationVariables>(DisableServiceNowHookDocument);
};
export const UpdateServiceNowWebhookDocument = gql`
    mutation updateServiceNowWebhook($id: ID!, $input: UpdateServiceNowWebhook!) {
  ncUpdateServiceNowWebhook(id: $id, input: $input) {
    ...ServiceNowHookPage
  }
}
    ${ServiceNowHookPageFragmentDoc}`;

export function useUpdateServiceNowWebhookMutation() {
  return Urql.useMutation<UpdateServiceNowWebhookMutation, UpdateServiceNowWebhookMutationVariables>(UpdateServiceNowWebhookDocument);
};
export const DeleteServiceNowWebhookDocument = gql`
    mutation deleteServiceNowWebhook($id: ID!) {
  ncDeleteServiceNowWebhook(id: $id) {
    serviceNowWebhooks {
      ...ServiceNowHookPage
    }
  }
}
    ${ServiceNowHookPageFragmentDoc}`;

export function useDeleteServiceNowWebhookMutation() {
  return Urql.useMutation<DeleteServiceNowWebhookMutation, DeleteServiceNowWebhookMutationVariables>(DeleteServiceNowWebhookDocument);
};
export const TestNewServiceNowWebhookDocument = gql`
    mutation testNewServiceNowWebhook($tenantId: ID!, $password: String!, $url: URL!, $username: String!) {
  ncTestServiceNowWebhookWithParams(input: {password: $password, url: $url, username: $username}, tenantId: $tenantId) {
    statusCode
    body
    statusMessage
  }
}
    `;

export function useTestNewServiceNowWebhookMutation() {
  return Urql.useMutation<TestNewServiceNowWebhookMutation, TestNewServiceNowWebhookMutationVariables>(TestNewServiceNowWebhookDocument);
};
export const TestServiceNowWebhookByIdDocument = gql`
    mutation testServiceNowWebhookById($id: ID!) {
  ncTestServiceNowWebhook(input: {id: $id}) {
    statusCode
    body
    statusMessage
  }
}
    `;

export function useTestServiceNowWebhookByIdMutation() {
  return Urql.useMutation<TestServiceNowWebhookByIdMutation, TestServiceNowWebhookByIdMutationVariables>(TestServiceNowWebhookByIdDocument);
};
export const UpdateServiceNowActionConfigurationDocument = gql`
    mutation updateServiceNowActionConfiguration($input: NcUpdateServiceNowWebhookAction!) {
  ncUpdateServiceNowActionConfiguration(input: $input) {
    id
    enabled
    rate
  }
}
    `;

export function useUpdateServiceNowActionConfigurationMutation() {
  return Urql.useMutation<UpdateServiceNowActionConfigurationMutation, UpdateServiceNowActionConfigurationMutationVariables>(UpdateServiceNowActionConfigurationDocument);
};
export const CreateTeamsWebhookForTenantDocument = gql`
    mutation CreateTeamsWebhookForTenant($tenantId: ID!, $input: CreateWebhook) {
  ncCreateTeamsWebhookForTenant(tenantId: $tenantId, input: $input) {
    ...TeamsHookPage
  }
}
    ${TeamsHookPageFragmentDoc}`;

export function useCreateTeamsWebhookForTenantMutation() {
  return Urql.useMutation<CreateTeamsWebhookForTenantMutation, CreateTeamsWebhookForTenantMutationVariables>(CreateTeamsWebhookForTenantDocument);
};
export const EnableTeamsHookDocument = gql`
    mutation enableTeamsHook($id: ID!) {
  ncEnableTeamsWebhook(id: $id) {
    id
    enabled
  }
}
    `;

export function useEnableTeamsHookMutation() {
  return Urql.useMutation<EnableTeamsHookMutation, EnableTeamsHookMutationVariables>(EnableTeamsHookDocument);
};
export const DisableTeamsHookDocument = gql`
    mutation disableTeamsHook($id: ID!) {
  ncDisableTeamsWebhook(id: $id) {
    id
    enabled
  }
}
    `;

export function useDisableTeamsHookMutation() {
  return Urql.useMutation<DisableTeamsHookMutation, DisableTeamsHookMutationVariables>(DisableTeamsHookDocument);
};
export const UpdateTeamsWebhookDocument = gql`
    mutation updateTeamsWebhook($id: ID!, $input: CreateWebhook!) {
  ncUpdateTeamsWebhook(id: $id, input: $input) {
    ...TeamsHookPage
  }
}
    ${TeamsHookPageFragmentDoc}`;

export function useUpdateTeamsWebhookMutation() {
  return Urql.useMutation<UpdateTeamsWebhookMutation, UpdateTeamsWebhookMutationVariables>(UpdateTeamsWebhookDocument);
};
export const DeleteTeamsWebhookDocument = gql`
    mutation deleteTeamsWebhook($id: ID!) {
  ncDeleteTeamsWebhook(id: $id) {
    teamsWebhooks {
      ...TeamsHookPage
    }
  }
}
    ${TeamsHookPageFragmentDoc}`;

export function useDeleteTeamsWebhookMutation() {
  return Urql.useMutation<DeleteTeamsWebhookMutation, DeleteTeamsWebhookMutationVariables>(DeleteTeamsWebhookDocument);
};
export const UpdateTeamsActionConfigurationDocument = gql`
    mutation updateTeamsActionConfiguration($input: NcUpdateTeamsWebhookAction!) {
  ncUpdateWebhookActionConfiguration(input: $input) {
    id
    enabled
    rate
  }
}
    `;

export function useUpdateTeamsActionConfigurationMutation() {
  return Urql.useMutation<UpdateTeamsActionConfigurationMutation, UpdateTeamsActionConfigurationMutationVariables>(UpdateTeamsActionConfigurationDocument);
};
export const TestTeamsWebhookByIdDocument = gql`
    mutation testTeamsWebhookById($id: ID, $url: URL) {
  ncTestTeamsWebhook(input: {id: $id, url: $url}) {
    success
    code
    message
  }
}
    `;

export function useTestTeamsWebhookByIdMutation() {
  return Urql.useMutation<TestTeamsWebhookByIdMutation, TestTeamsWebhookByIdMutationVariables>(TestTeamsWebhookByIdDocument);
};
export const GetTeamsHookDocument = gql`
    query getTeamsHook($id: ID!) {
  ncTeams {
    webhook(id: $id) {
      ...TeamsHookPage
    }
  }
}
    ${TeamsHookPageFragmentDoc}`;

export function useGetTeamsHookQuery(options: Omit<Urql.UseQueryArgs<GetTeamsHookQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetTeamsHookQuery>({ query: GetTeamsHookDocument, ...options });
};
export const TeamsHooksForTenantDocument = gql`
    query teamsHooksForTenant($id: ID!) {
  tenant(id: $id) {
    id
    teamsWebhooks {
      ...TeamsHookPage
    }
  }
}
    ${TeamsHookPageFragmentDoc}`;

export function useTeamsHooksForTenantQuery(options: Omit<Urql.UseQueryArgs<TeamsHooksForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TeamsHooksForTenantQuery>({ query: TeamsHooksForTenantDocument, ...options });
};
export const AvailableRelaySoftwareOvaDocument = gql`
    query availableRelaySoftwareOVA($releaseChannel: String) {
  availableProductSoftwareByPid(pid: "lens-relay-image-ova", releaseChannel: $releaseChannel) {
    productBuild {
      build
      archiveUrl
      tags {
        name
        value
      }
    }
    product {
      id
    }
    id
  }
}
    `;

export function useAvailableRelaySoftwareOvaQuery(options: Omit<Urql.UseQueryArgs<AvailableRelaySoftwareOvaQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AvailableRelaySoftwareOvaQuery>({ query: AvailableRelaySoftwareOvaDocument, ...options });
};
export const AvailableRelaySoftwareVhdDocument = gql`
    query availableRelaySoftwareVHD($releaseChannel: String) {
  availableProductSoftwareByPid(pid: "lens-relay-image-vhd", releaseChannel: $releaseChannel) {
    productBuild {
      build
      archiveUrl
      tags {
        name
        value
      }
    }
    product {
      id
    }
    id
  }
}
    `;

export function useAvailableRelaySoftwareVhdQuery(options: Omit<Urql.UseQueryArgs<AvailableRelaySoftwareVhdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AvailableRelaySoftwareVhdQuery>({ query: AvailableRelaySoftwareVhdDocument, ...options });
};
export const CreateRegisteredEdgeDeviceDocument = gql`
    mutation createRegisteredEdgeDevice($device: CreateRegisteredDeviceRequest!) {
  createRegisteredEdgeDevice(device: $device) {
    success
    error
    isEdgeDevice
    deviceId
    deviceKey
  }
}
    `;

export function useCreateRegisteredEdgeDeviceMutation() {
  return Urql.useMutation<CreateRegisteredEdgeDeviceMutation, CreateRegisteredEdgeDeviceMutationVariables>(CreateRegisteredEdgeDeviceDocument);
};
export const ProvisioningAccountsDocument = gql`
    query ProvisioningAccounts($tenantUuid: String) {
  getProvisioningAccounts(tenantUuid: $tenantUuid) {
    ...AccountDetail
  }
}
    ${AccountDetailFragmentDoc}`;

export function useProvisioningAccountsQuery(options: Omit<Urql.UseQueryArgs<ProvisioningAccountsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ProvisioningAccountsQuery>({ query: ProvisioningAccountsDocument, ...options });
};
export const UpdateProvisioningAccountDocument = gql`
    mutation updateProvisioningAccount($tenantUuid: String, $account: ProvisioningAccountIn) {
  updateProvisioningAccount(tenantUuid: $tenantUuid, account: $account) {
    ...AccountDetail
  }
}
    ${AccountDetailFragmentDoc}`;

export function useUpdateProvisioningAccountMutation() {
  return Urql.useMutation<UpdateProvisioningAccountMutation, UpdateProvisioningAccountMutationVariables>(UpdateProvisioningAccountDocument);
};
export const ConfigurationDocument = gql`
    query Configuration {
  getConfiguration {
    tenantSyncPeriod
  }
}
    `;

export function useConfigurationQuery(options: Omit<Urql.UseQueryArgs<ConfigurationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ConfigurationQuery>({ query: ConfigurationDocument, ...options });
};
export const TenantUserPermisionsDocument = gql`
    query TenantUserPermisions($userId: ID!, $tags: [String!]) {
  accessor(accessorId: $userId) {
    grants {
      ...PermisionsGrants
    }
  }
  roles(tags: $tags) {
    ...PermisionRoles
  }
}
    ${PermisionsGrantsFragmentDoc}
${PermisionRolesFragmentDoc}`;

export function useTenantUserPermisionsQuery(options: Omit<Urql.UseQueryArgs<TenantUserPermisionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantUserPermisionsQuery>({ query: TenantUserPermisionsDocument, ...options });
};
export const DevicesForTenantDocument = gql`
    query DevicesForTenant($tenantId: String!) {
  deviceCount: countDevices(filter: {eq: $tenantId, field: "tenantId"})
  models: deviceAggregations(aggregations: [{term: "hardwareModel"}], filter: {eq: $tenantId, field: "tenantId"}) {
    field
    buckets {
      __typename
      count
      ... on KeyBucket {
        key
      }
    }
  }
}
    `;

export function useDevicesForTenantQuery(options: Omit<Urql.UseQueryArgs<DevicesForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DevicesForTenantQuery>({ query: DevicesForTenantDocument, ...options });
};
export const SitesForTenantDocument = gql`
    query SitesForTenant($tenantId: String!) {
  sites(tenantId: $tenantId) {
    ...SiteForTenant
  }
}
    ${SiteForTenantFragmentDoc}`;

export function useSitesForTenantQuery(options: Omit<Urql.UseQueryArgs<SitesForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SitesForTenantQuery>({ query: SitesForTenantDocument, ...options });
};
export const UsersForTenantByRoleDocument = gql`
    query UsersForTenantByRole($params: UserSearchParams!) {
  users(params: $params) {
    count
  }
}
    `;

export function useUsersForTenantByRoleQuery(options: Omit<Urql.UseQueryArgs<UsersForTenantByRoleQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UsersForTenantByRoleQuery>({ query: UsersForTenantByRoleDocument, ...options });
};
export const DevicesAtSiteDocument = gql`
    query DevicesAtSite($siteId: String!) {
  count: countDevices(filter: {eq: $siteId, field: "siteUUID"})
}
    `;

export function useDevicesAtSiteQuery(options: Omit<Urql.UseQueryArgs<DevicesAtSiteQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DevicesAtSiteQuery>({ query: DevicesAtSiteDocument, ...options });
};
export const ImportDocument = gql`
    mutation Import($fileName: String!, $file: String!, $tenantId: String!, $importType: String!, $updateExistingDevices: Boolean, $overwriteDeviceRecords: Boolean) {
  importToLens(fileName: $fileName, file: $file, tenantId: $tenantId, importType: $importType, updateExistingDevices: $updateExistingDevices, overwriteDeviceRecords: $overwriteDeviceRecords)
}
    `;

export function useImportMutation() {
  return Urql.useMutation<ImportMutation, ImportMutationVariables>(ImportDocument);
};
export const GetImportReportDocument = gql`
    query GetImportReport($tenantId: String!) {
  getImportReport(tenantId: $tenantId) {
    progress
    success
    errors
    deviceConfigResult {
      deviceId
      deviceModel
      deviceReport
    }
    siteTopologyResult {
      siteName
      siteTopologyErrors
    }
    siteConfigResult {
      __typename
      siteConfigError
      siteName
      siteConfigSettings {
        deviceModel
        configAttributes
      }
      siteConfigError
    }
    groupConfigResult {
      __typename
      groupName
      groupConfigSettings {
        deviceModel
        configAttributes
      }
    }
    globalConfigResult {
      deviceModel
      globalConfigSettings
    }
  }
}
    `;

export function useGetImportReportQuery(options: Omit<Urql.UseQueryArgs<GetImportReportQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetImportReportQuery>({ query: GetImportReportDocument, ...options });
};
export const UpdateUserInfoDocument = gql`
    mutation UpdateUserInfo($id: ID!, $user: Auth0UserUpdateData!) {
  updateUser(id: $id, data: $user) {
    user {
      user_id
    }
  }
}
    `;

export function useUpdateUserInfoMutation() {
  return Urql.useMutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>(UpdateUserInfoDocument);
};
export const GetTrialSubscriptionDocument = gql`
    query GetTrialSubscription {
  getTrialSubscription: getClaritiTrialSubscription {
    ...TrialUserSubscriptionData
  }
}
    ${TrialUserSubscriptionDataFragmentDoc}`;

export function useGetTrialSubscriptionQuery(options: Omit<Urql.UseQueryArgs<GetTrialSubscriptionQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetTrialSubscriptionQuery>({ query: GetTrialSubscriptionDocument, ...options });
};
export const CreateTrialSubscriptionDocument = gql`
    mutation CreateTrialSubscription {
  createTrialSubscription: createClaritiTrialSubscription {
    ...TrialUserSubscriptionData
  }
}
    ${TrialUserSubscriptionDataFragmentDoc}`;

export function useCreateTrialSubscriptionMutation() {
  return Urql.useMutation<CreateTrialSubscriptionMutation, CreateTrialSubscriptionMutationVariables>(CreateTrialSubscriptionDocument);
};
export const GetTrialSubscriptionListDocument = gql`
    query GetTrialSubscriptionList($params: ClaritiTrialSubscriptionReportConnectionParams!) {
  getTrialSubscriptions: getClaritiTrialSubscriptionReports(params: $params) {
    ...TrialSubscriptionReportDataConnection
  }
}
    ${TrialSubscriptionReportDataConnectionFragmentDoc}`;

export function useGetTrialSubscriptionListQuery(options: Omit<Urql.UseQueryArgs<GetTrialSubscriptionListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetTrialSubscriptionListQuery>({ query: GetTrialSubscriptionListDocument, ...options });
};
export const DeleteTrialSubscriptionDocument = gql`
    mutation DeleteTrialSubscription($id: ID!) {
  deleteTrialSubscription: deleteClaritiTrialSubscriptionReport(id: $id) {
    id
  }
}
    `;

export function useDeleteTrialSubscriptionMutation() {
  return Urql.useMutation<DeleteTrialSubscriptionMutation, DeleteTrialSubscriptionMutationVariables>(DeleteTrialSubscriptionDocument);
};
export const CreateTenantDocument = gql`
    mutation createTenant($input: CreateTenantInput!) {
  createTenant(input: $input) {
    tenant {
      id
      name
    }
  }
}
    `;

export function useCreateTenantMutation() {
  return Urql.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument);
};
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $data: Auth0UserUpdateData!) {
  updateUser(id: $id, data: $data) {
    user {
      given_name
      family_name
      user_id
      name
    }
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const AvailableProductSoftwareByPidDocument = gql`
    query availableProductSoftwareByPid($pidWindows: ID!, $pidMac: ID!) {
  windows: availableProductSoftwareByPid(pid: $pidWindows) {
    productBuild {
      version
      build
      archiveUrl
    }
    id
    releaseChannel
    publishDate
  }
  mac: availableProductSoftwareByPid(pid: $pidMac) {
    productBuild {
      version
      build
      archiveUrl
    }
    id
    releaseChannel
    publishDate
  }
}
    `;

export function useAvailableProductSoftwareByPidQuery(options: Omit<Urql.UseQueryArgs<AvailableProductSoftwareByPidQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AvailableProductSoftwareByPidQuery>({ query: AvailableProductSoftwareByPidDocument, ...options });
};
export const DeviceCountsDocument = gql`
    query DeviceCounts($filter: Filter, $aggregations: [Aggregation]) {
  deviceAggregations(filter: $filter, aggregations: $aggregations) {
    ...AggregateFields
    buckets {
      __typename
      aggregates {
        ...AggregateFields
      }
    }
  }
}
    ${AggregateFieldsFragmentDoc}`;

export function useDeviceCountsQuery(options: Omit<Urql.UseQueryArgs<DeviceCountsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceCountsQuery>({ query: DeviceCountsDocument, ...options });
};
export const TopicsDocument = gql`
    query Topics {
  topics {
    id
    category
    validLocationScopes
  }
}
    `;

export function useTopicsQuery(options: Omit<Urql.UseQueryArgs<TopicsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TopicsQuery>({ query: TopicsDocument, ...options });
};
export const ChartsDocument = gql`
    query charts($tenantId: [String!]!, $locationScope: LocationScope!, $timeScope: TimeScope!, $timeStart: Date!, $topic: ID!, $id: ID!) {
  charts(tenantId: $tenantId, locationScope: $locationScope, timeScope: $timeScope, timeStart: $timeStart, topic: $topic, id: $id) {
    ...chartFields
  }
}
    ${ChartFieldsFragmentDoc}`;

export function useChartsQuery(options: Omit<Urql.UseQueryArgs<ChartsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ChartsQuery>({ query: ChartsDocument, ...options });
};
export const NodeDetailsDocument = gql`
    query nodeDetails($id: ID!, $tenant: [String!]!) {
  nodeDetail: node(id: $id, tenantId: $tenant) {
    __typename
    id
    ... on TopicIndicator {
      ...insightDetails
    }
  }
}
    ${InsightDetailsFragmentDoc}`;

export function useNodeDetailsQuery(options: Omit<Urql.UseQueryArgs<NodeDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NodeDetailsQuery>({ query: NodeDetailsDocument, ...options });
};
export const SimilarTopicIndicatorsDocument = gql`
    query similarTopicIndicators($tenant: [String!]!, $input: QueryTopicIndicatorInput) {
  similar: topicIndicators(tenantId: $tenant, input: $input) {
    edges {
      node {
        ...similarInsights
      }
    }
  }
}
    ${SimilarInsightsFragmentDoc}`;

export function useSimilarTopicIndicatorsQuery(options: Omit<Urql.UseQueryArgs<SimilarTopicIndicatorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SimilarTopicIndicatorsQuery>({ query: SimilarTopicIndicatorsDocument, ...options });
};
export const InsightsPriorityDocument = gql`
    query insightsPriority($tenant: [String!]!, $input: QueryTopicIndicatorInput!, $after: String, $first: Int) {
  topicIndicators(tenantId: $tenant, input: $input, after: $after, first: $first) {
    count
    ...PaginatedIndicators
  }
}
    ${PaginatedIndicatorsFragmentDoc}`;

export function useInsightsPriorityQuery(options: Omit<Urql.UseQueryArgs<InsightsPriorityQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InsightsPriorityQuery>({ query: InsightsPriorityDocument, ...options });
};
export const InsightsCategoryDocument = gql`
    query insightsCategory($tenant: [String!]!, $input: QueryTopicIndicatorInput!, $after: String, $first: Int) {
  topicIndicators(tenantId: $tenant, input: $input, after: $after, first: $first) {
    ...PaginatedIndicators
  }
}
    ${PaginatedIndicatorsFragmentDoc}`;

export function useInsightsCategoryQuery(options: Omit<Urql.UseQueryArgs<InsightsCategoryQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InsightsCategoryQuery>({ query: InsightsCategoryDocument, ...options });
};
export const InsightsDetailsDocument = gql`
    query insightsDetails($tenant: [String!]!, $input: QueryTopicIndicatorInput!, $similar: QueryTopicIndicatorInput!) {
  myInsight: topicIndicators(input: $input, tenantId: $tenant) {
    pageInfo {
      ...ContinuingPage
    }
    edges {
      cursor
      node {
        ...PriorityFields
      }
    }
  }
  similarInsights: topicIndicators(input: $similar, first: 3, tenantId: $tenant) {
    edges {
      node {
        ...PriorityFields
      }
    }
  }
}
    ${ContinuingPageFragmentDoc}
${PriorityFieldsFragmentDoc}`;

export function useInsightsDetailsQuery(options: Omit<Urql.UseQueryArgs<InsightsDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InsightsDetailsQuery>({ query: InsightsDetailsDocument, ...options });
};
export const InsightsDeviceActionDocument = gql`
    query insightsDeviceAction($offlineFilter: Filter, $availableUpdatesFilter: Filter, $siteUnassignedFilter: Filter, $showOfflineDevices: Boolean!, $showAvailableUpdates: Boolean!, $showUnassignedSite: Boolean!) {
  offlineDevices: deviceAggregations(aggregations: {term: "hardwareModel", SUB: [{term: "site"}]}, filter: $offlineFilter) @include(if: $showOfflineDevices) {
    __typename
    field
    buckets {
      modelCount: count
      __typename
      ... on KeyBucket {
        model: key
      }
      sites: aggregates {
        ...SiteBucket
      }
    }
  }
  availableUpdates: deviceAggregations(aggregations: {term: "hardwareModel", SUB: [{term: "updateVersion", SUB: [{term: "site"}]}]}, filter: $availableUpdatesFilter) @include(if: $showAvailableUpdates) {
    __typename
    field
    buckets {
      modelCount: count
      __typename
      ... on KeyBucket {
        model: key
      }
      updateVersions: aggregates {
        ...VersionBucket
      }
    }
  }
  siteUnassigned: deviceAggregations(aggregations: {term: "hardwareModel"}, filter: $siteUnassignedFilter) @include(if: $showUnassignedSite) {
    __typename
    field
    buckets {
      modelCount: count
      __typename
      ... on KeyBucket {
        model: key
      }
    }
  }
}
    ${SiteBucketFragmentDoc}
${VersionBucketFragmentDoc}`;

export function useInsightsDeviceActionQuery(options: Omit<Urql.UseQueryArgs<InsightsDeviceActionQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InsightsDeviceActionQuery>({ query: InsightsDeviceActionDocument, ...options });
};
export const DeviceGroupsDocument = gql`
    query DeviceGroups($tenantId: String!) {
  getAllGroups(tenantId: $tenantId) {
    groups {
      groups {
        ...Group
      }
    }
  }
}
    ${GroupFragmentDoc}`;

export function useDeviceGroupsQuery(options: Omit<Urql.UseQueryArgs<DeviceGroupsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceGroupsQuery>({ query: DeviceGroupsDocument, ...options });
};
export const DeviceGroupDocument = gql`
    query DeviceGroup($id: String!) {
  readGroup(groupId: $id) {
    groupDoc {
      ...Group
    }
  }
}
    ${GroupFragmentDoc}`;

export function useDeviceGroupQuery(options: Omit<Urql.UseQueryArgs<DeviceGroupQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceGroupQuery>({ query: DeviceGroupDocument, ...options });
};
export const GroupsForDeviceDocument = gql`
    query GroupsForDevice($serial: String!, $tenantId: String) {
  getDevice(serial: $serial, tenantId: $tenantId) {
    groups
  }
}
    `;

export function useGroupsForDeviceQuery(options: Omit<Urql.UseQueryArgs<GroupsForDeviceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GroupsForDeviceQuery>({ query: GroupsForDeviceDocument, ...options });
};
export const CreateDeviceGroupDocument = gql`
    mutation CreateDeviceGroup($createSWPolicy: Boolean, $devices: Devices, $groupName: String!, $tenantId: String!) {
  createGroup(createSWPolicy: $createSWPolicy, devices: $devices, groupName: $groupName, tenantId: $tenantId) {
    success
    error
    groupDoc {
      id
    }
  }
}
    `;

export function useCreateDeviceGroupMutation() {
  return Urql.useMutation<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>(CreateDeviceGroupDocument);
};
export const DeleteDeviceGroupsDocument = gql`
    mutation DeleteDeviceGroups($groups: Groups!) {
  deleteGroups(groupIds: $groups) {
    success
    error
  }
}
    `;

export function useDeleteDeviceGroupsMutation() {
  return Urql.useMutation<DeleteDeviceGroupsMutation, DeleteDeviceGroupsMutationVariables>(DeleteDeviceGroupsDocument);
};
export const UpdateDeviceGroupDocument = gql`
    mutation UpdateDeviceGroup($groupId: String!, $groupName: String, $devices: Devices, $createSWPolicy: Boolean) {
  updateGroup(groupId: $groupId, groupName: $groupName, devices: $devices, createSWPolicy: $createSWPolicy) {
    success
    error
  }
}
    `;

export function useUpdateDeviceGroupMutation() {
  return Urql.useMutation<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>(UpdateDeviceGroupDocument);
};
export const UpdateDeviceGroupPriorityDocument = gql`
    mutation updateDeviceGroupPriority($serial: String!, $groups: [String], $tenantId: String) {
  updateDeviceGroupPriority(serial: $serial, groups: $groups, tenantId: $tenantId)
}
    `;

export function useUpdateDeviceGroupPriorityMutation() {
  return Urql.useMutation<UpdateDeviceGroupPriorityMutation, UpdateDeviceGroupPriorityMutationVariables>(UpdateDeviceGroupPriorityDocument);
};
export const RebootDevicesByGroupDocument = gql`
    mutation RebootDevicesByGroup($groupId: String!) {
  rebootGroup(groupId: $groupId) {
    success
    error
  }
}
    `;

export function useRebootDevicesByGroupMutation() {
  return Urql.useMutation<RebootDevicesByGroupMutation, RebootDevicesByGroupMutationVariables>(RebootDevicesByGroupDocument);
};
export const SaveUserGroupDocument = gql`
    mutation saveUserGroup($tenantId: String!, $body: UserGroupBody!) {
  saveUserGroup(tenantId: $tenantId, body: $body) {
    name
    id
    createdAt
    updatedAt
    description
    source
    policies {
      priority
      id
    }
    genericUsers {
      __typename
      ... on GenericUserList {
        items {
          user {
            user {
              user_id
            }
          }
        }
      }
      ... on GenericUserMessage {
        value
      }
    }
  }
}
    `;

export function useSaveUserGroupMutation() {
  return Urql.useMutation<SaveUserGroupMutation, SaveUserGroupMutationVariables>(SaveUserGroupDocument);
};
export const ListUserGroupsForTenantDocument = gql`
    query listUserGroupsForTenant($tenantId: String!) {
  userGroupsForTenant(tenantId: $tenantId) {
    id
    name
    description
    createdAt
    updatedAt
    source
    policies {
      priority
      id
      name
    }
    genericUsers {
      __typename
      ... on GenericUserList {
        items {
          user {
            user {
              user_id
            }
          }
        }
      }
      ... on GenericUserMessage {
        value
      }
    }
  }
}
    `;

export function useListUserGroupsForTenantQuery(options: Omit<Urql.UseQueryArgs<ListUserGroupsForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ListUserGroupsForTenantQuery>({ query: ListUserGroupsForTenantDocument, ...options });
};
export const MutateUserGroupMembershipDocument = gql`
    mutation mutateUserGroupMembership($tenantId: String!, $groupId: String!, $newUsers: [String!]!, $removedUsers: [String!]!) {
  mutateUserGroupMembership(tenantId: $tenantId, groupId: $groupId, newUsers: $newUsers, removedUsers: $removedUsers) {
    name
    id
  }
}
    `;

export function useMutateUserGroupMembershipMutation() {
  return Urql.useMutation<MutateUserGroupMembershipMutation, MutateUserGroupMembershipMutationVariables>(MutateUserGroupMembershipDocument);
};
export const DeleteUserGroupDocument = gql`
    mutation deleteUserGroup($tenantId: String!, $id: String!) {
  deleteUserGroup(tenantId: $tenantId, id: $id) {
    error
    message
  }
}
    `;

export function useDeleteUserGroupMutation() {
  return Urql.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument);
};
export const GetUserGroupDetailsDocument = gql`
    query getUserGroupDetails($id: String!, $tenantId: String!) {
  userGroupsForTenant(groupIds: [$id], tenantId: $tenantId) {
    id
    name
    description
    createdAt
    updatedAt
    source
    genericUsers {
      __typename
      ... on GenericUserList {
        items {
          name
          id
          email
          user {
            user {
              ...DeviceUserInfo
            }
          }
        }
      }
      ... on GenericUserMessage {
        value
      }
    }
  }
}
    ${DeviceUserInfoFragmentDoc}`;

export function useGetUserGroupDetailsQuery(options: Omit<Urql.UseQueryArgs<GetUserGroupDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetUserGroupDetailsQuery>({ query: GetUserGroupDetailsDocument, ...options });
};
export const UpdatePolicyPriorityDocument = gql`
    mutation updatePolicyPriority($id: String!, $priority: String!) {
  updatePolicyCapabilities(input: {id: $id, priority: $priority}) {
    id
    priority
  }
}
    `;

export function useUpdatePolicyPriorityMutation() {
  return Urql.useMutation<UpdatePolicyPriorityMutation, UpdatePolicyPriorityMutationVariables>(UpdatePolicyPriorityDocument);
};
export const AvailableExternalUserGroupsDocument = gql`
    query availableExternalUserGroups($tenantId: String!, $source: UserGroupSourceType!) {
  userGroupsForTenant(tenantId: $tenantId, source: $source, state: NOT_IMPORTED) {
    id
    name
    description
    source
  }
}
    `;

export function useAvailableExternalUserGroupsQuery(options: Omit<Urql.UseQueryArgs<AvailableExternalUserGroupsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AvailableExternalUserGroupsQuery>({ query: AvailableExternalUserGroupsDocument, ...options });
};
export const UsersForExternalGroupsDocument = gql`
    query usersForExternalGroups($tenantId: String!, $source: UserGroupSourceType!, $groupIds: [String!]!) {
  userGroupsForTenant(tenantId: $tenantId, groupIds: $groupIds, source: $source, state: NOT_IMPORTED) {
    genericUsers {
      __typename
      ... on GenericUserList {
        items {
          email
          name
          id
          user {
            user {
              user_id
              name
            }
          }
        }
      }
      ... on GenericUserMessage {
        value
      }
    }
  }
}
    `;

export function useUsersForExternalGroupsQuery(options: Omit<Urql.UseQueryArgs<UsersForExternalGroupsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UsersForExternalGroupsQuery>({ query: UsersForExternalGroupsDocument, ...options });
};
export const ImportUserGroupsDocument = gql`
    mutation importUserGroups($tenantId: String!, $groups: [UserGroupBody!]!, $source: UserGroupSourceType!) {
  importUserGroups(tenantId: $tenantId, groups: $groups, source: $source) {
    id
  }
}
    `;

export function useImportUserGroupsMutation() {
  return Urql.useMutation<ImportUserGroupsMutation, ImportUserGroupsMutationVariables>(ImportUserGroupsDocument);
};
export const DeviceUsersCountDocument = gql`
    query DeviceUsersCount($params: UserSearchParams!, $after: Cursor, $first: Int) {
  deviceUsersResult: users(params: $params, after: $after, first: $first) {
    count
  }
}
    `;

export function useDeviceUsersCountQuery(options: Omit<Urql.UseQueryArgs<DeviceUsersCountQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceUsersCountQuery>({ query: DeviceUsersCountDocument, ...options });
};
export const DeviceUsersListDocument = gql`
    query DeviceUsersList($params: UserSearchParams!, $after: Cursor, $first: Int) {
  deviceUsersResult: users(params: $params, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      endCursor
    }
    deviceUsersInfo: edges {
      cursor
      node {
        ...DeviceUserInfo
      }
    }
  }
}
    ${DeviceUserInfoFragmentDoc}`;

export function useDeviceUsersListQuery(options: Omit<Urql.UseQueryArgs<DeviceUsersListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceUsersListQuery>({ query: DeviceUsersListDocument, ...options });
};
export const DeleteDeviceUserDocument = gql`
    mutation DeleteDeviceUser($accessorId: ID!, $resourceId: ID!) {
  revokeRole(accessorId: $accessorId, resourceId: $resourceId, role: "device_user") {
    grants {
      resourceId
      roles {
        name
      }
    }
  }
}
    `;

export function useDeleteDeviceUserMutation() {
  return Urql.useMutation<DeleteDeviceUserMutation, DeleteDeviceUserMutationVariables>(DeleteDeviceUserDocument);
};
export const AddDeviceUserDocument = gql`
    mutation AddDeviceUser($accessorId: ID!, $resourceId: ID!) {
  grantRole(accessorId: $accessorId, resourceId: $resourceId, resourceType: "Tenant", role: "device_user") {
    grants {
      resourceId
      roles {
        name
      }
    }
  }
}
    `;

export function useAddDeviceUserMutation() {
  return Urql.useMutation<AddDeviceUserMutation, AddDeviceUserMutationVariables>(AddDeviceUserDocument);
};
export const FirmwareUpdateInfoDocument = gql`
    query FirmwareUpdateInfo($id: String!) {
  firmwareUpdateInfo(id: $id) {
    updateVersion
    isUpdateAvailable
  }
}
    `;

export function useFirmwareUpdateInfoQuery(options: Omit<Urql.UseQueryArgs<FirmwareUpdateInfoQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FirmwareUpdateInfoQuery>({ query: FirmwareUpdateInfoDocument, ...options });
};
export const NetworkDiagnosticsDocument = gql`
    query NetworkDiagnostics($id: String!) {
  device(id: $id) {
    id
    name
    connected
    hardwareModel
    hardwareFamily
    softwareVersion
    hardwareRevision
    lastDetected
    ...NetworkDiagnostic
    site {
      name
    }
    product {
      updatedAt
      id
    }
  }
}
    ${NetworkDiagnosticFragmentDoc}`;

export function useNetworkDiagnosticsQuery(options: Omit<Urql.UseQueryArgs<NetworkDiagnosticsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NetworkDiagnosticsQuery>({ query: NetworkDiagnosticsDocument, ...options });
};
export const DeleteDevicesDocument = gql`
    mutation DeleteDevices($tenantId: String!, $serials: [String]) {
  deleteDevices(tenantId: $tenantId, serials: $serials)
}
    `;

export function useDeleteDevicesMutation() {
  return Urql.useMutation<DeleteDevicesMutation, DeleteDevicesMutationVariables>(DeleteDevicesDocument);
};
export const UnregisterDeviceDocument = gql`
    mutation UnregisterDevice($deviceId: String!) {
  unregisterDevice(deviceId: $deviceId) {
    success
    error
  }
}
    `;

export function useUnregisterDeviceMutation() {
  return Urql.useMutation<UnregisterDeviceMutation, UnregisterDeviceMutationVariables>(UnregisterDeviceDocument);
};
export const DevicesListDocument = gql`
    query DevicesList($filter: Filter, $limit: Int, $sort: DeviceSort, $from: Int!) {
  devices(filter: $filter, limit: $limit, sort: $sort, from: $from) {
    ...devicesCardProps
  }
  countDevices(filter: $filter)
}
    ${DevicesCardPropsFragmentDoc}`;

export function useDevicesListQuery(options: Omit<Urql.UseQueryArgs<DevicesListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DevicesListQuery>({ query: DevicesListDocument, ...options });
};
export const DevicesLocationDocument = gql`
    query DevicesLocation($aggregations: [Aggregation], $noLocationFilter: Filter, $boundsFilter: Filter, $sort: DeviceSort, $from: Int!) {
  unknownLocationCount: countDevices(filter: $noLocationFilter)
  deviceCount: countDevices(filter: $boundsFilter)
  deviceAggregations(aggregations: $aggregations, filter: $boundsFilter) {
    field
    buckets {
      __typename
      count
      ... on KeyBucket {
        key
      }
    }
  }
  deviceList: devices(filter: $boundsFilter, sort: $sort, from: $from, limit: 100) {
    ...devicesCardProps
  }
}
    ${DevicesCardPropsFragmentDoc}`;

export function useDevicesLocationQuery(options: Omit<Urql.UseQueryArgs<DevicesLocationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DevicesLocationQuery>({ query: DevicesLocationDocument, ...options });
};
export const StartCallDocument = gql`
    mutation StartCall($deviceId: String!, $dialString: String!, $options: CallOptions) {
  startCall(deviceId: $deviceId, dialString: $dialString, options: $options) {
    success
    error
  }
}
    `;

export function useStartCallMutation() {
  return Urql.useMutation<StartCallMutation, StartCallMutationVariables>(StartCallDocument);
};
export const EditDeviceDetailsDocument = gql`
    mutation EditDeviceDetails($fields: UpdateDeviceRequest!, $id: String!) {
  updateDevice(id: $id, fields: $fields) {
    ...device
  }
}
    ${DeviceFragmentDoc}`;

export function useEditDeviceDetailsMutation() {
  return Urql.useMutation<EditDeviceDetailsMutation, EditDeviceDetailsMutationVariables>(EditDeviceDetailsDocument);
};
export const ActiveEntitlementsBySerialDocument = gql`
    query ActiveEntitlementsBySerial($tenantId: String!, $productSerial: String!) {
  entitlements(tenantId: $tenantId, productSerials: [$productSerial], includeExpired: false) {
    edges {
      licenseKey
    }
  }
}
    `;

export function useActiveEntitlementsBySerialQuery(options: Omit<Urql.UseQueryArgs<ActiveEntitlementsBySerialQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ActiveEntitlementsBySerialQuery>({ query: ActiveEntitlementsBySerialDocument, ...options });
};
export const LinkedDevicesForDeviceDocument = gql`
    query LinkedDevicesForDevice($id: String!) {
  device(id: $id) {
    ...EntityConnections
  }
}
    ${EntityConnectionsFragmentDoc}`;

export function useLinkedDevicesForDeviceQuery(options: Omit<Urql.UseQueryArgs<LinkedDevicesForDeviceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LinkedDevicesForDeviceQuery>({ query: LinkedDevicesForDeviceDocument, ...options });
};
export const ExportDeviceInventoryDocument = gql`
    mutation ExportDeviceInventory($tenantId: String!) {
  exportDeviceInventory(tenantId: $tenantId) {
    success
    error
    link
    recipientEmail
  }
}
    `;

export function useExportDeviceInventoryMutation() {
  return Urql.useMutation<ExportDeviceInventoryMutation, ExportDeviceInventoryMutationVariables>(ExportDeviceInventoryDocument);
};
export const ExportDeviceSettingsDocument = gql`
    query ExportDeviceSettings($tenantId: String!) {
  exportDeviceSettings(tenantId: $tenantId)
}
    `;

export function useExportDeviceSettingsQuery(options: Omit<Urql.UseQueryArgs<ExportDeviceSettingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ExportDeviceSettingsQuery>({ query: ExportDeviceSettingsDocument, ...options });
};
export const CapabilitiesDocument = gql`
    query capabilities($deviceId: String!) {
  capabilities(deviceId: $deviceId) {
    id
  }
}
    `;

export function useCapabilitiesQuery(options: Omit<Urql.UseQueryArgs<CapabilitiesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CapabilitiesQuery>({ query: CapabilitiesDocument, ...options });
};
export const UpdateCapabilitiesDocument = gql`
    mutation updateCapabilities($deviceId: String!, $input: CapabilitiesInput!) {
  capabilitiesMutate(deviceId: $deviceId, input: $input) {
    com {
      poly {
        audio {
          bass {
            value
          }
        }
      }
    }
  }
}
    `;

export function useUpdateCapabilitiesMutation() {
  return Urql.useMutation<UpdateCapabilitiesMutation, UpdateCapabilitiesMutationVariables>(UpdateCapabilitiesDocument);
};
export const StartDeviceConfigExportDocument = gql`
    query startDeviceConfigExport($deviceId: String, $tenantId: String) {
  startExportDeviceConfigs(deviceId: $deviceId, tenantId: $tenantId) {
    status
    errorMessage
  }
}
    `;

export function useStartDeviceConfigExportQuery(options: Omit<Urql.UseQueryArgs<StartDeviceConfigExportQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StartDeviceConfigExportQuery>({ query: StartDeviceConfigExportDocument, ...options });
};
export const DeviceConfigDocument = gql`
    query DeviceConfig($deviceId: String, $deviceModel: String, $tenantId: String) {
  getExtendedConfigParams(deviceId: $deviceId, deviceModel: $deviceModel, tenantId: $tenantId) {
    status
    errorMessage
    configParams {
      ...DeviceConfigParam
    }
  }
}
    ${DeviceConfigParamFragmentDoc}`;

export function useDeviceConfigQuery(options: Omit<Urql.UseQueryArgs<DeviceConfigQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceConfigQuery>({ query: DeviceConfigDocument, ...options });
};
export const DeviceSettingsDocument = gql`
    query DeviceSettings($id: String!, $noCache: Boolean) {
  deviceSettings(id: $id, waitForDevice: $noCache) {
    id
    fetchedAt
    settings {
      ...networkSettings
      ...displaySettings
      ...calendarSettings
      ...callServerSettings
      ...upgradeSettings
      ...dateTimeSettings
    }
  }
}
    ${NetworkSettingsFragmentDoc}
${DisplaySettingsFragmentDoc}
${CalendarSettingsFragmentDoc}
${CallServerSettingsFragmentDoc}
${UpgradeSettingsFragmentDoc}
${DateTimeSettingsFragmentDoc}`;

export function useDeviceSettingsQuery(options: Omit<Urql.UseQueryArgs<DeviceSettingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceSettingsQuery>({ query: DeviceSettingsDocument, ...options });
};
export const DeviceSettingsAvailabilityDocument = gql`
    query DeviceSettingsAvailability($id: String!, $noCache: Boolean) {
  deviceSettings(disableError: true, id: $id, waitForDevice: $noCache) {
    fetchedAt
    settings {
      prov {
        enabled
      }
    }
  }
}
    `;

export function useDeviceSettingsAvailabilityQuery(options: Omit<Urql.UseQueryArgs<DeviceSettingsAvailabilityQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceSettingsAvailabilityQuery>({ query: DeviceSettingsAvailabilityDocument, ...options });
};
export const UpsertDeviceSettingsDocument = gql`
    mutation UpsertDeviceSettings($settings: PolyOSConfigInput!, $id: String!) {
  upsertDeviceSettings(settings: $settings, id: $id) {
    fetchedAt
  }
}
    `;

export function useUpsertDeviceSettingsMutation() {
  return Urql.useMutation<UpsertDeviceSettingsMutation, UpsertDeviceSettingsMutationVariables>(UpsertDeviceSettingsDocument);
};
export const DeviceSettingsAsXmlDocument = gql`
    query DeviceSettingsAsXML($id: String!, $waitForDevice: Boolean) {
  deviceSettingsAsXML(id: $id, waitForDevice: $waitForDevice) {
    id
    fetchedAt
    settings
  }
}
    `;

export function useDeviceSettingsAsXmlQuery(options: Omit<Urql.UseQueryArgs<DeviceSettingsAsXmlQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceSettingsAsXmlQuery>({ query: DeviceSettingsAsXmlDocument, ...options });
};
export const SetDeviceSettingsWithXmlDocument = gql`
    mutation SetDeviceSettingsWithXML($settingsXML: String!, $id: String!) {
  setDeviceSettingsWithXML(settingsXML: $settingsXML, id: $id) {
    fetchedAt
  }
}
    `;

export function useSetDeviceSettingsWithXmlMutation() {
  return Urql.useMutation<SetDeviceSettingsWithXmlMutation, SetDeviceSettingsWithXmlMutationVariables>(SetDeviceSettingsWithXmlDocument);
};
export const HardwareModelWithAvailableSoftwareDocument = gql`
    query hardwareModelWithAvailableSoftware($id: ID!) {
  hardwareModel(id: $id) {
    name
    hardwareProducts {
      id
      availableProductSoftware {
        version
        productBuild {
          version
          build
        }
      }
    }
  }
}
    `;

export function useHardwareModelWithAvailableSoftwareQuery(options: Omit<Urql.UseQueryArgs<HardwareModelWithAvailableSoftwareQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HardwareModelWithAvailableSoftwareQuery>({ query: HardwareModelWithAvailableSoftwareDocument, ...options });
};
export const NormalizedDeviceSettingsDocument = gql`
    query NormalizedDeviceSettings($id: String!) {
  normalizedDeviceSettings(id: $id) {
    id
    fetchedAt
    settings {
      name
      value
    }
  }
}
    `;

export function useNormalizedDeviceSettingsQuery(options: Omit<Urql.UseQueryArgs<NormalizedDeviceSettingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NormalizedDeviceSettingsQuery>({ query: NormalizedDeviceSettingsDocument, ...options });
};
export const UpsertNormalizedDeviceSettingsDocument = gql`
    mutation UpsertNormalizedDeviceSettings($id: String!, $settings: [NormalizedDeviceSettingInput!]!) {
  upsertNormalizedDeviceSettings(id: $id, settings: $settings) {
    id
    fetchedAt
    settings {
      name
      value
    }
  }
}
    `;

export function useUpsertNormalizedDeviceSettingsMutation() {
  return Urql.useMutation<UpsertNormalizedDeviceSettingsMutation, UpsertNormalizedDeviceSettingsMutationVariables>(UpsertNormalizedDeviceSettingsDocument);
};
export const PoliciesDocument = gql`
    query Policies($deviceModel: String, $deviceId: String, $siteId: String, $groupId: String, $scope: PolicyDeploymentScope, $tenantId: String) {
  getPolicies(deviceModel: $deviceModel, deviceId: $deviceId, siteId: $siteId, groupId: $groupId, policyScope: $scope, tenantId: $tenantId) {
    ...policy
  }
}
    ${PolicyFragmentDoc}`;

export function usePoliciesQuery(options: Omit<Urql.UseQueryArgs<PoliciesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PoliciesQuery>({ query: PoliciesDocument, ...options });
};
export const ExternalPolicyDocument = gql`
    query ExternalPolicy($deviceId: String, $tenantId: String) {
  getPolicies(deviceId: $deviceId, tenantId: $tenantId, policyScope: EXTERNAL_DEVICE) {
    ...ExternalPolicy
  }
}
    ${ExternalPolicyFragmentDoc}`;

export function useExternalPolicyQuery(options: Omit<Urql.UseQueryArgs<ExternalPolicyQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ExternalPolicyQuery>({ query: ExternalPolicyDocument, ...options });
};
export const CreatePolicyDocument = gql`
    mutation CreatePolicy($policy: PolicyInput, $taskExecuteTime: String, $tenantId: String) {
  createPolicy(policy: $policy, taskExecuteTime: $taskExecuteTime, tenantId: $tenantId)
}
    `;

export function useCreatePolicyMutation() {
  return Urql.useMutation<CreatePolicyMutation, CreatePolicyMutationVariables>(CreatePolicyDocument);
};
export const UpdatePolicyDocument = gql`
    mutation UpdatePolicy($policy: PolicyInput, $taskExecuteTime: String, $tenantId: String) {
  updatePolicy(policy: $policy, taskExecuteTime: $taskExecuteTime, tenantId: $tenantId) {
    ...policy
  }
}
    ${PolicyFragmentDoc}`;

export function useUpdatePolicyMutation() {
  return Urql.useMutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(UpdatePolicyDocument);
};
export const DeletePolicyDocument = gql`
    mutation DeletePolicy($policyId: String) {
  deletePolicyById(policyId: $policyId)
}
    `;

export function useDeletePolicyMutation() {
  return Urql.useMutation<DeletePolicyMutation, DeletePolicyMutationVariables>(DeletePolicyDocument);
};
export const DeletePoliciesDocument = gql`
    mutation DeletePolicies($policyIds: [String]) {
  deletePolicies(policyIds: $policyIds) {
    ids
  }
}
    `;

export function useDeletePoliciesMutation() {
  return Urql.useMutation<DeletePoliciesMutation, DeletePoliciesMutationVariables>(DeletePoliciesDocument);
};
export const DeletePoliciesForSitesDocument = gql`
    mutation DeletePoliciesForSites($siteIds: [String], $tenantId: String) {
  deletePoliciesBySiteId(siteIds: $siteIds, tenantId: $tenantId) {
    ids
  }
}
    `;

export function useDeletePoliciesForSitesMutation() {
  return Urql.useMutation<DeletePoliciesForSitesMutation, DeletePoliciesForSitesMutationVariables>(DeletePoliciesForSitesDocument);
};
export const DeviceParametersDocument = gql`
    query DeviceParameters($deviceId: String, $deviceModel: String, $siteId: String, $sendOnlyChanged: Boolean, $tenantId: String, $groupId: String) {
  getDeviceParametersExtended(tenantId: $tenantId, deviceId: $deviceId, deviceModel: $deviceModel, siteId: $siteId, groupId: $groupId, sendOnlyChanged: $sendOnlyChanged) {
    ...ExtendedDeviceParameter
  }
}
    ${ExtendedDeviceParameterFragmentDoc}`;

export function useDeviceParametersQuery(options: Omit<Urql.UseQueryArgs<DeviceParametersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceParametersQuery>({ query: DeviceParametersDocument, ...options });
};
export const ProvisioningSyncDocument = gql`
    mutation ProvisioningSync($deviceId: String!) {
  requestProvisioningSync(deviceId: $deviceId) {
    success
    error
  }
}
    `;

export function useProvisioningSyncMutation() {
  return Urql.useMutation<ProvisioningSyncMutation, ProvisioningSyncMutationVariables>(ProvisioningSyncDocument);
};
export const EpUpdateImagesDocument = gql`
    query EpUpdateImages($deviceModel: String, $isGlobal: Boolean) {
  getEpUpdateImages(deviceModel: $deviceModel, isGlobal: $isGlobal) {
    ...UpdateImage
  }
}
    ${UpdateImageFragmentDoc}`;

export function useEpUpdateImagesQuery(options: Omit<Urql.UseQueryArgs<EpUpdateImagesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<EpUpdateImagesQuery>({ query: EpUpdateImagesDocument, ...options });
};
export const DescribeCertificateDocument = gql`
    query describeCertificate($deviceId: String!) {
  describeCertificate(deviceId: $deviceId) {
    ...deviceCertificate
  }
}
    ${DeviceCertificateFragmentDoc}`;

export function useDescribeCertificateQuery(options: Omit<Urql.UseQueryArgs<DescribeCertificateQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DescribeCertificateQuery>({ query: DescribeCertificateDocument, ...options });
};
export const InstallCertificateDocument = gql`
    mutation InstallCertificate($deviceId: String!, $certificate: DeviceCertificate!) {
  installCertificate(deviceId: $deviceId, certificate: $certificate) {
    ...deviceCertificate
  }
}
    ${DeviceCertificateFragmentDoc}`;

export function useInstallCertificateMutation() {
  return Urql.useMutation<InstallCertificateMutation, InstallCertificateMutationVariables>(InstallCertificateDocument);
};
export const UninstallCertificateDocument = gql`
    mutation UninstallCertificate($deviceId: String!) {
  uninstallCertificate(deviceId: $deviceId) {
    success
    error
    deviceId
  }
}
    `;

export function useUninstallCertificateMutation() {
  return Urql.useMutation<UninstallCertificateMutation, UninstallCertificateMutationVariables>(UninstallCertificateDocument);
};
export const UpdateDeviceOsDocument = gql`
    mutation UpdateDeviceOS($deviceId: String!) {
  updateDeviceOS(deviceId: $deviceId) {
    success
    error
  }
}
    `;

export function useUpdateDeviceOsMutation() {
  return Urql.useMutation<UpdateDeviceOsMutation, UpdateDeviceOsMutationVariables>(UpdateDeviceOsDocument);
};
export const TenantRelayDevicesDocument = gql`
    query TenantRelayDevices($filter: Filter, $limit: Int, $sort: DeviceSort, $from: Int) {
  devices(filter: $filter, limit: $limit, sort: $sort, from: $from) {
    ...tenantRelayDevice
  }
}
    ${TenantRelayDeviceFragmentDoc}`;

export function useTenantRelayDevicesQuery(options: Omit<Urql.UseQueryArgs<TenantRelayDevicesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TenantRelayDevicesQuery>({ query: TenantRelayDevicesDocument, ...options });
};
export const DeviceDetailsDocument = gql`
    query DeviceDetails($filter: Filter, $limit: Int, $from: Int = 0) {
  devices(filter: $filter, limit: $limit, from: $from) {
    ...device
  }
}
    ${DeviceFragmentDoc}`;

export function useDeviceDetailsQuery(options: Omit<Urql.UseQueryArgs<DeviceDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceDetailsQuery>({ query: DeviceDetailsDocument, ...options });
};
export const DeviceDocument = gql`
    query Device($id: String!) {
  device(id: $id) {
    ...device
  }
}
    ${DeviceFragmentDoc}`;

export function useDeviceQuery(options: Omit<Urql.UseQueryArgs<DeviceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceQuery>({ query: DeviceDocument, ...options });
};
export const RestartDeviceDocument = gql`
    mutation RestartDevice($id: String!) {
  rebootDevice(deviceId: $id) {
    success
    error
  }
}
    `;

export function useRestartDeviceMutation() {
  return Urql.useMutation<RestartDeviceMutation, RestartDeviceMutationVariables>(RestartDeviceDocument);
};
export const FactoryResetDocument = gql`
    mutation FactoryReset($options: FactoryResetOptions, $deviceId: String!) {
  factoryReset(options: $options, deviceId: $deviceId) {
    success
    error
  }
}
    `;

export function useFactoryResetMutation() {
  return Urql.useMutation<FactoryResetMutation, FactoryResetMutationVariables>(FactoryResetDocument);
};
export const DeviceProvisioningScopeDocument = gql`
    query DeviceProvisioningScope($tenantId: String, $deviceModel: String, $deviceId: String, $siteId: String) {
  getDeviceParametersExtended(tenantId: $tenantId, deviceModel: $deviceModel, deviceId: $deviceId, siteId: $siteId, sendOnlyChanged: false) {
    policyDeploymentScope
  }
}
    `;

export function useDeviceProvisioningScopeQuery(options: Omit<Urql.UseQueryArgs<DeviceProvisioningScopeQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceProvisioningScopeQuery>({ query: DeviceProvisioningScopeDocument, ...options });
};
export const DeviceLinesDocument = gql`
    query deviceLines($deviceId: String!) {
  capabilitiesQuery(deviceId: $deviceId) {
    com {
      poly {
        service_information {
          ...DeviceLine
        }
      }
    }
  }
}
    ${DeviceLineFragmentDoc}`;

export function useDeviceLinesQuery(options: Omit<Urql.UseQueryArgs<DeviceLinesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceLinesQuery>({ query: DeviceLinesDocument, ...options });
};
export const RequestDeviceLogsDocument = gql`
    mutation RequestDeviceLogs($deviceId: String!) {
  requestUploadDeviceLog(deviceId: $deviceId, erase: true) {
    success
    error
  }
}
    `;

export function useRequestDeviceLogsMutation() {
  return Urql.useMutation<RequestDeviceLogsMutation, RequestDeviceLogsMutationVariables>(RequestDeviceLogsDocument);
};
export const FetchDeviceLogsDocument = gql`
    query FetchDeviceLogs($deviceId: String!) {
  accessLogUrl(deviceId: $deviceId) {
    success
    uploadedOn
    url
  }
}
    `;

export function useFetchDeviceLogsQuery(options: Omit<Urql.UseQueryArgs<FetchDeviceLogsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchDeviceLogsQuery>({ query: FetchDeviceLogsDocument, ...options });
};
export const RequestToggleFlashDocument = gql`
    mutation RequestToggleFlash($deviceId: String!, $enableFlash: Boolean!) {
  toggleLogToFlash(deviceId: $deviceId, enableFlash: $enableFlash) {
    requestedValue
    result
    error
  }
}
    `;

export function useRequestToggleFlashMutation() {
  return Urql.useMutation<RequestToggleFlashMutation, RequestToggleFlashMutationVariables>(RequestToggleFlashDocument);
};
export const GetFlashStatusDocument = gql`
    query GetFlashStatus($deviceId: String!) {
  logToFlashStatus(deviceId: $deviceId) {
    requestedValue
    result
    error
  }
}
    `;

export function useGetFlashStatusQuery(options: Omit<Urql.UseQueryArgs<GetFlashStatusQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetFlashStatusQuery>({ query: GetFlashStatusDocument, ...options });
};
export const RequestStartUploadPcapDocument = gql`
    mutation RequestStartUploadPCAP($filter: String!, $interval: Int!, $timeout: Int!, $size: Int!, $deviceId: String!) {
  requestStartUploadDevicePCAP(deviceId: $deviceId, interval: $interval, filter: $filter, timeout: $timeout, size: $size) {
    success
    error
    pcapStopTime
  }
}
    `;

export function useRequestStartUploadPcapMutation() {
  return Urql.useMutation<RequestStartUploadPcapMutation, RequestStartUploadPcapMutationVariables>(RequestStartUploadPcapDocument);
};
export const RequestStopUploadPcapDocument = gql`
    mutation RequestStopUploadPCAP($deviceId: String!) {
  requestStopUploadDevicePCAP(deviceId: $deviceId) {
    success
    error
  }
}
    `;

export function useRequestStopUploadPcapMutation() {
  return Urql.useMutation<RequestStopUploadPcapMutation, RequestStopUploadPcapMutationVariables>(RequestStopUploadPcapDocument);
};
export const FetchDevicePcapDocument = gql`
    query FetchDevicePCAP($deviceId: String!) {
  accessPCAPUrl(deviceId: $deviceId) {
    success
    error
    uploadedOn
    url
    pcapStopTime
  }
}
    `;

export function useFetchDevicePcapQuery(options: Omit<Urql.UseQueryArgs<FetchDevicePcapQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchDevicePcapQuery>({ query: FetchDevicePcapDocument, ...options });
};
export const GetPcapEnabledDocument = gql`
    query getPCAPEnabled($deviceId: String!, $tenantId: String!) {
  getPolicies(deviceId: $deviceId, tenantId: $tenantId) {
    ...policy
    groupId
    modifiedBy
    priority
    swSupportUpdatePath {
      deviceModel
      swPath
    }
  }
}
    ${PolicyFragmentDoc}`;

export function useGetPcapEnabledQuery(options: Omit<Urql.UseQueryArgs<GetPcapEnabledQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetPcapEnabledQuery>({ query: GetPcapEnabledDocument, ...options });
};
export const SetPcapEnabledDocument = gql`
    mutation setPCAPEnabled($tenantId: String!, $policy: PolicyInput!) {
  updatePolicy(policy: $policy, tenantId: $tenantId) {
    ...policy
    groupId
    modifiedBy
    priority
    swSupportUpdatePath {
      deviceModel
      swPath
    }
  }
}
    ${PolicyFragmentDoc}`;

export function useSetPcapEnabledMutation() {
  return Urql.useMutation<SetPcapEnabledMutation, SetPcapEnabledMutationVariables>(SetPcapEnabledDocument);
};
export const RequestUploadDeviceScreenDocument = gql`
    mutation RequestUploadDeviceScreen($deviceId: String!) {
  requestUploadDeviceScreen(deviceId: $deviceId) {
    success
    error
    url
    uploadedOn
    pcapStopTime
  }
}
    `;

export function useRequestUploadDeviceScreenMutation() {
  return Urql.useMutation<RequestUploadDeviceScreenMutation, RequestUploadDeviceScreenMutationVariables>(RequestUploadDeviceScreenDocument);
};
export const AccessScreenUrlDocument = gql`
    query AccessScreenUrl($deviceId: String!) {
  accessScreenUrl(deviceId: $deviceId) {
    success
    error
    url
    uploadedOn
    pcapStopTime
  }
}
    `;

export function useAccessScreenUrlQuery(options: Omit<Urql.UseQueryArgs<AccessScreenUrlQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AccessScreenUrlQuery>({ query: AccessScreenUrlDocument, ...options });
};
export const NetworkLinesDocument = gql`
    query networkLines($deviceId: String!) {
  capabilitiesQuery(deviceId: $deviceId) {
    com {
      poly {
        network_information {
          interfaces {
            value {
              status
              cdpstatus
              connectionmode
              connectionspeed
              connectiontype
              dnsalternativeaddress
              dnsdomain
              dnsprimaryaddress
              eapmethod
              ipv4address
              ipv4addresssource
              ipv4gateway
              ipv4subnet
              ipv4vlan
              ipv6addresssource
              ipv6globaladdress
              ipv6linklocaladdress
              ipv6ula
              lldplocationinformation
              lldpneighbors
              lldpstatus
              ntpserver
              provisioningprotocol
              pcportstatus
              interfacename
              vlan
              security
              ssid
              wifistatus
            }
          }
        }
      }
    }
  }
}
    `;

export function useNetworkLinesQuery(options: Omit<Urql.UseQueryArgs<NetworkLinesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NetworkLinesQuery>({ query: NetworkLinesDocument, ...options });
};
export const PrimaryDeviceInfoLinesDocument = gql`
    query primaryDeviceInfoLines($deviceId: String!) {
  capabilitiesQuery(deviceId: $deviceId) {
    com {
      poly {
        primary_device_information {
          ...C10PDI
        }
      }
    }
  }
}
    ${C10PdiFragmentDoc}`;

export function usePrimaryDeviceInfoLinesQuery(options: Omit<Urql.UseQueryArgs<PrimaryDeviceInfoLinesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PrimaryDeviceInfoLinesQuery>({ query: PrimaryDeviceInfoLinesDocument, ...options });
};
export const GetDeviceSettingsNameDocument = gql`
    query GetDeviceSettingsName($deviceModel: String) {
  getAllDeviceParameters(deviceModel: $deviceModel) {
    name
    friendlyName
    type
  }
}
    `;

export function useGetDeviceSettingsNameQuery(options: Omit<Urql.UseQueryArgs<GetDeviceSettingsNameQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetDeviceSettingsNameQuery>({ query: GetDeviceSettingsNameDocument, ...options });
};
export const GetSiteDocument = gql`
    query GetSite($site: String!) {
  getSite(id: $site) {
    id
    name
    address {
      address1
      country
      city
      region
      postalCode
    }
    rooms {
      id
      name
    }
  }
}
    `;

export function useGetSiteQuery(options: Omit<Urql.UseQueryArgs<GetSiteQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetSiteQuery>({ query: GetSiteDocument, ...options });
};
export const HardwareModelDetailsDocument = gql`
    query HardwareModelDetails($id: ID!) {
  hardwareModel(id: $id) {
    id
    name
    supportsPolicies
    aliases
  }
}
    `;

export function useHardwareModelDetailsQuery(options: Omit<Urql.UseQueryArgs<HardwareModelDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HardwareModelDetailsQuery>({ query: HardwareModelDetailsDocument, ...options });
};
export const OsStateDocument = gql`
    query OsState($filter: Filter) {
  devices(filter: $filter) {
    ...OSState
  }
}
    ${OsStateFragmentDoc}`;

export function useOsStateQuery(options: Omit<Urql.UseQueryArgs<OsStateQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OsStateQuery>({ query: OsStateDocument, ...options });
};
export const UpdateSiteDocument = gql`
    mutation UpdateSite($site: UpsertSiteRequest!) {
  upsertSite(fields: $site) {
    id
    name
  }
}
    `;

export function useUpdateSiteMutation() {
  return Urql.useMutation<UpdateSiteMutation, UpdateSiteMutationVariables>(UpdateSiteDocument);
};
export const DeviceStateSubscriptionDocument = gql`
    query deviceStateSubscription($id: String!) {
  device(id: $id) {
    id
    callStatus
  }
}
    `;

export function useDeviceStateSubscriptionQuery(options: Omit<Urql.UseQueryArgs<DeviceStateSubscriptionQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviceStateSubscriptionQuery>({ query: DeviceStateSubscriptionDocument, ...options });
};
export const GetAccessTokenListDocument = gql`
    query GetAccessTokenList($tenantId: String, $after: Cursor, $first: Int) {
  searchAccessTokens: ns_ls_searchClientAuthTokens(tenantId: $tenantId, after: $after, first: $first) {
    ...AccessTokenDataConnection
  }
}
    ${AccessTokenDataConnectionFragmentDoc}`;

export function useGetAccessTokenListQuery(options: Omit<Urql.UseQueryArgs<GetAccessTokenListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetAccessTokenListQuery>({ query: GetAccessTokenListDocument, ...options });
};
export const GetAccessTokenDocument = gql`
    query GetAccessToken($recordId: ID!) {
  getAccessToken: ns_ls_getClientAuthToken(recordId: $recordId) {
    ...AccessTokenData
  }
}
    ${AccessTokenDataFragmentDoc}`;

export function useGetAccessTokenQuery(options: Omit<Urql.UseQueryArgs<GetAccessTokenQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetAccessTokenQuery>({ query: GetAccessTokenDocument, ...options });
};
export const CreateAccessTokenDocument = gql`
    mutation CreateAccessToken($tenantId: String!) {
  createAccessToken: ns_ls_createAuthToken(tenantId: $tenantId) {
    ...AccessTokenData
  }
}
    ${AccessTokenDataFragmentDoc}`;

export function useCreateAccessTokenMutation() {
  return Urql.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(CreateAccessTokenDocument);
};
export const DeleteAccessTokenDocument = gql`
    mutation DeleteAccessToken($recordId: ID!) {
  deleteAccessToken: ns_ls_deleteAuthToken(recordId: $recordId) {
    ...AccessTokenData
  }
}
    ${AccessTokenDataFragmentDoc}`;

export function useDeleteAccessTokenMutation() {
  return Urql.useMutation<DeleteAccessTokenMutation, DeleteAccessTokenMutationVariables>(DeleteAccessTokenDocument);
};
export const GetAuditEventListDocument = gql`
    query GetAuditEventList($tenantId: String, $after: Cursor, $first: Int) {
  searchAuditEvents: ns_ls_searchAudits(tenantId: $tenantId, after: $after, first: $first) {
    ...AuditEventDataConnection
  }
}
    ${AuditEventDataConnectionFragmentDoc}`;

export function useGetAuditEventListQuery(options: Omit<Urql.UseQueryArgs<GetAuditEventListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetAuditEventListQuery>({ query: GetAuditEventListDocument, ...options });
};
export const GetAuditEventDocument = gql`
    query GetAuditEvent($recordId: ID!) {
  getAuditEvent: ns_ls_getAudit(recordId: $recordId) {
    ...AuditEventData
  }
}
    ${AuditEventDataFragmentDoc}`;

export function useGetAuditEventQuery(options: Omit<Urql.UseQueryArgs<GetAuditEventQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetAuditEventQuery>({ query: GetAuditEventDocument, ...options });
};
export const EntitlementGroupingSetListDocument = gql`
    query EntitlementGroupingSetList($tenantId: String!, $groupingId: String, $assignedToTenant: Boolean, $after: Cursor, $first: Int) {
  searchResult: ns_ls_searchEntitlementGroupingSets(tenantId: $tenantId, assignedToTenant: $assignedToTenant, groupingId: $groupingId, after: $after, first: $first) {
    ...EntitlementGroupingSetConnection
  }
}
    ${EntitlementGroupingSetConnectionFragmentDoc}`;

export function useEntitlementGroupingSetListQuery(options: Omit<Urql.UseQueryArgs<EntitlementGroupingSetListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<EntitlementGroupingSetListQuery>({ query: EntitlementGroupingSetListDocument, ...options });
};
export const GetEntitlementDocument = gql`
    query GetEntitlement($recordId: ID!) {
  entitlement: ns_ls_getEntitlement(recordId: $recordId) {
    ...EntitlementData
  }
}
    ${EntitlementDataFragmentDoc}`;

export function useGetEntitlementQuery(options: Omit<Urql.UseQueryArgs<GetEntitlementQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetEntitlementQuery>({ query: GetEntitlementDocument, ...options });
};
export const AssignEntitlementValueDocument = gql`
    mutation AssignEntitlementValue($groupingId: ID!, $instanceRecordId: ID!, $value: Int!) {
  assignEntitlementValue: ns_ls_assignEntitlementValue(groupingId: $groupingId, instanceRecordId: $instanceRecordId, value: $value) {
    ...EntitlementGroupingSetData
  }
}
    ${EntitlementGroupingSetDataFragmentDoc}`;

export function useAssignEntitlementValueMutation() {
  return Urql.useMutation<AssignEntitlementValueMutation, AssignEntitlementValueMutationVariables>(AssignEntitlementValueDocument);
};
export const DeleteEntitlementGroupDocument = gql`
    mutation DeleteEntitlementGroup($tenantId: String, $groupingId: String!) {
  searchDeleteEntitlements: ns_ls_searchDeleteEntitlements(tenantId: $tenantId, groupingId: $groupingId)
}
    `;

export function useDeleteEntitlementGroupMutation() {
  return Urql.useMutation<DeleteEntitlementGroupMutation, DeleteEntitlementGroupMutationVariables>(DeleteEntitlementGroupDocument);
};
export const ReleaseEntitlementValueDocument = gql`
    mutation ReleaseEntitlementValue($groupingId: ID!, $instanceRecordId: ID!, $value: Int!) {
  releaseEntitlementValue: ns_ls_releaseEntitlementValue(groupingId: $groupingId, instanceRecordId: $instanceRecordId, value: $value) {
    ...EntitlementGroupingSetData
  }
}
    ${EntitlementGroupingSetDataFragmentDoc}`;

export function useReleaseEntitlementValueMutation() {
  return Urql.useMutation<ReleaseEntitlementValueMutation, ReleaseEntitlementValueMutationVariables>(ReleaseEntitlementValueDocument);
};
export const CreateEntitlementDocument = gql`
    mutation CreateEntitlement($entitlement: ns_ls_EntitlementIn!) {
  createEntitlement: ns_ls_addEntitlement(entitlement: $entitlement) {
    ...EntitlementData
  }
}
    ${EntitlementDataFragmentDoc}`;

export function useCreateEntitlementMutation() {
  return Urql.useMutation<CreateEntitlementMutation, CreateEntitlementMutationVariables>(CreateEntitlementDocument);
};
export const ReleaseEntitlementDocument = gql`
    mutation ReleaseEntitlement($recordId: ID!) {
  releaseEntitlement: ns_ls_releaseEntitlement(recordId: $recordId) {
    ...EntitlementData
  }
}
    ${EntitlementDataFragmentDoc}`;

export function useReleaseEntitlementMutation() {
  return Urql.useMutation<ReleaseEntitlementMutation, ReleaseEntitlementMutationVariables>(ReleaseEntitlementDocument);
};
export const InstanceListDocument = gql`
    query InstanceList($tenantId: String, $after: Cursor, $first: Int) {
  searchResult: ns_ls_searchInstances(tenantId: $tenantId, after: $after, first: $first) {
    ...InstanceListConnection
  }
}
    ${InstanceListConnectionFragmentDoc}`;

export function useInstanceListQuery(options: Omit<Urql.UseQueryArgs<InstanceListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InstanceListQuery>({ query: InstanceListDocument, ...options });
};
export const GetInstanceDocument = gql`
    query GetInstance($recordId: ID!) {
  getInstance: ns_ls_getInstance(recordId: $recordId) {
    ...InstanceData
  }
}
    ${InstanceDataFragmentDoc}`;

export function useGetInstanceQuery(options: Omit<Urql.UseQueryArgs<GetInstanceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetInstanceQuery>({ query: GetInstanceDocument, ...options });
};
export const GetLicenseDocument = gql`
    query GetLicense($recordId: ID!) {
  getLicense: ns_ls_getLastLicense(recordId: $recordId)
}
    `;

export function useGetLicenseQuery(options: Omit<Urql.UseQueryArgs<GetLicenseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetLicenseQuery>({ query: GetLicenseDocument, ...options });
};
export const CreateInstanceDocument = gql`
    mutation CreateInstance($requestValue: String!, $tenantId: String!) {
  createInstance: ns_ls_createInstance(b64Request: $requestValue, tenantId: $tenantId) {
    ...InstanceData
  }
}
    ${InstanceDataFragmentDoc}`;

export function useCreateInstanceMutation() {
  return Urql.useMutation<CreateInstanceMutation, CreateInstanceMutationVariables>(CreateInstanceDocument);
};
export const CreateAltInstanceDocument = gql`
    mutation CreateAltInstance($createFromData: ns_ls_CreateRestrictiveInstanceDataIn!) {
  createAltInstance: ns_ls_createAltInstance(createFromData: $createFromData) {
    ...InstanceData
  }
}
    ${InstanceDataFragmentDoc}`;

export function useCreateAltInstanceMutation() {
  return Urql.useMutation<CreateAltInstanceMutation, CreateAltInstanceMutationVariables>(CreateAltInstanceDocument);
};
export const DeleteInstanceDocument = gql`
    mutation DeleteInstance($recordId: ID!) {
  deleteInstance: ns_ls_deleteInstance(recordId: $recordId) {
    ...InstanceData
  }
}
    ${InstanceDataFragmentDoc}`;

export function useDeleteInstanceMutation() {
  return Urql.useMutation<DeleteInstanceMutation, DeleteInstanceMutationVariables>(DeleteInstanceDocument);
};
export const ProcessLicenseRequestDocument = gql`
    mutation ProcessLicenseRequest($recordId: ID!, $requestValue: String!) {
  processLicenseRequest: ns_ls_processLicenseRequest(recordId: $recordId, requestValue: $requestValue)
}
    `;

export function useProcessLicenseRequestMutation() {
  return Urql.useMutation<ProcessLicenseRequestMutation, ProcessLicenseRequestMutationVariables>(ProcessLicenseRequestDocument);
};
export const ProcessAltLicenseRequestDocument = gql`
    mutation ProcessAltLicenseRequest($recordId: ID!, $requestValue: String!) {
  processAltLicenseRequest: ns_ls_generateAlternateLicense(recordId: $recordId, ackValue: $requestValue)
}
    `;

export function useProcessAltLicenseRequestMutation() {
  return Urql.useMutation<ProcessAltLicenseRequestMutation, ProcessAltLicenseRequestMutationVariables>(ProcessAltLicenseRequestDocument);
};
export const ProcessLicenseAckDocument = gql`
    mutation ProcessLicenseAck($recordId: ID!, $requestValue: String!) {
  ackInstance: ns_ls_ackInstance(recordId: $recordId, requestValue: $requestValue)
}
    `;

export function useProcessLicenseAckMutation() {
  return Urql.useMutation<ProcessLicenseAckMutation, ProcessLicenseAckMutationVariables>(ProcessLicenseAckDocument);
};
export const ReleaseInstanceDocument = gql`
    mutation ReleaseInstance($recordId: ID!, $requestValue: String!) {
  releaseInstance: ns_ls_releaseInstance(recordId: $recordId, requestValue: $requestValue)
}
    `;

export function useReleaseInstanceMutation() {
  return Urql.useMutation<ReleaseInstanceMutation, ReleaseInstanceMutationVariables>(ReleaseInstanceDocument);
};
export const UpdateInstanceDocument = gql`
    mutation UpdateInstance($recordId: ID!, $hostName: String, $niceName: String, $version: String, $serialNumber: String) {
  updateInstance: ns_ls_setInstanceEditables(recordId: $recordId, hostName: $hostName, niceName: $niceName, version: $version, serialNumber: $serialNumber) {
    ...InstanceData
  }
}
    ${InstanceDataFragmentDoc}`;

export function useUpdateInstanceMutation() {
  return Urql.useMutation<UpdateInstanceMutation, UpdateInstanceMutationVariables>(UpdateInstanceDocument);
};
export const LatestProductVersionsListDocument = gql`
    query LatestProductVersionsList {
  getLatestProductVersions: ns_ls_getLatestProductVersions {
    ...ProductLatestVersionListData
  }
}
    ${ProductLatestVersionListDataFragmentDoc}`;

export function useLatestProductVersionsListQuery(options: Omit<Urql.UseQueryArgs<LatestProductVersionsListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LatestProductVersionsListQuery>({ query: LatestProductVersionsListDocument, ...options });
};
export const ProductIdsDocument = gql`
    query ProductIds {
  getProductIds: ns_ls_getProductIds {
    productIds
  }
}
    `;

export function useProductIdsQuery(options: Omit<Urql.UseQueryArgs<ProductIdsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ProductIdsQuery>({ query: ProductIdsDocument, ...options });
};
export const ProductVersionsDocument = gql`
    query ProductVersions($productId: String!) {
  getProductVersions: ns_ls_getProductVersions(productId: $productId) {
    ...ProductVersionsData
  }
}
    ${ProductVersionsDataFragmentDoc}`;

export function useProductVersionsQuery(options: Omit<Urql.UseQueryArgs<ProductVersionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ProductVersionsQuery>({ query: ProductVersionsDocument, ...options });
};
export const ProductSoftwareCatalogDocument = gql`
    query ProductSoftwareCatalog($productId: String!, $version: String!) {
  getProductSoftwareCatalog: ns_ls_getSoftwareCatalog(productId: $productId, version: $version) {
    ...ProductSoftwareCatalogData
  }
}
    ${ProductSoftwareCatalogDataFragmentDoc}`;

export function useProductSoftwareCatalogQuery(options: Omit<Urql.UseQueryArgs<ProductSoftwareCatalogQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ProductSoftwareCatalogQuery>({ query: ProductSoftwareCatalogDocument, ...options });
};
export const DeleteMockRecordsDocument = gql`
    mutation deleteMockRecords($tenantId: String!) {
  deleteMockRecords(tenantId: $tenantId) {
    resultCode
  }
}
    `;

export function useDeleteMockRecordsMutation() {
  return Urql.useMutation<DeleteMockRecordsMutation, DeleteMockRecordsMutationVariables>(DeleteMockRecordsDocument);
};
export const GenerateLicenseDocument = gql`
    mutation generateLicense($tenantId: String!, $userId: String!, $quantity: Float = 10, $sku: String) {
  generateLicense(tenantId: $tenantId, userId: $userId, quantity: $quantity, sku: $sku) {
    licenseKey
    sku
    endDate
    activationDate
    tenantId
    userId
    details
    quantity
  }
}
    `;

export function useGenerateLicenseMutation() {
  return Urql.useMutation<GenerateLicenseMutation, GenerateLicenseMutationVariables>(GenerateLicenseDocument);
};
export const EntitleAllDevicesForModelDocument = gql`
    mutation entitleAllDevicesForModel($tenantId: String!, $modelId: String!) {
  entitleAllDevicesForModel(tenantId: $tenantId, modelId: $modelId) {
    licenseKey
    productSerial
    resultCode
    resultErrorMessage
  }
}
    `;

export function useEntitleAllDevicesForModelMutation() {
  return Urql.useMutation<EntitleAllDevicesForModelMutation, EntitleAllDevicesForModelMutationVariables>(EntitleAllDevicesForModelDocument);
};
export const EntitleDevicesDocument = gql`
    mutation entitleDevices($tenantId: String!, $modelId: String!, $productSerials: [String!]!) {
  entitleDevices(tenantId: $tenantId, modelId: $modelId, productSerials: $productSerials) {
    licenseKey
    productSerial
    resultCode
    resultErrorMessage
  }
}
    `;

export function useEntitleDevicesMutation() {
  return Urql.useMutation<EntitleDevicesMutation, EntitleDevicesMutationVariables>(EntitleDevicesDocument);
};
export const LicenseAggregationsByModelDocument = gql`
    query licenseAggregationsByModel($tenantId: ID!) {
  licenseAggregationsByModel(tenantId: $tenantId) {
    id
    name
    activeLicenseCount
    expiredLicenseCount
    availableLicenseCount
    eligibleDeviceCount
    ineligibleDeviceCount
    availableDeviceCount
    entitledDeviceCount
  }
  hardwareModels {
    id
    name
  }
}
    `;

export function useLicenseAggregationsByModelQuery(options: Omit<Urql.UseQueryArgs<LicenseAggregationsByModelQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LicenseAggregationsByModelQuery>({ query: LicenseAggregationsByModelDocument, ...options });
};
export const LicenseDetailsDocument = gql`
    query licenseDetails($tenantId: ID!, $licenseKey: String!) {
  licenseAggregationsByModel(tenantId: $tenantId, licenseKey: $licenseKey) {
    id
    name
    activeLicenseCount
    entitledDeviceCount
    availableDeviceCount
    availableLicenseCount
    eligibleDeviceCount
    expiredLicenseCount
    ineligibleDeviceCount
  }
  license(licenseKey: $licenseKey) {
    licenseKey
    sku
    userId
    endDate
    tenantId
    activationDate
    quantity
    isMockLicense
    consolidatedKey
    type
    expired
    models
    canceled
  }
}
    `;

export function useLicenseDetailsQuery(options: Omit<Urql.UseQueryArgs<LicenseDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LicenseDetailsQuery>({ query: LicenseDetailsDocument, ...options });
};
export const LicenseCountDocument = gql`
    query licenseCount($tenantId: String!, $type: LicenseTypeInput, $canceled: Boolean) {
  licenseCount(tenantId: $tenantId, type: $type, canceled: $canceled)
}
    `;

export function useLicenseCountQuery(options: Omit<Urql.UseQueryArgs<LicenseCountQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LicenseCountQuery>({ query: LicenseCountDocument, ...options });
};
export const LicensesDocument = gql`
    query licenses($tenantId: String!, $type: LicenseTypeInput, $searchTerm: String, $canceled: Boolean, $sort: LicenseSortObject, $from: Int, $limit: Int) {
  licenses(tenantId: $tenantId, type: $type, searchTerm: $searchTerm, canceled: $canceled, sort: $sort, from: $from, limit: $limit) {
    licenseKey
    userId
    endDate
    activationDate
    quantity
    type
  }
  count: licenseCount(tenantId: $tenantId, type: $type, searchTerm: $searchTerm, canceled: $canceled)
}
    `;

export function useLicensesQuery(options: Omit<Urql.UseQueryArgs<LicensesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LicensesQuery>({ query: LicensesDocument, ...options });
};
export const ActivateLicenseDocument = gql`
    mutation activateLicense($tenantId: String!, $userId: String!, $licenseKey: String!) {
  activateLicense(tenantId: $tenantId, userId: $userId, licenseKey: $licenseKey) {
    licenseKey
    sku
    endDate
    activationDate
    tenantId
    userId
    details
  }
}
    `;

export function useActivateLicenseMutation() {
  return Urql.useMutation<ActivateLicenseMutation, ActivateLicenseMutationVariables>(ActivateLicenseDocument);
};
export const VerifyLicenseKeyDocument = gql`
    query verifyLicenseKey($licenseKey: String!) {
  verifyLicenseKey(licenseKey: $licenseKey) {
    success
    error
    availableLicenses {
      ...availableLicense
    }
  }
}
    ${AvailableLicenseFragmentDoc}`;

export function useVerifyLicenseKeyQuery(options: Omit<Urql.UseQueryArgs<VerifyLicenseKeyQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VerifyLicenseKeyQuery>({ query: VerifyLicenseKeyDocument, ...options });
};
export const CreateGroupPolicyDocument = gql`
    mutation CreateGroupPolicy($input: GroupPolicyInput!) {
  createPolicyCapabilities(input: $input) {
    id
    collectionId
    name
    priority
    type
    settingsCount
    hardwareModel {
      id
      name
    }
  }
}
    `;

export function useCreateGroupPolicyMutation() {
  return Urql.useMutation<CreateGroupPolicyMutation, CreateGroupPolicyMutationVariables>(CreateGroupPolicyDocument);
};
export const UpdateGroupPolicyDocument = gql`
    mutation UpdateGroupPolicy($input: GroupPolicyInput!) {
  updatePolicyCapabilities(input: $input) {
    id
  }
}
    `;

export function useUpdateGroupPolicyMutation() {
  return Urql.useMutation<UpdateGroupPolicyMutation, UpdateGroupPolicyMutationVariables>(UpdateGroupPolicyDocument);
};
export const DeleteGroupPoliciesDocument = gql`
    mutation DeleteGroupPolicies($policyIds: [String!]!) {
  deletePoliciesCapabilities(policyIds: $policyIds)
}
    `;

export function useDeleteGroupPoliciesMutation() {
  return Urql.useMutation<DeleteGroupPoliciesMutation, DeleteGroupPoliciesMutationVariables>(DeleteGroupPoliciesDocument);
};
export const GroupPoliciesDocument = gql`
    query GroupPolicies($rules: Rule!) {
  policiesCapabilities(rules: $rules) {
    id
    name
    collectionId
    settingsCount
    priority
    type
    hardwareModel {
      id
      name
    }
  }
}
    `;

export function useGroupPoliciesQuery(options: Omit<Urql.UseQueryArgs<GroupPoliciesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GroupPoliciesQuery>({ query: GroupPoliciesDocument, ...options });
};
export const UserGroupPoliciesPrioritiesDocument = gql`
    query UserGroupPoliciesPriorities($rules: Rule!) {
  policiesCapabilities(rules: $rules) {
    id
    priority
  }
}
    `;

export function useUserGroupPoliciesPrioritiesQuery(options: Omit<Urql.UseQueryArgs<UserGroupPoliciesPrioritiesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UserGroupPoliciesPrioritiesQuery>({ query: UserGroupPoliciesPrioritiesDocument, ...options });
};
export const AvailablePolicyCapabilitiesDocument = gql`
    query AvailablePolicyCapabilities($propertyValue: String!, $propertyPath: String!) {
  capabilitiesSuperset(propertyValue: $propertyValue, propertyPath: $propertyPath) {
    id
    constraints {
      options
    }
  }
}
    `;

export function useAvailablePolicyCapabilitiesQuery(options: Omit<Urql.UseQueryArgs<AvailablePolicyCapabilitiesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AvailablePolicyCapabilitiesQuery>({ query: AvailablePolicyCapabilitiesDocument, ...options });
};
export const AutoCreatedPoliciesDocument = gql`
    query AutoCreatedPolicies($tenantId: String!) {
  getAutoCreatedPolicies(tenantId: $tenantId) {
    deviceModel
    deviceModelUuid
  }
}
    `;

export function useAutoCreatedPoliciesQuery(options: Omit<Urql.UseQueryArgs<AutoCreatedPoliciesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AutoCreatedPoliciesQuery>({ query: AutoCreatedPoliciesDocument, ...options });
};
export const ReadGroupDocument = gql`
    query ReadGroup($groupId: String!) {
  readGroup(groupId: $groupId) {
    groupId
  }
}
    `;

export function useReadGroupQuery(options: Omit<Urql.UseQueryArgs<ReadGroupQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ReadGroupQuery>({ query: ReadGroupDocument, ...options });
};
export const AllPoliciesGroupsDocument = gql`
    query AllPoliciesGroups($tenantId: String!) {
  getAllGroups(tenantId: $tenantId) {
    groups {
      groups {
        name
        id
        policies
      }
    }
    groupId
  }
}
    `;

export function useAllPoliciesGroupsQuery(options: Omit<Urql.UseQueryArgs<AllPoliciesGroupsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AllPoliciesGroupsQuery>({ query: AllPoliciesGroupsDocument, ...options });
};
export const UserGroupsForTenantDocument = gql`
    query UserGroupsForTenant($tenantId: String!) {
  userGroupsForTenant(tenantId: $tenantId) {
    id
    name
    source
  }
}
    `;

export function useUserGroupsForTenantQuery(options: Omit<Urql.UseQueryArgs<UserGroupsForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UserGroupsForTenantQuery>({ query: UserGroupsForTenantDocument, ...options });
};
export const GetUserGroupDevicesDocument = gql`
    query GetUserGroupDevices($id: String!, $tenantId: String!) {
  getUserGroup(id: $id, tenantId: $tenantId) {
    id
    name
    users {
      user {
        user_id
        name
        connections {
          tenantId
          id
          model {
            name
            id
            supportsPolicies
          }
          name
          supportsSettings
        }
      }
    }
  }
}
    `;

export function useGetUserGroupDevicesQuery(options: Omit<Urql.UseQueryArgs<GetUserGroupDevicesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetUserGroupDevicesQuery>({ query: GetUserGroupDevicesDocument, ...options });
};
export const GetUserGroupDocument = gql`
    query GetUserGroup($id: String!, $tenantId: String!) {
  getUserGroup(id: $id, tenantId: $tenantId) {
    id
    name
  }
}
    `;

export function useGetUserGroupQuery(options: Omit<Urql.UseQueryArgs<GetUserGroupQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetUserGroupQuery>({ query: GetUserGroupDocument, ...options });
};
export const GetDeviceNameDocument = gql`
    query GetDeviceName($id: String!) {
  device(id: $id) {
    id
    name
    productId
    serialNumber
    hardwareModel
    lastConfigRequestDate
  }
}
    `;

export function useGetDeviceNameQuery(options: Omit<Urql.UseQueryArgs<GetDeviceNameQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetDeviceNameQuery>({ query: GetDeviceNameDocument, ...options });
};
export const AddressLookupDocument = gql`
    query AddressLookup($address: ID!) {
  postalLookup(q: $address) {
    formattedAddress
    buildingNumber
    street
    countryName
    city
    regionCode
    zip
    geohash
  }
}
    `;

export function useAddressLookupQuery(options: Omit<Urql.UseQueryArgs<AddressLookupQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AddressLookupQuery>({ query: AddressLookupDocument, ...options });
};
export const HardwareModelsDocument = gql`
    query HardwareModels {
  hardwareModels {
    ...hardwareModel
  }
}
    ${HardwareModelFragmentDoc}`;

export function useHardwareModelsQuery(options: Omit<Urql.UseQueryArgs<HardwareModelsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HardwareModelsQuery>({ query: HardwareModelsDocument, ...options });
};
export const SupportsProvisioningOnboardingDocument = gql`
    query SupportsProvisioningOnboarding {
  hardwareModels(query: {filter: {clauses: {field: supportsProvisioning, comparisonOperator: EQUAL, value: "true"}}}) {
    id
    name
  }
}
    `;

export function useSupportsProvisioningOnboardingQuery(options: Omit<Urql.UseQueryArgs<SupportsProvisioningOnboardingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SupportsProvisioningOnboardingQuery>({ query: SupportsProvisioningOnboardingDocument, ...options });
};
export const SupportsUsbOnboardingDocument = gql`
    query SupportsUSBOnboarding {
  hardwareModels(query: {filter: {clauses: {field: supportsPolicies, comparisonOperator: EQUAL, value: "true"}}}) {
    id
    name
    skus {
      id
    }
  }
}
    `;

export function useSupportsUsbOnboardingQuery(options: Omit<Urql.UseQueryArgs<SupportsUsbOnboardingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SupportsUsbOnboardingQuery>({ query: SupportsUsbOnboardingDocument, ...options });
};
export const RegisterDeviceDocument = gql`
    mutation registerDevice($device: RegisterDeviceRequest!) {
  registerDevice(device: $device) {
    success
    deviceId
    error
  }
}
    `;

export function useRegisterDeviceMutation() {
  return Urql.useMutation<RegisterDeviceMutation, RegisterDeviceMutationVariables>(RegisterDeviceDocument);
};
export const SitesAndRoomsDocument = gql`
    query SitesAndRooms($tenantId: String) {
  sites(tenantId: $tenantId) {
    id
    name
    deviceCount
    address {
      formattedAddress
      address1
      city
      region
      postalCode
      country
      geohash
    }
    roomCount
    rooms {
      id
      name
      floor
      capacity
      devices {
        ...RoomDevice
      }
    }
  }
}
    ${RoomDeviceFragmentDoc}`;

export function useSitesAndRoomsQuery(options: Omit<Urql.UseQueryArgs<SitesAndRoomsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SitesAndRoomsQuery>({ query: SitesAndRoomsDocument, ...options });
};
export const GetResourceFilesDocument = gql`
    query getResourceFiles($tenantId: String!) {
  getAllResourceFiles(tenantId: $tenantId) {
    ...ResourceFile
  }
}
    ${ResourceFileFragmentDoc}`;

export function useGetResourceFilesQuery(options: Omit<Urql.UseQueryArgs<GetResourceFilesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetResourceFilesQuery>({ query: GetResourceFilesDocument, ...options });
};
export const AddResourceFileDocument = gql`
    mutation addResourceFile($tenantId: String, $userId: String, $file: String, $fileName: String!, $fileSize: Float) {
  addResourceFile(tenantId: $tenantId, userId: $userId, file: $file, fileName: $fileName, fileSize: $fileSize) {
    status
    errors
  }
}
    `;

export function useAddResourceFileMutation() {
  return Urql.useMutation<AddResourceFileMutation, AddResourceFileMutationVariables>(AddResourceFileDocument);
};
export const DeleteResourceFilesDocument = gql`
    mutation deleteResourceFiles($tenantId: String, $fileNames: [String]) {
  deleteResourceFiles(tenantId: $tenantId, fileNames: $fileNames) {
    status
    errors
  }
}
    `;

export function useDeleteResourceFilesMutation() {
  return Urql.useMutation<DeleteResourceFilesMutation, DeleteResourceFilesMutationVariables>(DeleteResourceFilesDocument);
};
export const CreateRoomDocument = gql`
    mutation createRoom($fields: UpsertRoomRequest!) {
  upsertRoom(fields: $fields) {
    id
    name
    floor
    capacity
    site {
      name
    }
  }
}
    `;

export function useCreateRoomMutation() {
  return Urql.useMutation<CreateRoomMutation, CreateRoomMutationVariables>(CreateRoomDocument);
};
export const RoomDocument = gql`
    query Room($id: String!) {
  room(id: $id) {
    ...RoomData
  }
}
    ${RoomDataFragmentDoc}`;

export function useRoomQuery(options: Omit<Urql.UseQueryArgs<RoomQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RoomQuery>({ query: RoomDocument, ...options });
};
export const MtrRoomDevicesDocument = gql`
    query MTRRoomDevices($id: String!) {
  room(id: $id) {
    id
    devices {
      ...MTRRoomDevice
    }
  }
}
    ${MtrRoomDeviceFragmentDoc}`;

export function useMtrRoomDevicesQuery(options: Omit<Urql.UseQueryArgs<MtrRoomDevicesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MtrRoomDevicesQuery>({ query: MtrRoomDevicesDocument, ...options });
};
export const UpdateRoomDocument = gql`
    mutation UpdateRoom($details: UpsertRoomRequest!) {
  upsertRoom(fields: $details) {
    ...RoomData
  }
}
    ${RoomDataFragmentDoc}`;

export function useUpdateRoomMutation() {
  return Urql.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument);
};
export const SwitchRoomSiteDocument = gql`
    mutation SwitchRoomSite($tenantId: String!, $siteId: String!, $roomId: String!) {
  switchSite(tenantId: $tenantId, siteId: $siteId, roomId: $roomId) {
    ...RoomData
  }
}
    ${RoomDataFragmentDoc}`;

export function useSwitchRoomSiteMutation() {
  return Urql.useMutation<SwitchRoomSiteMutation, SwitchRoomSiteMutationVariables>(SwitchRoomSiteDocument);
};
export const DeleteRoomsDocument = gql`
    mutation DeleteRooms($tenantId: String!, $roomIds: [String!]!) {
  deleteRooms(tenantId: $tenantId, ids: $roomIds) {
    error
    success
    id
  }
}
    `;

export function useDeleteRoomsMutation() {
  return Urql.useMutation<DeleteRoomsMutation, DeleteRoomsMutationVariables>(DeleteRoomsDocument);
};
export const CountDevicesDocument = gql`
    query CountDevices($totalCountFilter: Filter!, $connectedCountFilter: Filter!) {
  count: countDevices(filter: $totalCountFilter)
  connectedCount: countDevices(filter: $connectedCountFilter)
}
    `;

export function useCountDevicesQuery(options: Omit<Urql.UseQueryArgs<CountDevicesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CountDevicesQuery>({ query: CountDevicesDocument, ...options });
};
export const CountUnassignedDevicesDocument = gql`
    query CountUnassignedDevices($tenantId: String!) {
  count: countDevices(filter: {AND: [{eq: "Unassigned", field: "site"}, {eq: $tenantId, field: "tenantId"}]})
}
    `;

export function useCountUnassignedDevicesQuery(options: Omit<Urql.UseQueryArgs<CountUnassignedDevicesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CountUnassignedDevicesQuery>({ query: CountUnassignedDevicesDocument, ...options });
};
export const CountDevicesInUnassignedRoomsDocument = gql`
    query CountDevicesInUnassignedRooms($tenantId: String!) {
  count: countDevices(filter: {AND: [{eq: "Unassigned", field: "room"}, {eq: $tenantId, field: "tenantId"}]})
}
    `;

export function useCountDevicesInUnassignedRoomsQuery(options: Omit<Urql.UseQueryArgs<CountDevicesInUnassignedRoomsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CountDevicesInUnassignedRoomsQuery>({ query: CountDevicesInUnassignedRoomsDocument, ...options });
};
export const SitesListForTenantDocument = gql`
    query SitesListForTenant($tenantId: ID!, $params: SiteConnectionParams) {
  tenant(id: $tenantId) {
    id
    siteData(params: $params) {
      total
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        ...SitesListEdges
      }
    }
  }
}
    ${SitesListEdgesFragmentDoc}`;

export function useSitesListForTenantQuery(options: Omit<Urql.UseQueryArgs<SitesListForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SitesListForTenantQuery>({ query: SitesListForTenantDocument, ...options });
};
export const SitesCountForTenantDocument = gql`
    query SitesCountForTenant($tenantId: ID!) {
  tenant(id: $tenantId) {
    id
    siteCount: siteData(params: {sort: {field: UNASSIGNED_FIRST, direction: DESC}}) {
      total
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

export function useSitesCountForTenantQuery(options: Omit<Urql.UseQueryArgs<SitesCountForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SitesCountForTenantQuery>({ query: SitesCountForTenantDocument, ...options });
};
export const RoomsListForTenantDocument = gql`
    query RoomsListForTenant($tenantId: ID!, $params: RoomConnectionParams) {
  tenant(id: $tenantId) {
    id
    roomData(params: $params) {
      total
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        ...RoomsListEdges
      }
    }
    roomCount: roomData(params: {sort: {field: UNASSIGNED_ROOM_NAME_FIRST, direction: DESC}}) {
      total
    }
  }
}
    ${RoomsListEdgesFragmentDoc}`;

export function useRoomsListForTenantQuery(options: Omit<Urql.UseQueryArgs<RoomsListForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RoomsListForTenantQuery>({ query: RoomsListForTenantDocument, ...options });
};
export const GetSubnetRulesDocument = gql`
    query getSubnetRules($input: GetSubnetRulesInput!) {
  getSubnetRules(getSubnetRulesInput: $input) {
    id
    publicCidr
    privateCidr
  }
}
    `;

export function useGetSubnetRulesQuery(options: Omit<Urql.UseQueryArgs<GetSubnetRulesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetSubnetRulesQuery>({ query: GetSubnetRulesDocument, ...options });
};
export const CheckSubnetRuleValidityDocument = gql`
    query checkSubnetRuleValidity($input: SubnetRuleValidityInput!) {
  getSubnetRuleValidity(subnetRuleValidityInput: $input) {
    result
    ruleId
    siteId
    siteName
  }
}
    `;

export function useCheckSubnetRuleValidityQuery(options: Omit<Urql.UseQueryArgs<CheckSubnetRuleValidityQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CheckSubnetRuleValidityQuery>({ query: CheckSubnetRuleValidityDocument, ...options });
};
export const UpdateSubnetRuleDocument = gql`
    mutation updateSubnetRule($input: UpdateSubnetRuleInput!) {
  updateSubnetRule(updateSubnetRuleInput: $input) {
    id
  }
}
    `;

export function useUpdateSubnetRuleMutation() {
  return Urql.useMutation<UpdateSubnetRuleMutation, UpdateSubnetRuleMutationVariables>(UpdateSubnetRuleDocument);
};
export const DeleteSubnetRuleDocument = gql`
    mutation deleteSubnetRule($input: DeleteSubnetRuleInput!) {
  deleteSubnetRule(deleteSubnetRuleInput: $input) {
    id
  }
}
    `;

export function useDeleteSubnetRuleMutation() {
  return Urql.useMutation<DeleteSubnetRuleMutation, DeleteSubnetRuleMutationVariables>(DeleteSubnetRuleDocument);
};
export const CreateSubnetRuleDocument = gql`
    mutation createSubnetRule($input: CreateSubnetRuleInput!) {
  createSubnetRule(createSubnetRuleInput: $input) {
    id
    publicCidr
    privateCidr
  }
}
    `;

export function useCreateSubnetRuleMutation() {
  return Urql.useMutation<CreateSubnetRuleMutation, CreateSubnetRuleMutationVariables>(CreateSubnetRuleDocument);
};
export const SiteOverviewDocument = gql`
    query siteOverview($id: String!) {
  getSite(id: $id) {
    name
    rooms {
      id
      name
      floor
      capacity
      devices {
        id
        name
      }
    }
    address {
      address1
      formattedAddress
    }
  }
  countDevices(filter: {field: "siteUUID", eq: $id})
}
    `;

export function useSiteOverviewQuery(options: Omit<Urql.UseQueryArgs<SiteOverviewQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SiteOverviewQuery>({ query: SiteOverviewDocument, ...options });
};
export const SiteIdsForTenantDocument = gql`
    query SiteIdsForTenant($tenantId: String!) {
  sites(tenantId: $tenantId) {
    id
  }
}
    `;

export function useSiteIdsForTenantQuery(options: Omit<Urql.UseQueryArgs<SiteIdsForTenantQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SiteIdsForTenantQuery>({ query: SiteIdsForTenantDocument, ...options });
};
export const SiteNameAndAddressDocument = gql`
    query siteNameAndAddress($id: String!) {
  site(id: $id) {
    name
    address {
      address1
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
      geohash
      formattedAddress
    }
  }
}
    `;

export function useSiteNameAndAddressQuery(options: Omit<Urql.UseQueryArgs<SiteNameAndAddressQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SiteNameAndAddressQuery>({ query: SiteNameAndAddressDocument, ...options });
};
export const SiteNameDocument = gql`
    query siteName($id: String!) {
  siteName: site(id: $id) {
    id
    name
  }
}
    `;

export function useSiteNameQuery(options: Omit<Urql.UseQueryArgs<SiteNameQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SiteNameQuery>({ query: SiteNameDocument, ...options });
};
export const DeleteSitesDocument = gql`
    mutation DeleteSites($ids: [String!]!, $tenantId: String!, $deleteRooms: Boolean) {
  deleteSites(ids: $ids, tenantId: $tenantId, deleteRooms: $deleteRooms) {
    id
    success
    error
  }
}
    `;

export function useDeleteSitesMutation() {
  return Urql.useMutation<DeleteSitesMutation, DeleteSitesMutationVariables>(DeleteSitesDocument);
};
export const RestartDevicesBySiteDocument = gql`
    mutation RestartDevicesBySite($siteId: String!) {
  rebootDevicesBySiteId(siteId: $siteId) {
    success
    error
  }
}
    `;

export function useRestartDevicesBySiteMutation() {
  return Urql.useMutation<RestartDevicesBySiteMutation, RestartDevicesBySiteMutationVariables>(RestartDevicesBySiteDocument);
};
export const ResendVerifyEmailDocument = gql`
    mutation resendVerifyEmail($id: ID!, $clientId: ID) {
  resendVerifyEmail(id: $id, clientId: $clientId) {
    userId
  }
}
    `;

export function useResendVerifyEmailMutation() {
  return Urql.useMutation<ResendVerifyEmailMutation, ResendVerifyEmailMutationVariables>(ResendVerifyEmailDocument);
};
export const EmailVerifiedDocument = gql`
    query emailVerified {
  user {
    user {
      user_id
      email_verified
    }
  }
}
    `;

export function useEmailVerifiedQuery(options: Omit<Urql.UseQueryArgs<EmailVerifiedQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<EmailVerifiedQuery>({ query: EmailVerifiedDocument, ...options });
};
export const HardwareProductsDocument = gql`
    query HardwareProducts {
  hardwareProducts {
    ...product
  }
}
    ${ProductFragmentDoc}`;

export function useHardwareProductsQuery(options: Omit<Urql.UseQueryArgs<HardwareProductsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HardwareProductsQuery>({ query: HardwareProductsDocument, ...options });
};
export const PolyPlusEnabledDocument = gql`
    query PolyPlusEnabled($tenantId: String!) {
  polyPlusEnabled(tenantId: $tenantId)
}
    `;

export function usePolyPlusEnabledQuery(options: Omit<Urql.UseQueryArgs<PolyPlusEnabledQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PolyPlusEnabledQuery>({ query: PolyPlusEnabledDocument, ...options });
};
export const SetUserMetaDataDocument = gql`
    mutation SetUserMetaData($input: UserMetaDataInput!) {
  setUserMetaData(input: $input) {
    user {
      user_metadata {
        info {
          acceptedToS
          theme
          highContrastCharts
          lastTenantId
          ackAdblockWarning
          subnetInstructions
        }
      }
    }
  }
}
    `;

export function useSetUserMetaDataMutation() {
  return Urql.useMutation<SetUserMetaDataMutation, SetUserMetaDataMutationVariables>(SetUserMetaDataDocument);
};
export type TenantsListQueryVariables = t.Exact<{
  from?: t.Maybe<t.Scalars['Int']>;
  limit?: t.Maybe<t.Scalars['Int']>;
  namePrefix?: t.Maybe<t.Scalars['String']>;
  tenantType?: t.Maybe<t.TenantType>;
}>;


export type TenantsListQuery = (
  { __typename: 'Query' }
  & { tenants: Array<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'name' | 'type'>
    & { sites: t.Maybe<(
      { __typename: 'SiteConnection' }
      & Pick<t.SiteConnection, 'count'>
    )>, rooms: t.Maybe<(
      { __typename: 'RoomConnection' }
      & Pick<t.RoomConnection, 'count'>
    )> }
  )> }
);

export type TenantCreationDateQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type TenantCreationDateQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'createdAt'>
  ) }
);

export type UserPermisionsFragment = (
  { __typename: 'Permission' }
  & Pick<t.Permission, 'name'>
);

export type RolesAndPermisionsQueryVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
}>;


export type RolesAndPermisionsQuery = (
  { __typename: 'Query' }
  & { accessor: t.Maybe<(
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId' | 'resourceType'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )>, permissions: Array<(
        { __typename: 'Permission' }
        & UserPermisionsFragment
      )> }
    )> }
  )>, roles: Array<(
    { __typename: 'Role' }
    & Pick<t.Role, 'name'>
    & { permissions: Array<(
      { __typename: 'Permission' }
      & UserPermisionsFragment
    )> }
  )> }
);

export type AcceptInviteMutationVariables = t.Exact<{
  code: t.Scalars['ID'];
}>;


export type AcceptInviteMutation = (
  { __typename: 'Mutation' }
  & { acceptUserInvite: (
    { __typename: 'AcceptedInviteResponse' }
    & { invite: t.Maybe<(
      { __typename: 'UserInvite' }
      & Pick<t.UserInvite, 'tenant_id'>
    )> }
  ) }
);

export type AccountsListQueryVariables = t.Exact<{
  from?: t.Maybe<t.Scalars['Int']>;
  limit?: t.Maybe<t.Scalars['Int']>;
  namePrefix?: t.Maybe<t.Scalars['String']>;
  tenantType?: t.Maybe<t.TenantType>;
  sort?: t.Maybe<t.TenantSort>;
}>;


export type AccountsListQuery = (
  { __typename: 'Query' }
  & { tenants: Array<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'name' | 'type' | 'deviceCount' | 'memberCount'>
    & { sites: t.Maybe<(
      { __typename: 'SiteConnection' }
      & Pick<t.SiteConnection, 'count'>
    )>, rooms: t.Maybe<(
      { __typename: 'RoomConnection' }
      & Pick<t.RoomConnection, 'count'>
    )> }
  )> }
);

export type AuditLogFragment = (
  { __typename: 'AuditLog' }
  & Pick<t.AuditLog, 'id' | 'userId' | 'username' | 'logTime' | 'eventType' | 'eventDetails' | 'loginType' | 'publicIpAddress' | 'authorized'>
);

export type AuditLogsQueryVariables = t.Exact<{
  filter?: t.Maybe<t.LogFilter>;
  from?: t.Maybe<t.Scalars['Int']>;
  limit?: t.Maybe<t.Scalars['Int']>;
  sort?: t.Maybe<t.Sort>;
  tenantId: t.Scalars['String'];
}>;


export type AuditLogsQuery = (
  { __typename: 'Query' }
  & { getAuditLogs: Array<(
    { __typename: 'AuditLog' }
    & AuditLogFragment
  )> }
);

export type ConsolidateAndRenameAccountsMutationVariables = t.Exact<{
  fromId: t.Scalars['ID'];
  toId: t.Scalars['ID'];
  input: t.UpdateTenantInput;
}>;


export type ConsolidateAndRenameAccountsMutation = (
  { __typename: 'Mutation' }
  & { mergeInternalTenants: (
    { __typename: 'MergeEntityResponse' }
    & { mergeRequest: (
      { __typename: 'MergeEntityRequest' }
      & Pick<t.MergeEntityRequest, 'id'>
    ) }
  ), updateTenant: (
    { __typename: 'TenantResponse' }
    & { tenant: (
      { __typename: 'Tenant' }
      & Pick<t.Tenant, 'id'>
    ) }
  ) }
);

export type DualTenantUserCountsQueryVariables = t.Exact<{
  tenant1Id: t.Scalars['String'];
  tenant2Id: t.Scalars['String'];
}>;


export type DualTenantUserCountsQuery = (
  { __typename: 'Query' }
  & { tenant1: (
    { __typename: 'UserConnection' }
    & { total: t.UserConnection['count'] }
  ), tenant2: (
    { __typename: 'UserConnection' }
    & { total: t.UserConnection['count'] }
  ), common: (
    { __typename: 'UserConnection' }
    & { total: t.UserConnection['count'] }
  ) }
);

export type DeleteTenantMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
}>;


export type DeleteTenantMutation = (
  { __typename: 'Mutation' }
  & { deleteTenant: (
    { __typename: 'DeleteTenantResponse' }
    & Pick<t.DeleteTenantResponse, 'id'>
  ) }
);

export type DeviceCountForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type DeviceCountForTenantQuery = (
  { __typename: 'Query' }
  & { deviceCount: t.Query['countDevices'] }
);

export type UpdateTenantMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  input: t.UpdateTenantInput;
}>;


export type UpdateTenantMutation = (
  { __typename: 'Mutation' }
  & { updateTenant: (
    { __typename: 'TenantResponse' }
    & { account: (
      { __typename: 'Tenant' }
      & Pick<t.Tenant, 'id' | 'name' | 'type'>
    ) }
  ) }
);

export type TenantIntegrationsQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  integration?: t.Maybe<t.TenantIntegrationInput>;
}>;


export type TenantIntegrationsQuery = (
  { __typename: 'Query' }
  & { tenantIntegrations: Array<(
    { __typename: 'TenantIntegrationsResponse' }
    & Pick<t.TenantIntegrationsResponse, 'id' | 'integrationType'>
    & { detail: t.Maybe<(
      { __typename: 'Microsoft' }
      & Pick<t.Microsoft, 'MicrosoftTenantId' | 'scopes'>
    )> }
  )> }
);

export type CreateTenantIntegrationMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  integration: t.TenantIntegrationInput;
}>;


export type CreateTenantIntegrationMutation = (
  { __typename: 'Mutation' }
  & { createTenantIntegration: (
    { __typename: 'CreateTenantIntegrationResponse' }
    & { integration: (
      { __typename: 'Integration' }
      & Pick<t.Integration, 'id'>
    ) }
  ) }
);

export type DeleteTenantIntegrationMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  integration: t.TenantIntegrationInput;
}>;


export type DeleteTenantIntegrationMutation = (
  { __typename: 'Mutation' }
  & { deleteTenantIntegration: (
    { __typename: 'DeleteTenantIntegrationResponse' }
    & Pick<t.DeleteTenantIntegrationResponse, 'id'>
  ) }
);

export type CountAccountsQueryVariables = t.Exact<{ [key: string]: never; }>;


export type CountAccountsQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'tenantCount'>
);

export type AccountListMergeRequestsFragment = (
  { __typename: 'MergeEntityRequest' }
  & Pick<t.MergeEntityRequest, 'id' | 'createdAt' | 'acceptedAt' | 'acceptedById' | 'cancelledAt' | 'cancelledById' | 'confirmedAt' | 'confirmedById' | 'mergeFromId' | 'mergeFromType' | 'mergeToId' | 'mergeToType' | 'rejectedAt' | 'rejectedById' | 'updatedAt'>
);

export type RequestsMadeQueryVariables = t.Exact<{
  entityId?: t.Maybe<t.Scalars['String']>;
}>;


export type RequestsMadeQuery = (
  { __typename: 'Query' }
  & { mergeEntityRequests: (
    { __typename: 'MergeEntitiesResponse' }
    & { mergeRequests: (
      { __typename: 'MergeEntitiesResult' }
      & { from: Array<(
        { __typename: 'MergeEntityRequest' }
        & AccountListMergeRequestsFragment
      )>, to: Array<(
        { __typename: 'MergeEntityRequest' }
        & AccountListMergeRequestsFragment
      )> }
    ) }
  ) }
);

export type AccessorQueryVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
}>;


export type AccessorQuery = (
  { __typename: 'Query' }
  & { accessor: t.Maybe<(
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId' | 'resourceType'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name' | 'tags'>
      )> }
    )> }
  )> }
);

export type InviteMemberMutationVariables = t.Exact<{
  emails: Array<t.Scalars['String']>;
  tenant_id: t.Scalars['ID'];
  role: t.Scalars['String'];
}>;


export type InviteMemberMutation = (
  { __typename: 'Mutation' }
  & { inviteUser: (
    { __typename: 'InviteUserResponse' }
    & { invites: t.Maybe<Array<(
      { __typename: 'InviteUsersStatus' }
      & Pick<t.InviteUsersStatus, 'success' | 'email' | 'error'>
    )>> }
  ) }
);

export type GrantRoleMutationVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  resourceId: t.Scalars['ID'];
  role: t.Scalars['String'];
}>;


export type GrantRoleMutation = (
  { __typename: 'Mutation' }
  & { grantRole: (
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId' | 'resourceType'>
      & { permissions: Array<(
        { __typename: 'Permission' }
        & Pick<t.Permission, 'name'>
      )>, roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )> }
    )> }
  ) }
);

export type RevokeRoleMutationVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  resourceId: t.Scalars['ID'];
  role: t.Scalars['String'];
}>;


export type RevokeRoleMutation = (
  { __typename: 'Mutation' }
  & { revokeRole: (
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )> }
    )> }
  ) }
);

export type PermisionRolesFragment = (
  { __typename: 'Role' }
  & Pick<t.Role, 'name'>
  & { permissions: Array<(
    { __typename: 'Permission' }
    & Pick<t.Permission, 'name'>
  )> }
);

export type PermisionsGrantsFragment = (
  { __typename: 'Grant' }
  & Pick<t.Grant, 'resourceId' | 'resourceType'>
  & { roles: Array<(
    { __typename: 'Role' }
    & Pick<t.Role, 'name' | 'tags'>
    & { permissions: Array<(
      { __typename: 'Permission' }
      & Pick<t.Permission, 'name'>
    )> }
  )>, permissions: Array<(
    { __typename: 'Permission' }
    & Pick<t.Permission, 'name'>
  )> }
);

export type PermissionsQueryVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  tags?: t.Maybe<Array<t.Scalars['String']>>;
}>;


export type PermissionsQuery = (
  { __typename: 'Query' }
  & { loggedInUser: t.Maybe<(
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & PermisionsGrantsFragment
    )> }
  )>, tenants: Array<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'name'>
  )>, roles: Array<(
    { __typename: 'Role' }
    & PermisionRolesFragment
  )> }
);

export type RemoveUserFromAccountMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  tid: t.Scalars['ID'];
}>;


export type RemoveUserFromAccountMutation = (
  { __typename: 'Mutation' }
  & { disassociateWithResource: (
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )>, permissions: Array<(
        { __typename: 'Permission' }
        & Pick<t.Permission, 'name'>
      )> }
    )> }
  ) }
);

export type SwitchRoleMutationVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  resourceId: t.Scalars['ID'];
  role?: t.Maybe<t.Scalars['String']>;
  resourceType?: t.Maybe<t.Scalars['String']>;
  tags?: t.Maybe<Array<t.Scalars['String']>>;
}>;


export type SwitchRoleMutation = (
  { __typename: 'Mutation' }
  & { switchRole: (
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId' | 'resourceType'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name' | 'tags'>
      )> }
    )> }
  ) }
);

export type UserFragmentFragment = (
  { __typename: 'User' }
  & Pick<t.User, 'user_id' | 'email' | 'name' | 'picture' | 'created_at' | 'blocked' | 'last_login' | 'logins_count' | 'last_ip' | 'given_name' | 'family_name'>
  & { identities: t.Maybe<Array<t.Maybe<(
    { __typename: 'Identity' }
    & Pick<t.Identity, 'connection' | 'isSocial'>
  )>>>, user_metadata: t.Maybe<(
    { __typename: 'UserMetadata' }
    & { info: t.Maybe<(
      { __typename: 'UserMetaDataInfo' }
      & Pick<t.UserMetaDataInfo, 'defaultInventoryView'>
    )> }
  )>, connections: t.Maybe<Array<(
    { __typename: 'Device' }
    & { connections: t.Maybe<Array<(
      { __typename: 'Device' }
      & ConnectedDeviceFragment
    )>> }
    & ConnectedDeviceFragment
  )>> }
);

export type UserByIdQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type UserByIdQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & UserFragmentFragment
    )> }
  ) }
);

export type UserDataByIdQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type UserDataByIdQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & UserDataFragment
    )> }
  ) }
);

export type RolesQueryVariables = t.Exact<{
  tags?: t.Maybe<Array<t.Scalars['String']>>;
}>;


export type RolesQuery = (
  { __typename: 'Query' }
  & { roles: Array<(
    { __typename: 'Role' }
    & Pick<t.Role, 'name'>
  )> }
);

export type TenantAccessorsQueryVariables = t.Exact<{
  params: t.AccessorSearchParams;
}>;


export type TenantAccessorsQuery = (
  { __typename: 'Query' }
  & { accessors: Array<(
    { __typename: 'Accessor' }
    & Pick<t.Accessor, 'id'>
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )> }
    )> }
  )> }
);

export type TenantQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type TenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'name' | 'type' | 'mockLicenseTenant'>
  ) }
);

export type UsersCountQueryVariables = t.Exact<{
  params: t.UserSearchParams;
}>;


export type UsersCountQuery = (
  { __typename: 'Query' }
  & { searchResult: (
    { __typename: 'UserConnection' }
    & Pick<t.UserConnection, 'count'>
  ) }
);

export type UsersListQueryVariables = t.Exact<{
  params: t.UserSearchParams;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type UsersListQuery = (
  { __typename: 'Query' }
  & { searchResult: (
    { __typename: 'UserConnection' }
    & UsersListConnectionFragment
  ) }
);

export type UsersListConnectionFragment = (
  { __typename: 'UserConnection' }
  & { total: t.UserConnection['count'] }
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
  ), searchData: Array<(
    { __typename: 'UserEdge' }
    & Pick<t.UserEdge, 'cursor'>
    & { node: (
      { __typename: 'User' }
      & UserDataFragment
    ) }
  )> }
);

export type UserDataFragment = (
  { __typename: 'User' }
  & Pick<t.User, 'user_id' | 'email' | 'name' | 'email_verified' | 'picture' | 'created_at' | 'phone_number' | 'last_login' | 'logins_count' | 'blocked'>
);

export type PendingInvitesListQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['ID']>;
}>;


export type PendingInvitesListQuery = (
  { __typename: 'Query' }
  & { userInvitesByTenant: (
    { __typename: 'UserInvitesResponse' }
    & { invites: Array<(
      { __typename: 'UserInvite' }
      & Pick<t.UserInvite, 'id' | 'email' | 'created_at' | 'tenant_id' | 'role_name'>
    )> }
  ) }
);

export type DeletePendingInviteMutationVariables = t.Exact<{
  inviteId: t.Scalars['ID'];
}>;


export type DeletePendingInviteMutation = (
  { __typename: 'Mutation' }
  & { cancelUserInvite: (
    { __typename: 'UserInviteResponse' }
    & { invite: (
      { __typename: 'UserInvite' }
      & Pick<t.UserInvite, 'id' | 'email'>
    ) }
  ) }
);

export type AudienceForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
}>;


export type AudienceForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id' | 'name'>
    & { audience: t.Maybe<(
      { __typename: 'Audience' }
      & CommonAudienceFragment
    )> }
  ) }
);

export type NcIntegrationsQueryVariables = t.Exact<{
  input?: t.Maybe<t.IntegrationsFilter>;
}>;


export type NcIntegrationsQuery = (
  { __typename: 'Query' }
  & { notificationCenter: t.Maybe<(
    { __typename: 'NotificationCenter' }
    & { integrations: Array<(
      { __typename: 'NcIntegrationConfig' }
      & Pick<t.NcIntegrationConfig, 'name'>
      & { actionConfigurations: Array<t.Maybe<(
        { __typename: 'NcIntegrationActionConfig' }
        & Pick<t.NcIntegrationActionConfig, 'allowedRates'>
        & { type: (
          { __typename: 'ActionType' }
          & Pick<t.ActionType, 'id' | 'type'>
        ) }
      )>> }
    )> }
  )> }
);

export type AudienceForUserQueryVariables = t.Exact<{
  user_id: t.Scalars['String'];
  tid: t.Scalars['ID'];
}>;


export type AudienceForUserQuery = (
  { __typename: 'Query' }
  & { ncPoly: (
    { __typename: 'PolyNotificationConfigurationQueries' }
    & { userAudience: t.Maybe<(
      { __typename: 'Audience' }
      & CommonAudienceFragment
    )> }
  ) }
);

export type EnableNotificationsForTenantMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type EnableNotificationsForTenantMutation = (
  { __typename: 'Mutation' }
  & { ncEnableTenant: (
    { __typename: 'Audience' }
    & CommonAudienceFragment
  ) }
);

export type EnableNotificationsForUserMutationVariables = t.Exact<{
  user_id: t.Scalars['String'];
  tid: t.Scalars['ID'];
}>;


export type EnableNotificationsForUserMutation = (
  { __typename: 'Mutation' }
  & { ncEnableUser: (
    { __typename: 'Audience' }
    & CommonAudienceFragment
  ) }
);

export type AddRecipientMutationVariables = t.Exact<{
  audienceId: t.Scalars['ID'];
  email: t.Scalars['Email'];
}>;


export type AddRecipientMutation = (
  { __typename: 'Mutation' }
  & { ncAddRecipient: (
    { __typename: 'Recipient' }
    & Pick<t.Recipient, 'id' | 'confirmed' | 'email'>
  ) }
);

export type RemoveRecipientMutationVariables = t.Exact<{
  recipientId: t.Scalars['ID'];
  audienceId: t.Scalars['ID'];
}>;


export type RemoveRecipientMutation = (
  { __typename: 'Mutation' }
  & { ncRemoveRecipient: (
    { __typename: 'Audience' }
    & CommonAudienceFragment
  ) }
);

export type DisableNotificationsForTenantMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DisableNotificationsForTenantMutation = (
  { __typename: 'Mutation' }
  & { ncDisableTenant: (
    { __typename: 'Audience' }
    & Pick<t.Audience, 'id' | 'enabled'>
  ) }
);

export type DisableNotificationsForUserMutationVariables = t.Exact<{
  user_id: t.Scalars['String'];
  tid: t.Scalars['ID'];
}>;


export type DisableNotificationsForUserMutation = (
  { __typename: 'Mutation' }
  & { ncDisableUser: (
    { __typename: 'Audience' }
    & Pick<t.Audience, 'id' | 'enabled'>
  ) }
);

export type EnableActionMutationVariables = t.Exact<{
  actionId: t.Scalars['ID'];
  audienceId: t.Scalars['ID'];
}>;


export type EnableActionMutation = (
  { __typename: 'Mutation' }
  & { ncEnableAction: (
    { __typename: 'ActionConfiguration' }
    & CommonActionConfigurationsFragment
  ) }
);

export type DisableActionMutationVariables = t.Exact<{
  actionId: t.Scalars['ID'];
  audienceId: t.Scalars['ID'];
}>;


export type DisableActionMutation = (
  { __typename: 'Mutation' }
  & { ncDisableAction: (
    { __typename: 'ActionConfiguration' }
    & CommonActionConfigurationsFragment
  ) }
);

export type SetActionFrequencyMutationVariables = t.Exact<{
  actionId: t.Scalars['ID'];
  rate: t.Rate;
}>;


export type SetActionFrequencyMutation = (
  { __typename: 'Mutation' }
  & { ncSetFrequency: (
    { __typename: 'ActionConfiguration' }
    & CommonActionConfigurationsFragment
  ) }
);

export type UnsubscribeMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type UnsubscribeMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'ncUnsubscribe'>
);

export type ConfirmEmailMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type ConfirmEmailMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'ncConfirmEmail'>
);

export type CommonAudienceFragment = (
  { __typename: 'Audience' }
  & Pick<t.Audience, 'id' | 'enabled'>
  & { recipients: Array<(
    { __typename: 'Recipient' }
    & Pick<t.Recipient, 'id' | 'confirmed' | 'email'>
  )>, actionConfigurations: Array<(
    { __typename: 'ActionConfiguration' }
    & CommonActionConfigurationsFragment
  )> }
);

export type CommonActionConfigurationsFragment = (
  { __typename: 'ActionConfiguration' }
  & Pick<t.ActionConfiguration, 'id' | 'enabled' | 'rate' | 'allowedRates'>
  & { actionType: (
    { __typename: 'ActionType' }
    & Pick<t.ActionType, 'id' | 'type'>
  ) }
);

export type ServiceNowHookPageFragment = (
  { __typename: 'ServiceNowWebhook' }
  & Pick<t.ServiceNowWebhook, 'enabled' | 'id' | 'name' | 'url' | 'username'>
  & { lastErrorBody: t.ServiceNowWebhook['last_error_body'], lastErrorMessage: t.ServiceNowWebhook['last_error_message'], lastErrorStatusCode: t.ServiceNowWebhook['last_error_status_code'], lastErrorTime: t.ServiceNowWebhook['last_error_time'], succeedingSince: t.ServiceNowWebhook['succeeding_since'] }
  & { actionConfigurations: Array<(
    { __typename: 'ServiceNowActionConfiguration' }
    & Pick<t.ServiceNowActionConfiguration, 'allowedRates' | 'enabled' | 'id' | 'rate'>
    & { actionType: (
      { __typename: 'ActionType' }
      & Pick<t.ActionType, 'id' | 'type'>
    ) }
  )> }
);

export type ServiceNowHooksForTenantQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type ServiceNowHooksForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { serviceNowWebhooks: Array<(
      { __typename: 'ServiceNowWebhook' }
      & ServiceNowHookPageFragment
    )> }
  ) }
);

export type GetServiceNowHookQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type GetServiceNowHookQuery = (
  { __typename: 'Query' }
  & { ncServiceNow: (
    { __typename: 'NcServiceNowQueries' }
    & { webhook: t.Maybe<(
      { __typename: 'ServiceNowWebhook' }
      & ServiceNowHookPageFragment
    )> }
  ) }
);

export type CreateServiceNowWebhookForTenantMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  input: t.CreateServiceNowInput;
}>;


export type CreateServiceNowWebhookForTenantMutation = (
  { __typename: 'Mutation' }
  & { ncCreateServiceNowWebhook: (
    { __typename: 'ServiceNowWebhook' }
    & ServiceNowHookPageFragment
  ) }
);

export type EnableServiceNowHookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type EnableServiceNowHookMutation = (
  { __typename: 'Mutation' }
  & { ncEnableServiceNowWebhook: (
    { __typename: 'ServiceNowWebhook' }
    & Pick<t.ServiceNowWebhook, 'id' | 'enabled'>
  ) }
);

export type DisableServiceNowHookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DisableServiceNowHookMutation = (
  { __typename: 'Mutation' }
  & { ncDisableServiceNowWebhook: (
    { __typename: 'ServiceNowWebhook' }
    & Pick<t.ServiceNowWebhook, 'id' | 'enabled'>
  ) }
);

export type UpdateServiceNowWebhookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  input: t.UpdateServiceNowWebhook;
}>;


export type UpdateServiceNowWebhookMutation = (
  { __typename: 'Mutation' }
  & { ncUpdateServiceNowWebhook: (
    { __typename: 'ServiceNowWebhook' }
    & ServiceNowHookPageFragment
  ) }
);

export type DeleteServiceNowWebhookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DeleteServiceNowWebhookMutation = (
  { __typename: 'Mutation' }
  & { ncDeleteServiceNowWebhook: (
    { __typename: 'Tenant' }
    & { serviceNowWebhooks: Array<(
      { __typename: 'ServiceNowWebhook' }
      & ServiceNowHookPageFragment
    )> }
  ) }
);

export type TestNewServiceNowWebhookMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  password: t.Scalars['String'];
  url: t.Scalars['URL'];
  username: t.Scalars['String'];
}>;


export type TestNewServiceNowWebhookMutation = (
  { __typename: 'Mutation' }
  & { ncTestServiceNowWebhookWithParams: (
    { __typename: 'HookTestResult' }
    & Pick<t.HookTestResult, 'statusCode' | 'body' | 'statusMessage'>
  ) }
);

export type TestServiceNowWebhookByIdMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type TestServiceNowWebhookByIdMutation = (
  { __typename: 'Mutation' }
  & { ncTestServiceNowWebhook: (
    { __typename: 'HookTestResult' }
    & Pick<t.HookTestResult, 'statusCode' | 'body' | 'statusMessage'>
  ) }
);

export type UpdateServiceNowActionConfigurationMutationVariables = t.Exact<{
  input: t.NcUpdateServiceNowWebhookAction;
}>;


export type UpdateServiceNowActionConfigurationMutation = (
  { __typename: 'Mutation' }
  & { ncUpdateServiceNowActionConfiguration: (
    { __typename: 'ServiceNowActionConfiguration' }
    & Pick<t.ServiceNowActionConfiguration, 'id' | 'enabled' | 'rate'>
  ) }
);

export type CreateTeamsWebhookForTenantMutationVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  input?: t.Maybe<t.CreateWebhook>;
}>;


export type CreateTeamsWebhookForTenantMutation = (
  { __typename: 'Mutation' }
  & { ncCreateTeamsWebhookForTenant: (
    { __typename: 'TeamsHook' }
    & TeamsHookPageFragment
  ) }
);

export type EnableTeamsHookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type EnableTeamsHookMutation = (
  { __typename: 'Mutation' }
  & { ncEnableTeamsWebhook: (
    { __typename: 'TeamsHook' }
    & Pick<t.TeamsHook, 'id' | 'enabled'>
  ) }
);

export type DisableTeamsHookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DisableTeamsHookMutation = (
  { __typename: 'Mutation' }
  & { ncDisableTeamsWebhook: (
    { __typename: 'TeamsHook' }
    & Pick<t.TeamsHook, 'id' | 'enabled'>
  ) }
);

export type TeamsHookPageFragment = (
  { __typename: 'TeamsHook' }
  & Pick<t.TeamsHook, 'id' | 'name' | 'url' | 'enabled'>
  & { actionConfigurations: Array<(
    { __typename: 'TeamsWebhookActionConfiguration' }
    & Pick<t.TeamsWebhookActionConfiguration, 'id' | 'enabled' | 'rate' | 'allowedRates'>
    & { actionType: (
      { __typename: 'ActionType' }
      & Pick<t.ActionType, 'id' | 'type'>
    ) }
  )> }
);

export type UpdateTeamsWebhookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  input: t.CreateWebhook;
}>;


export type UpdateTeamsWebhookMutation = (
  { __typename: 'Mutation' }
  & { ncUpdateTeamsWebhook: (
    { __typename: 'TeamsHook' }
    & TeamsHookPageFragment
  ) }
);

export type DeleteTeamsWebhookMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DeleteTeamsWebhookMutation = (
  { __typename: 'Mutation' }
  & { ncDeleteTeamsWebhook: (
    { __typename: 'Tenant' }
    & { teamsWebhooks: Array<(
      { __typename: 'TeamsHook' }
      & TeamsHookPageFragment
    )> }
  ) }
);

export type UpdateTeamsActionConfigurationMutationVariables = t.Exact<{
  input: t.NcUpdateTeamsWebhookAction;
}>;


export type UpdateTeamsActionConfigurationMutation = (
  { __typename: 'Mutation' }
  & { ncUpdateWebhookActionConfiguration: (
    { __typename: 'TeamsWebhookActionConfiguration' }
    & Pick<t.TeamsWebhookActionConfiguration, 'id' | 'enabled' | 'rate'>
  ) }
);

export type TestTeamsWebhookByIdMutationVariables = t.Exact<{
  id?: t.Maybe<t.Scalars['ID']>;
  url?: t.Maybe<t.Scalars['URL']>;
}>;


export type TestTeamsWebhookByIdMutation = (
  { __typename: 'Mutation' }
  & { ncTestTeamsWebhook: (
    { __typename: 'HookTestResult' }
    & Pick<t.HookTestResult, 'success' | 'code' | 'message'>
  ) }
);

export type GetTeamsHookQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type GetTeamsHookQuery = (
  { __typename: 'Query' }
  & { ncTeams: (
    { __typename: 'NcTeamsQueries' }
    & { webhook: t.Maybe<(
      { __typename: 'TeamsHook' }
      & TeamsHookPageFragment
    )> }
  ) }
);

export type TeamsHooksForTenantQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type TeamsHooksForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { teamsWebhooks: Array<(
      { __typename: 'TeamsHook' }
      & TeamsHookPageFragment
    )> }
  ) }
);

export type AvailableRelaySoftwareOvaQueryVariables = t.Exact<{
  releaseChannel?: t.Maybe<t.Scalars['String']>;
}>;


export type AvailableRelaySoftwareOvaQuery = (
  { __typename: 'Query' }
  & { availableProductSoftwareByPid: t.Maybe<(
    { __typename: 'ProductSoftware' }
    & Pick<t.ProductSoftware, 'id'>
    & { productBuild: t.Maybe<(
      { __typename: 'ProductBuild' }
      & Pick<t.ProductBuild, 'build' | 'archiveUrl'>
      & { tags: Array<(
        { __typename: 'ProductBuildTag' }
        & Pick<t.ProductBuildTag, 'name' | 'value'>
      )> }
    )>, product: t.Maybe<(
      { __typename: 'HardwareProduct' }
      & Pick<t.HardwareProduct, 'id'>
    )> }
  )> }
);

export type AvailableRelaySoftwareVhdQueryVariables = t.Exact<{
  releaseChannel?: t.Maybe<t.Scalars['String']>;
}>;


export type AvailableRelaySoftwareVhdQuery = (
  { __typename: 'Query' }
  & { availableProductSoftwareByPid: t.Maybe<(
    { __typename: 'ProductSoftware' }
    & Pick<t.ProductSoftware, 'id'>
    & { productBuild: t.Maybe<(
      { __typename: 'ProductBuild' }
      & Pick<t.ProductBuild, 'build' | 'archiveUrl'>
      & { tags: Array<(
        { __typename: 'ProductBuildTag' }
        & Pick<t.ProductBuildTag, 'name' | 'value'>
      )> }
    )>, product: t.Maybe<(
      { __typename: 'HardwareProduct' }
      & Pick<t.HardwareProduct, 'id'>
    )> }
  )> }
);

export type CreateRegisteredEdgeDeviceMutationVariables = t.Exact<{
  device: t.CreateRegisteredDeviceRequest;
}>;


export type CreateRegisteredEdgeDeviceMutation = (
  { __typename: 'Mutation' }
  & { createRegisteredEdgeDevice: (
    { __typename: 'CreateRegisteredDeviceResponse' }
    & Pick<t.CreateRegisteredDeviceResponse, 'success' | 'error' | 'isEdgeDevice' | 'deviceId' | 'deviceKey'>
  ) }
);

export type AccountDetailFragment = (
  { __typename: 'ProvisioningAccount' }
  & Pick<t.ProvisioningAccount, 'uuid' | 'username' | 'password' | 'description' | 'type' | 'isDisabled' | 'downloadPath' | 'provisioningUri'>
);

export type ProvisioningAccountsQueryVariables = t.Exact<{
  tenantUuid?: t.Maybe<t.Scalars['String']>;
}>;


export type ProvisioningAccountsQuery = (
  { __typename: 'Query' }
  & { getProvisioningAccounts: t.Maybe<Array<t.Maybe<(
    { __typename: 'ProvisioningAccount' }
    & AccountDetailFragment
  )>>> }
);

export type UpdateProvisioningAccountMutationVariables = t.Exact<{
  tenantUuid?: t.Maybe<t.Scalars['String']>;
  account?: t.Maybe<t.ProvisioningAccountIn>;
}>;


export type UpdateProvisioningAccountMutation = (
  { __typename: 'Mutation' }
  & { updateProvisioningAccount: t.Maybe<(
    { __typename: 'ProvisioningAccount' }
    & AccountDetailFragment
  )> }
);

export type ConfigurationQueryVariables = t.Exact<{ [key: string]: never; }>;


export type ConfigurationQuery = (
  { __typename: 'Query' }
  & { getConfiguration: t.Maybe<(
    { __typename: 'TenantManagementConfiguration' }
    & Pick<t.TenantManagementConfiguration, 'tenantSyncPeriod'>
  )> }
);

export type TenantUserPermisionsQueryVariables = t.Exact<{
  userId: t.Scalars['ID'];
  tags?: t.Maybe<Array<t.Scalars['String']>>;
}>;


export type TenantUserPermisionsQuery = (
  { __typename: 'Query' }
  & { accessor: t.Maybe<(
    { __typename: 'Accessor' }
    & { grants: Array<(
      { __typename: 'Grant' }
      & PermisionsGrantsFragment
    )> }
  )>, roles: Array<(
    { __typename: 'Role' }
    & PermisionRolesFragment
  )> }
);

export type DevicesForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type DevicesForTenantQuery = (
  { __typename: 'Query' }
  & { deviceCount: t.Query['countDevices'] }
  & { models: Array<(
    { __typename: 'Aggregate' }
    & Pick<t.Aggregate, 'field'>
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & Pick<t.FieldMissingBucket, 'count'>
    ) | (
      { __typename: 'KeyBucket' }
      & Pick<t.KeyBucket, 'key' | 'count'>
    ) | (
      { __typename: 'RangeBucket' }
      & Pick<t.RangeBucket, 'count'>
    )> }
  )> }
);

export type SiteForTenantFragment = (
  { __typename: 'Site' }
  & Pick<t.Site, 'id' | 'name'>
  & { rooms: Array<(
    { __typename: 'Room' }
    & Pick<t.Room, 'id' | 'name'>
    & { devices: t.Maybe<Array<(
      { __typename: 'Device' }
      & RoomDeviceFragment
    )>> }
  )>, address: t.Maybe<(
    { __typename: 'Address' }
    & Pick<t.Address, 'city' | 'region' | 'country'>
  )> }
);

export type RoomForTenantFragment = (
  { __typename: 'Room' }
  & Pick<t.Room, 'id' | 'name'>
  & { devices: t.Maybe<Array<(
    { __typename: 'Device' }
    & RoomDeviceFragment
  )>> }
);

export type SitesForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type SitesForTenantQuery = (
  { __typename: 'Query' }
  & { sites: Array<(
    { __typename: 'Site' }
    & SiteForTenantFragment
  )> }
);

export type UsersForTenantByRoleQueryVariables = t.Exact<{
  params: t.UserSearchParams;
}>;


export type UsersForTenantByRoleQuery = (
  { __typename: 'Query' }
  & { users: (
    { __typename: 'UserConnection' }
    & Pick<t.UserConnection, 'count'>
  ) }
);

export type DevicesAtSiteQueryVariables = t.Exact<{
  siteId: t.Scalars['String'];
}>;


export type DevicesAtSiteQuery = (
  { __typename: 'Query' }
  & { count: t.Query['countDevices'] }
);

export type ImportMutationVariables = t.Exact<{
  fileName: t.Scalars['String'];
  file: t.Scalars['String'];
  tenantId: t.Scalars['String'];
  importType: t.Scalars['String'];
  updateExistingDevices?: t.Maybe<t.Scalars['Boolean']>;
  overwriteDeviceRecords?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type ImportMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'importToLens'>
);

export type GetImportReportQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type GetImportReportQuery = (
  { __typename: 'Query' }
  & { getImportReport: t.Maybe<(
    { __typename: 'ImportResponse' }
    & Pick<t.ImportResponse, 'progress' | 'success' | 'errors'>
    & { deviceConfigResult: t.Maybe<Array<t.Maybe<(
      { __typename: 'DeviceImportResponse' }
      & Pick<t.DeviceImportResponse, 'deviceId' | 'deviceModel' | 'deviceReport'>
    )>>>, siteTopologyResult: t.Maybe<Array<t.Maybe<(
      { __typename: 'SiteTopologyResponse' }
      & Pick<t.SiteTopologyResponse, 'siteName' | 'siteTopologyErrors'>
    )>>>, siteConfigResult: t.Maybe<Array<t.Maybe<(
      { __typename: 'SiteConfigResponse' }
      & Pick<t.SiteConfigResponse, 'siteConfigError' | 'siteName'>
      & { siteConfigSettings: t.Maybe<Array<t.Maybe<(
        { __typename: 'ModelConfigSettingsResponse' }
        & Pick<t.ModelConfigSettingsResponse, 'deviceModel' | 'configAttributes'>
      )>>> }
    )>>>, groupConfigResult: t.Maybe<Array<t.Maybe<(
      { __typename: 'GroupConfigResponse' }
      & Pick<t.GroupConfigResponse, 'groupName'>
      & { groupConfigSettings: t.Maybe<Array<t.Maybe<(
        { __typename: 'ModelConfigSettingsResponse' }
        & Pick<t.ModelConfigSettingsResponse, 'deviceModel' | 'configAttributes'>
      )>>> }
    )>>>, globalConfigResult: t.Maybe<Array<t.Maybe<(
      { __typename: 'GlobalConfigResponse' }
      & Pick<t.GlobalConfigResponse, 'deviceModel' | 'globalConfigSettings'>
    )>>> }
  )> }
);

export type UpdateUserInfoMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  user: t.Auth0UserUpdateData;
}>;


export type UpdateUserInfoMutation = (
  { __typename: 'Mutation' }
  & { updateUser: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & Pick<t.User, 'user_id'>
    )> }
  ) }
);

export type GetTrialSubscriptionQueryVariables = t.Exact<{ [key: string]: never; }>;


export type GetTrialSubscriptionQuery = (
  { __typename: 'Query' }
  & { getTrialSubscription: t.Maybe<(
    { __typename: 'ClaritiTrialUserSubscription' }
    & TrialUserSubscriptionDataFragment
  )> }
);

export type CreateTrialSubscriptionMutationVariables = t.Exact<{ [key: string]: never; }>;


export type CreateTrialSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { createTrialSubscription: (
    { __typename: 'ClaritiTrialUserSubscription' }
    & TrialUserSubscriptionDataFragment
  ) }
);

export type TrialUserSubscriptionDataFragment = (
  { __typename: 'ClaritiTrialUserSubscription' }
  & Pick<t.ClaritiTrialUserSubscription, 'id' | 'meetingUrl' | 'meetingRoomId'>
);

export type GetTrialSubscriptionListQueryVariables = t.Exact<{
  params: t.ClaritiTrialSubscriptionReportConnectionParams;
}>;


export type GetTrialSubscriptionListQuery = (
  { __typename: 'Query' }
  & { getTrialSubscriptions: (
    { __typename: 'ClaritiTrialSubscriptionReportConnection' }
    & TrialSubscriptionReportDataConnectionFragment
  ) }
);

export type DeleteTrialSubscriptionMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type DeleteTrialSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { deleteTrialSubscription: (
    { __typename: 'ClaritiTrialDeleteSubscriptionReportResponse' }
    & Pick<t.ClaritiTrialDeleteSubscriptionReportResponse, 'id'>
  ) }
);

export type TrialSubscriptionReportDataConnectionFragment = (
  { __typename: 'ClaritiTrialSubscriptionReportConnection' }
  & Pick<t.ClaritiTrialSubscriptionReportConnection, 'total'>
  & { pageInfo: (
    { __typename: 'PageInformation' }
    & Pick<t.PageInformation, 'hasNextPage' | 'endCursor'>
  ), edges: t.Maybe<Array<(
    { __typename: 'ClaritiTrialSubscriptionReportConnectionEdge' }
    & TrialSubscriptionReportDataEdgeFragment
  )>> }
);

export type TrialSubscriptionReportDataEdgeFragment = (
  { __typename: 'ClaritiTrialSubscriptionReportConnectionEdge' }
  & Pick<t.ClaritiTrialSubscriptionReportConnectionEdge, 'cursor'>
  & { node: (
    { __typename: 'ClaritiTrialSubscriptionReport' }
    & TrialSubscriptionReportDataFragment
  ) }
);

export type TrialSubscriptionReportDataFragment = (
  { __typename: 'ClaritiTrialSubscriptionReport' }
  & Pick<t.ClaritiTrialSubscriptionReport, 'aboutToExpireEmailSent' | 'browserType' | 'createdAt' | 'eulaAcceptanceDate' | 'eulaAccepted' | 'expired' | 'id' | 'latestUse' | 'meetingRoomId' | 'meetingUrl' | 'subscriptionDate' | 'subscriptionExpiredEmailSent' | 'welcomeEmailSent'>
  & { usageStats: (
    { __typename: 'ClaritiTrialUsageStats' }
    & TrialUsageStatsDataFragment
  ), user: t.Maybe<(
    { __typename: 'ClaritiTrialUserInfo' }
    & TrialUserInfoDataFragment
  )> }
);

export type TrialUsageStatsDataFragment = (
  { __typename: 'ClaritiTrialUsageStats' }
  & Pick<t.ClaritiTrialUsageStats, 'averageNumberOfParticipants' | 'conferencesUsageCounter' | 'maxNumberOfParticipants' | 'minNumberOfParticipants' | 'totalDurationMinutes' | 'totalNumberOfParticipants'>
  & { conferenceReports: t.Maybe<Array<(
    { __typename: 'ClaritiTrialConferenceReport' }
    & TrialConferenceReportDataFragment
  )>> }
);

export type TrialUserInfoDataFragment = (
  { __typename: 'ClaritiTrialUserInfo' }
  & Pick<t.ClaritiTrialUserInfo, 'email' | 'familyName' | 'givenName' | 'name'>
);

export type TrialConferenceReportDataFragment = (
  { __typename: 'ClaritiTrialConferenceReport' }
  & Pick<t.ClaritiTrialConferenceReport, 'conferenceIdentifier' | 'conferenceRoomIdentifier' | 'endTime' | 'entityTag' | 'hostName' | 'id' | 'numberOfParticipants' | 'participantsDetails' | 'startTime' | 'subscriptionReportId'>
);

export type CreateTenantMutationVariables = t.Exact<{
  input: t.CreateTenantInput;
}>;


export type CreateTenantMutation = (
  { __typename: 'Mutation' }
  & { createTenant: (
    { __typename: 'TenantResponse' }
    & { tenant: (
      { __typename: 'Tenant' }
      & Pick<t.Tenant, 'id' | 'name'>
    ) }
  ) }
);

export type UpdateUserMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  data: t.Auth0UserUpdateData;
}>;


export type UpdateUserMutation = (
  { __typename: 'Mutation' }
  & { updateUser: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & Pick<t.User, 'given_name' | 'family_name' | 'user_id' | 'name'>
    )> }
  ) }
);

export type AvailableProductSoftwareByPidQueryVariables = t.Exact<{
  pidWindows: t.Scalars['ID'];
  pidMac: t.Scalars['ID'];
}>;


export type AvailableProductSoftwareByPidQuery = (
  { __typename: 'Query' }
  & { windows: t.Maybe<(
    { __typename: 'ProductSoftware' }
    & Pick<t.ProductSoftware, 'id' | 'releaseChannel' | 'publishDate'>
    & { productBuild: t.Maybe<(
      { __typename: 'ProductBuild' }
      & Pick<t.ProductBuild, 'version' | 'build' | 'archiveUrl'>
    )> }
  )>, mac: t.Maybe<(
    { __typename: 'ProductSoftware' }
    & Pick<t.ProductSoftware, 'id' | 'releaseChannel' | 'publishDate'>
    & { productBuild: t.Maybe<(
      { __typename: 'ProductBuild' }
      & Pick<t.ProductBuild, 'version' | 'build' | 'archiveUrl'>
    )> }
  )> }
);

export type DeviceCountsQueryVariables = t.Exact<{
  filter?: t.Maybe<t.Filter>;
  aggregations?: t.Maybe<Array<t.Maybe<t.Aggregation>>>;
}>;


export type DeviceCountsQuery = (
  { __typename: 'Query' }
  & { deviceAggregations: Array<(
    { __typename: 'Aggregate' }
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & { aggregates: Array<(
        { __typename: 'Aggregate' }
        & AggregateFieldsFragment
      )> }
    ) | (
      { __typename: 'KeyBucket' }
      & { aggregates: Array<(
        { __typename: 'Aggregate' }
        & AggregateFieldsFragment
      )> }
    ) | (
      { __typename: 'RangeBucket' }
      & { aggregates: Array<(
        { __typename: 'Aggregate' }
        & AggregateFieldsFragment
      )> }
    )> }
    & AggregateFieldsFragment
  )> }
);

export type AggregateFieldsFragment = (
  { __typename: 'Aggregate' }
  & Pick<t.Aggregate, 'field'>
  & { buckets: Array<(
    { __typename: 'FieldMissingBucket' }
    & Pick<t.FieldMissingBucket, 'fieldMissing' | 'count'>
  ) | (
    { __typename: 'KeyBucket' }
    & Pick<t.KeyBucket, 'key' | 'count'>
  ) | (
    { __typename: 'RangeBucket' }
    & Pick<t.RangeBucket, 'count'>
  )> }
);

export type TopicsQueryVariables = t.Exact<{ [key: string]: never; }>;


export type TopicsQuery = (
  { __typename: 'Query' }
  & { topics: Array<(
    { __typename: 'Topic' }
    & Pick<t.Topic, 'id' | 'category' | 'validLocationScopes'>
  )> }
);

export type ChartFieldsFragment = (
  { __typename: 'Chart' }
  & { meta: (
    { __typename: 'InsightChartMeta' }
    & ChartMetaFields_InsightChartMeta_Fragment
  ) | (
    { __typename: 'MeetingRecordAggregateChartMeta' }
    & ChartMetaFields_MeetingRecordAggregateChartMeta_Fragment
  ), series: Array<(
    { __typename: 'Series' }
    & Pick<t.Series, 'name'>
    & { meta: (
      { __typename: 'InsightSeriesMeta' }
      & SeriesMetaFields_InsightSeriesMeta_Fragment
    ) | (
      { __typename: 'MeetingRecordAggregateSeriesMeta' }
      & SeriesMetaFields_MeetingRecordAggregateSeriesMeta_Fragment
    ), data: t.Maybe<Array<(
      { __typename: 'Point' }
      & Pick<t.Point, 'x' | 'y'>
    )>> }
  )> }
);

type ChartMetaFields_InsightChartMeta_Fragment = (
  { __typename: 'InsightChartMeta' }
  & InsightChartMetaFieldsFragment
);

type ChartMetaFields_MeetingRecordAggregateChartMeta_Fragment = (
  { __typename: 'MeetingRecordAggregateChartMeta' }
  & MeetingRecordAggregateChartMetaFieldsFragment
);

export type ChartMetaFieldsFragment = ChartMetaFields_InsightChartMeta_Fragment | ChartMetaFields_MeetingRecordAggregateChartMeta_Fragment;

export type InsightChartMetaFieldsFragment = (
  { __typename: 'InsightChartMeta' }
  & Pick<t.InsightChartMeta, 'topic' | 'aggType' | 'timeScope' | 'increment' | 'childCount' | 'otherCount'>
);

export type MeetingRecordAggregateChartMetaFieldsFragment = (
  { __typename: 'MeetingRecordAggregateChartMeta' }
  & Pick<t.MeetingRecordAggregateChartMeta, 'test'>
);

type SeriesMetaFields_InsightSeriesMeta_Fragment = (
  { __typename: 'InsightSeriesMeta' }
  & InsightSeriesMetaFieldsFragment
);

type SeriesMetaFields_MeetingRecordAggregateSeriesMeta_Fragment = (
  { __typename: 'MeetingRecordAggregateSeriesMeta' }
  & MeetingRecordAggregateSeriesMetaFieldsFragment
);

export type SeriesMetaFieldsFragment = SeriesMetaFields_InsightSeriesMeta_Fragment | SeriesMetaFields_MeetingRecordAggregateSeriesMeta_Fragment;

export type InsightSeriesMetaFieldsFragment = (
  { __typename: 'InsightSeriesMeta' }
  & Pick<t.InsightSeriesMeta, 'seriesType' | 'locationScope'>
  & { object: t.Maybe<(
    { __typename: 'Device' }
    & Pick<t.Device, 'id'>
    & { deviceName: t.Device['name'] }
  ) | (
    { __typename: 'Other' }
    & Pick<t.Other, 'id'>
  ) | (
    { __typename: 'Room' }
    & Pick<t.Room, 'id'>
    & { roomName: t.Room['name'] }
  ) | (
    { __typename: 'Site' }
    & Pick<t.Site, 'id'>
    & { siteName: t.Site['name'] }
  ) | (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { tenantName: t.Tenant['name'] }
  )> }
);

export type MeetingRecordAggregateSeriesMetaFieldsFragment = (
  { __typename: 'MeetingRecordAggregateSeriesMeta' }
  & Pick<t.MeetingRecordAggregateSeriesMeta, 'test'>
);

export type ChartsQueryVariables = t.Exact<{
  tenantId: Array<t.Scalars['String']>;
  locationScope: t.LocationScope;
  timeScope: t.TimeScope;
  timeStart: t.Scalars['Date'];
  topic: t.Scalars['ID'];
  id: t.Scalars['ID'];
}>;


export type ChartsQuery = (
  { __typename: 'Query' }
  & { charts: t.Maybe<(
    { __typename: 'Chart' }
    & ChartFieldsFragment
  )> }
);

export type DetailFieldsFragment = (
  { __typename: 'TopicIndicator' }
  & Pick<t.TopicIndicator, 'id' | 'type' | 'timeScope' | 'locationScope' | 'timePeriodStart' | 'deviceType' | 'model' | 'version' | 'modelVersion' | 'family' | 'trendingUpward' | 'tenantAverage' | 'tenantPercentile' | 'globalAverage' | 'globalPercentile' | 'previousTenantPercentile' | 'previousGlobalPercentile'>
  & { topic: (
    { __typename: 'Topic' }
    & Pick<t.Topic, 'id' | 'type' | 'higherIsBetter' | 'category'>
  ), room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'name' | 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'name' | 'id'>
  )>, tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'name' | 'id'>
  ), device: t.Maybe<(
    { __typename: 'Device' }
    & Pick<t.Device, 'name' | 'id'>
  )>, indicator: (
    { __typename: 'AverageIndicator' }
    & Pick<t.AverageIndicator, 'average'>
  ) | (
    { __typename: 'CountAverageIndicator' }
    & Pick<t.CountAverageIndicator, 'count' | 'average'>
  ) | (
    { __typename: 'CountOfTotalIndicator' }
    & Pick<t.CountOfTotalIndicator, 'count' | 'total' | 'percentage'>
  ), previous: t.Maybe<(
    { __typename: 'AverageIndicator' }
    & Pick<t.AverageIndicator, 'average'>
  ) | (
    { __typename: 'CountAverageIndicator' }
    & Pick<t.CountAverageIndicator, 'count' | 'average'>
  ) | (
    { __typename: 'CountOfTotalIndicator' }
    & Pick<t.CountOfTotalIndicator, 'count' | 'total' | 'percentage'>
  )> }
);

export type InsightDetailsFragment = (
  { __typename: 'TopicIndicator' }
  & { recommendedDetail: t.Maybe<(
    { __typename: 'TopicIndicatorDetail' }
    & Pick<t.TopicIndicatorDetail, 'locationScope'>
    & { connection: (
      { __typename: 'TopicIndicatorConnection' }
      & Pick<t.TopicIndicatorConnection, 'count'>
      & { edges: Array<(
        { __typename: 'TopicIndicatorEdge' }
        & { node: (
          { __typename: 'TopicIndicator' }
          & DetailFieldsFragment
        ) }
      )> }
    ) }
  )> }
  & DetailFieldsFragment
);

export type NodeDetailsQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
  tenant: Array<t.Scalars['String']>;
}>;


export type NodeDetailsQuery = (
  { __typename: 'Query' }
  & { nodeDetail: t.Maybe<(
    { __typename: 'Topic' }
    & Pick<t.Topic, 'id'>
  ) | (
    { __typename: 'TopicIndicator' }
    & Pick<t.TopicIndicator, 'id'>
    & InsightDetailsFragment
  )> }
);

export type SimilarInsightsFragment = (
  { __typename: 'TopicIndicator' }
  & Pick<t.TopicIndicator, 'id' | 'type' | 'timeScope' | 'locationScope' | 'deviceType' | 'model' | 'version' | 'modelVersion' | 'family' | 'timePeriodStart'>
  & { topic: (
    { __typename: 'Topic' }
    & Pick<t.Topic, 'id' | 'type' | 'higherIsBetter'>
  ), device: t.Maybe<(
    { __typename: 'Device' }
    & Pick<t.Device, 'name' | 'id'>
  )>, room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'name' | 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'name' | 'id'>
  )>, tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'name' | 'id'>
  ), indicator: (
    { __typename: 'AverageIndicator' }
    & Pick<t.AverageIndicator, 'average'>
  ) | (
    { __typename: 'CountAverageIndicator' }
    & Pick<t.CountAverageIndicator, 'count' | 'average'>
  ) | (
    { __typename: 'CountOfTotalIndicator' }
    & Pick<t.CountOfTotalIndicator, 'count' | 'total' | 'percentage'>
  ) }
);

export type SimilarTopicIndicatorsQueryVariables = t.Exact<{
  tenant: Array<t.Scalars['String']>;
  input?: t.Maybe<t.QueryTopicIndicatorInput>;
}>;


export type SimilarTopicIndicatorsQuery = (
  { __typename: 'Query' }
  & { similar: (
    { __typename: 'TopicIndicatorConnection' }
    & { edges: Array<(
      { __typename: 'TopicIndicatorEdge' }
      & { node: (
        { __typename: 'TopicIndicator' }
        & SimilarInsightsFragment
      ) }
    )> }
  ) }
);

export type ContinuingPageFragment = (
  { __typename: 'PageInfo' }
  & Pick<t.PageInfo, 'endCursor' | 'hasNextPage'>
);

type AllIndicators_AverageIndicator_Fragment = (
  { __typename: 'AverageIndicator' }
  & Pick<t.AverageIndicator, 'average'>
);

type AllIndicators_CountAverageIndicator_Fragment = (
  { __typename: 'CountAverageIndicator' }
  & Pick<t.CountAverageIndicator, 'count' | 'average'>
);

type AllIndicators_CountOfTotalIndicator_Fragment = (
  { __typename: 'CountOfTotalIndicator' }
  & Pick<t.CountOfTotalIndicator, 'count' | 'total' | 'percentage'>
);

export type AllIndicatorsFragment = AllIndicators_AverageIndicator_Fragment | AllIndicators_CountAverageIndicator_Fragment | AllIndicators_CountOfTotalIndicator_Fragment;

export type PriorityFieldsFragment = (
  { __typename: 'TopicIndicator' }
  & Pick<t.TopicIndicator, 'id' | 'type' | 'timeScope' | 'locationScope' | 'timePeriodStart' | 'deviceType' | 'model' | 'version' | 'modelVersion' | 'family' | 'trendingUpward' | 'notability'>
  & { topic: (
    { __typename: 'Topic' }
    & Pick<t.Topic, 'id' | 'higherIsBetter' | 'category'>
  ), room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'name' | 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'name' | 'id'>
  )>, tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'name' | 'id'>
  ), device: t.Maybe<(
    { __typename: 'Device' }
    & Pick<t.Device, 'name' | 'id'>
  )>, indicator: (
    { __typename: 'AverageIndicator' }
    & AllIndicators_AverageIndicator_Fragment
  ) | (
    { __typename: 'CountAverageIndicator' }
    & AllIndicators_CountAverageIndicator_Fragment
  ) | (
    { __typename: 'CountOfTotalIndicator' }
    & AllIndicators_CountOfTotalIndicator_Fragment
  ), previous: t.Maybe<(
    { __typename: 'AverageIndicator' }
    & AllIndicators_AverageIndicator_Fragment
  ) | (
    { __typename: 'CountAverageIndicator' }
    & AllIndicators_CountAverageIndicator_Fragment
  ) | (
    { __typename: 'CountOfTotalIndicator' }
    & AllIndicators_CountOfTotalIndicator_Fragment
  )> }
);

export type PriorityFieldsNonFederatedFragment = (
  { __typename: 'TopicIndicator' }
  & { topic: (
    { __typename: 'Topic' }
    & Pick<t.Topic, 'higherIsBetter'>
  ) }
);

export type PaginatedIndicatorsFragment = (
  { __typename: 'TopicIndicatorConnection' }
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & ContinuingPageFragment
  ), edges: Array<(
    { __typename: 'TopicIndicatorEdge' }
    & Pick<t.TopicIndicatorEdge, 'cursor'>
    & { node: (
      { __typename: 'TopicIndicator' }
      & PriorityFieldsFragment
    ) }
  )> }
);

export type InsightsPriorityQueryVariables = t.Exact<{
  tenant: Array<t.Scalars['String']>;
  input: t.QueryTopicIndicatorInput;
  after?: t.Maybe<t.Scalars['String']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type InsightsPriorityQuery = (
  { __typename: 'Query' }
  & { topicIndicators: (
    { __typename: 'TopicIndicatorConnection' }
    & Pick<t.TopicIndicatorConnection, 'count'>
    & PaginatedIndicatorsFragment
  ) }
);

export type InsightsCategoryQueryVariables = t.Exact<{
  tenant: Array<t.Scalars['String']>;
  input: t.QueryTopicIndicatorInput;
  after?: t.Maybe<t.Scalars['String']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type InsightsCategoryQuery = (
  { __typename: 'Query' }
  & { topicIndicators: (
    { __typename: 'TopicIndicatorConnection' }
    & PaginatedIndicatorsFragment
  ) }
);

export type InsightsDetailsQueryVariables = t.Exact<{
  tenant: Array<t.Scalars['String']>;
  input: t.QueryTopicIndicatorInput;
  similar: t.QueryTopicIndicatorInput;
}>;


export type InsightsDetailsQuery = (
  { __typename: 'Query' }
  & { myInsight: (
    { __typename: 'TopicIndicatorConnection' }
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & ContinuingPageFragment
    ), edges: Array<(
      { __typename: 'TopicIndicatorEdge' }
      & Pick<t.TopicIndicatorEdge, 'cursor'>
      & { node: (
        { __typename: 'TopicIndicator' }
        & PriorityFieldsFragment
      ) }
    )> }
  ), similarInsights: (
    { __typename: 'TopicIndicatorConnection' }
    & { edges: Array<(
      { __typename: 'TopicIndicatorEdge' }
      & { node: (
        { __typename: 'TopicIndicator' }
        & PriorityFieldsFragment
      ) }
    )> }
  ) }
);

export type SiteBucketFragment = (
  { __typename: 'Aggregate' }
  & Pick<t.Aggregate, 'field'>
  & { buckets: Array<(
    { __typename: 'FieldMissingBucket' }
    & Pick<t.FieldMissingBucket, 'fieldMissing'>
  ) | (
    { __typename: 'KeyBucket' }
    & { site: t.KeyBucket['key'] }
  ) | { __typename: 'RangeBucket' }> }
);

export type VersionBucketFragment = (
  { __typename: 'Aggregate' }
  & Pick<t.Aggregate, 'field'>
  & { buckets: Array<(
    { __typename: 'FieldMissingBucket' }
    & Pick<t.FieldMissingBucket, 'fieldMissing'>
  ) | (
    { __typename: 'KeyBucket' }
    & { versionCount: t.KeyBucket['count'], updateVersion: t.KeyBucket['key'] }
    & { sites: Array<(
      { __typename: 'Aggregate' }
      & SiteBucketFragment
    )> }
  ) | { __typename: 'RangeBucket' }> }
);

export type InsightsDeviceActionQueryVariables = t.Exact<{
  offlineFilter?: t.Maybe<t.Filter>;
  availableUpdatesFilter?: t.Maybe<t.Filter>;
  siteUnassignedFilter?: t.Maybe<t.Filter>;
  showOfflineDevices: t.Scalars['Boolean'];
  showAvailableUpdates: t.Scalars['Boolean'];
  showUnassignedSite: t.Scalars['Boolean'];
}>;


export type InsightsDeviceActionQuery = (
  { __typename: 'Query' }
  & { offlineDevices: Array<(
    { __typename: 'Aggregate' }
    & Pick<t.Aggregate, 'field'>
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & { modelCount: t.FieldMissingBucket['count'] }
      & { sites: Array<(
        { __typename: 'Aggregate' }
        & SiteBucketFragment
      )> }
    ) | (
      { __typename: 'KeyBucket' }
      & { model: t.KeyBucket['key'], modelCount: t.KeyBucket['count'] }
      & { sites: Array<(
        { __typename: 'Aggregate' }
        & SiteBucketFragment
      )> }
    ) | (
      { __typename: 'RangeBucket' }
      & { modelCount: t.RangeBucket['count'] }
      & { sites: Array<(
        { __typename: 'Aggregate' }
        & SiteBucketFragment
      )> }
    )> }
  )>, availableUpdates: Array<(
    { __typename: 'Aggregate' }
    & Pick<t.Aggregate, 'field'>
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & { modelCount: t.FieldMissingBucket['count'] }
      & { updateVersions: Array<(
        { __typename: 'Aggregate' }
        & VersionBucketFragment
      )> }
    ) | (
      { __typename: 'KeyBucket' }
      & { model: t.KeyBucket['key'], modelCount: t.KeyBucket['count'] }
      & { updateVersions: Array<(
        { __typename: 'Aggregate' }
        & VersionBucketFragment
      )> }
    ) | (
      { __typename: 'RangeBucket' }
      & { modelCount: t.RangeBucket['count'] }
      & { updateVersions: Array<(
        { __typename: 'Aggregate' }
        & VersionBucketFragment
      )> }
    )> }
  )>, siteUnassigned: Array<(
    { __typename: 'Aggregate' }
    & Pick<t.Aggregate, 'field'>
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & { modelCount: t.FieldMissingBucket['count'] }
    ) | (
      { __typename: 'KeyBucket' }
      & { model: t.KeyBucket['key'], modelCount: t.KeyBucket['count'] }
    ) | (
      { __typename: 'RangeBucket' }
      & { modelCount: t.RangeBucket['count'] }
    )> }
  )> }
);

export type GroupFragment = (
  { __typename: 'GroupDto' }
  & Pick<t.GroupDto, 'id' | 'name' | 'createdAt' | 'deviceSerials' | 'policies'>
);

export type GroupDeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'name' | 'serialNumber' | 'hardwareModel' | 'softwareVersion' | 'connected' | 'supportsSettings' | 'supportsSoftwareUpdate' | 'provisioningEnabled' | 'lastConfigRequestDate'>
  & { site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )>, entityConnections: (
    { __typename: 'EntityConnectionInfo' }
    & { edges: t.Maybe<Array<(
      { __typename: 'EntityConnectionEdge' }
      & { node: (
        { __typename: 'EntityConnection' }
        & Pick<t.EntityConnection, 'entityId' | 'targetEntityId' | 'type' | 'connected'>
      ) }
    )>> }
  ) }
);

export type GroupPolicyFragment = (
  { __typename: 'Policy' }
  & Pick<t.Policy, 'policyId' | 'name' | 'deviceModel' | 'deviceModelUuid'>
  & { configurationAttributes: t.Maybe<Array<t.Maybe<(
    { __typename: 'ConfigurationAttribute' }
    & Pick<t.ConfigurationAttribute, 'name'>
  )>>> }
);

export type DeviceGroupsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type DeviceGroupsQuery = (
  { __typename: 'Query' }
  & { getAllGroups: (
    { __typename: 'GroupAPIResponse' }
    & { groups: t.Maybe<(
      { __typename: 'GroupDtos' }
      & { groups: Array<(
        { __typename: 'GroupDto' }
        & GroupFragment
      )> }
    )> }
  ) }
);

export type DeviceGroupQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type DeviceGroupQuery = (
  { __typename: 'Query' }
  & { readGroup: (
    { __typename: 'GroupAPIResponse' }
    & { groupDoc: t.Maybe<(
      { __typename: 'GroupDto' }
      & GroupFragment
    )> }
  ) }
);

export type GroupsForDeviceQueryVariables = t.Exact<{
  serial: t.Scalars['String'];
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type GroupsForDeviceQuery = (
  { __typename: 'Query' }
  & { getDevice: t.Maybe<(
    { __typename: 'DeviceBasicData' }
    & Pick<t.DeviceBasicData, 'groups'>
  )> }
);

export type CreateDeviceGroupMutationVariables = t.Exact<{
  createSWPolicy?: t.Maybe<t.Scalars['Boolean']>;
  devices?: t.Maybe<t.Devices>;
  groupName: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type CreateDeviceGroupMutation = (
  { __typename: 'Mutation' }
  & { createGroup: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'success' | 'error'>
    & { groupDoc: t.Maybe<(
      { __typename: 'GroupDto' }
      & Pick<t.GroupDto, 'id'>
    )> }
  ) }
);

export type DeleteDeviceGroupsMutationVariables = t.Exact<{
  groups: t.Groups;
}>;


export type DeleteDeviceGroupsMutation = (
  { __typename: 'Mutation' }
  & { deleteGroups: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'success' | 'error'>
  ) }
);

export type UpdateDeviceGroupMutationVariables = t.Exact<{
  groupId: t.Scalars['String'];
  groupName?: t.Maybe<t.Scalars['String']>;
  devices?: t.Maybe<t.Devices>;
  createSWPolicy?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type UpdateDeviceGroupMutation = (
  { __typename: 'Mutation' }
  & { updateGroup: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'success' | 'error'>
  ) }
);

export type UpdateDeviceGroupPriorityMutationVariables = t.Exact<{
  serial: t.Scalars['String'];
  groups?: t.Maybe<Array<t.Maybe<t.Scalars['String']>>>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type UpdateDeviceGroupPriorityMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'updateDeviceGroupPriority'>
);

export type RebootDevicesByGroupMutationVariables = t.Exact<{
  groupId: t.Scalars['String'];
}>;


export type RebootDevicesByGroupMutation = (
  { __typename: 'Mutation' }
  & { rebootGroup: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'success' | 'error'>
  ) }
);

export type SaveUserGroupMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  body: t.UserGroupBody;
}>;


export type SaveUserGroupMutation = (
  { __typename: 'Mutation' }
  & { saveUserGroup: (
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'name' | 'id' | 'createdAt' | 'updatedAt' | 'description' | 'source'>
    & { policies: t.Maybe<Array<(
      { __typename: 'GroupPolicy' }
      & Pick<t.GroupPolicy, 'priority' | 'id'>
    )>>, genericUsers: t.Maybe<(
      { __typename: 'GenericUserList' }
      & { items: Array<(
        { __typename: 'GenericUser' }
        & { user: (
          { __typename: 'UserResponse' }
          & { user: t.Maybe<(
            { __typename: 'User' }
            & Pick<t.User, 'user_id'>
          )> }
        ) }
      )> }
    ) | (
      { __typename: 'GenericUserMessage' }
      & Pick<t.GenericUserMessage, 'value'>
    )> }
  ) }
);

export type ListUserGroupsForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type ListUserGroupsForTenantQuery = (
  { __typename: 'Query' }
  & { userGroupsForTenant: Array<(
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name' | 'description' | 'createdAt' | 'updatedAt' | 'source'>
    & { policies: t.Maybe<Array<(
      { __typename: 'GroupPolicy' }
      & Pick<t.GroupPolicy, 'priority' | 'id' | 'name'>
    )>>, genericUsers: t.Maybe<(
      { __typename: 'GenericUserList' }
      & { items: Array<(
        { __typename: 'GenericUser' }
        & { user: (
          { __typename: 'UserResponse' }
          & { user: t.Maybe<(
            { __typename: 'User' }
            & Pick<t.User, 'user_id'>
          )> }
        ) }
      )> }
    ) | (
      { __typename: 'GenericUserMessage' }
      & Pick<t.GenericUserMessage, 'value'>
    )> }
  )> }
);

export type MutateUserGroupMembershipMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  groupId: t.Scalars['String'];
  newUsers: Array<t.Scalars['String']>;
  removedUsers: Array<t.Scalars['String']>;
}>;


export type MutateUserGroupMembershipMutation = (
  { __typename: 'Mutation' }
  & { mutateUserGroupMembership: (
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'name' | 'id'>
  ) }
);

export type DeleteUserGroupMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  id: t.Scalars['String'];
}>;


export type DeleteUserGroupMutation = (
  { __typename: 'Mutation' }
  & { deleteUserGroup: (
    { __typename: 'GenericUserGroupResponse' }
    & Pick<t.GenericUserGroupResponse, 'error' | 'message'>
  ) }
);

export type GetUserGroupDetailsQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type GetUserGroupDetailsQuery = (
  { __typename: 'Query' }
  & { userGroupsForTenant: Array<(
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name' | 'description' | 'createdAt' | 'updatedAt' | 'source'>
    & { genericUsers: t.Maybe<(
      { __typename: 'GenericUserList' }
      & { items: Array<(
        { __typename: 'GenericUser' }
        & Pick<t.GenericUser, 'name' | 'id' | 'email'>
        & { user: (
          { __typename: 'UserResponse' }
          & { user: t.Maybe<(
            { __typename: 'User' }
            & DeviceUserInfoFragment
          )> }
        ) }
      )> }
    ) | (
      { __typename: 'GenericUserMessage' }
      & Pick<t.GenericUserMessage, 'value'>
    )> }
  )> }
);

export type UpdatePolicyPriorityMutationVariables = t.Exact<{
  id: t.Scalars['String'];
  priority: t.Scalars['String'];
}>;


export type UpdatePolicyPriorityMutation = (
  { __typename: 'Mutation' }
  & { updatePolicyCapabilities: (
    { __typename: 'GroupPolicy' }
    & Pick<t.GroupPolicy, 'id' | 'priority'>
  ) }
);

export type AvailableExternalUserGroupsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  source: t.UserGroupSourceType;
}>;


export type AvailableExternalUserGroupsQuery = (
  { __typename: 'Query' }
  & { userGroupsForTenant: Array<(
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name' | 'description' | 'source'>
  )> }
);

export type UsersForExternalGroupsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  source: t.UserGroupSourceType;
  groupIds: Array<t.Scalars['String']>;
}>;


export type UsersForExternalGroupsQuery = (
  { __typename: 'Query' }
  & { userGroupsForTenant: Array<(
    { __typename: 'UserGroup' }
    & { genericUsers: t.Maybe<(
      { __typename: 'GenericUserList' }
      & { items: Array<(
        { __typename: 'GenericUser' }
        & Pick<t.GenericUser, 'email' | 'name' | 'id'>
        & { user: (
          { __typename: 'UserResponse' }
          & { user: t.Maybe<(
            { __typename: 'User' }
            & Pick<t.User, 'user_id' | 'name'>
          )> }
        ) }
      )> }
    ) | (
      { __typename: 'GenericUserMessage' }
      & Pick<t.GenericUserMessage, 'value'>
    )> }
  )> }
);

export type ImportUserGroupsMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  groups: Array<t.UserGroupBody>;
  source: t.UserGroupSourceType;
}>;


export type ImportUserGroupsMutation = (
  { __typename: 'Mutation' }
  & { importUserGroups: Array<(
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id'>
  )> }
);

export type DeviceUsersCountQueryVariables = t.Exact<{
  params: t.UserSearchParams;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type DeviceUsersCountQuery = (
  { __typename: 'Query' }
  & { deviceUsersResult: (
    { __typename: 'UserConnection' }
    & Pick<t.UserConnection, 'count'>
  ) }
);

export type DeviceUsersListQueryVariables = t.Exact<{
  params: t.UserSearchParams;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type DeviceUsersListQuery = (
  { __typename: 'Query' }
  & { deviceUsersResult: (
    { __typename: 'UserConnection' }
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
    ), deviceUsersInfo: Array<(
      { __typename: 'UserEdge' }
      & Pick<t.UserEdge, 'cursor'>
      & { node: (
        { __typename: 'User' }
        & DeviceUserInfoFragment
      ) }
    )> }
  ) }
);

export type DeviceUserInfoFragment = (
  { __typename: 'User' }
  & Pick<t.User, 'user_id' | 'name' | 'email' | 'last_login'>
  & { connections: t.Maybe<Array<(
    { __typename: 'Device' }
    & { connections: t.Maybe<Array<(
      { __typename: 'Device' }
      & ConnectedDeviceFragment
    )>> }
    & ConnectedDeviceFragment
  )>> }
);

export type DeleteDeviceUserMutationVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  resourceId: t.Scalars['ID'];
}>;


export type DeleteDeviceUserMutation = (
  { __typename: 'Mutation' }
  & { revokeRole: (
    { __typename: 'Accessor' }
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )> }
    )> }
  ) }
);

export type AddDeviceUserMutationVariables = t.Exact<{
  accessorId: t.Scalars['ID'];
  resourceId: t.Scalars['ID'];
}>;


export type AddDeviceUserMutation = (
  { __typename: 'Mutation' }
  & { grantRole: (
    { __typename: 'Accessor' }
    & { grants: Array<(
      { __typename: 'Grant' }
      & Pick<t.Grant, 'resourceId'>
      & { roles: Array<(
        { __typename: 'Role' }
        & Pick<t.Role, 'name'>
      )> }
    )> }
  ) }
);

export type FirmwareUpdateInfoQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type FirmwareUpdateInfoQuery = (
  { __typename: 'Query' }
  & { firmwareUpdateInfo: (
    { __typename: 'FirmwareUpdateInfo' }
    & Pick<t.FirmwareUpdateInfo, 'updateVersion' | 'isUpdateAvailable'>
  ) }
);

export type NetworkDiagnosticFragment = (
  { __typename: 'Device' }
  & { bandwidth: t.Maybe<(
    { __typename: 'Bandwidth' }
    & Pick<t.Bandwidth, 'downloadMbps' | 'endTime' | 'pingJitterMs' | 'pingLatencyMs' | 'pingLossPercent' | 'uploadMbps'>
  )> }
);

export type NetworkDiagnosticsQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type NetworkDiagnosticsQuery = (
  { __typename: 'Query' }
  & { device: (
    { __typename: 'Device' }
    & Pick<t.Device, 'id' | 'name' | 'connected' | 'hardwareModel' | 'hardwareFamily' | 'softwareVersion' | 'hardwareRevision' | 'lastDetected'>
    & { site: t.Maybe<(
      { __typename: 'Site' }
      & Pick<t.Site, 'name'>
    )>, product: t.Maybe<(
      { __typename: 'HardwareProduct' }
      & Pick<t.HardwareProduct, 'updatedAt' | 'id'>
    )> }
    & NetworkDiagnosticFragment
  ) }
);

export type DeleteDevicesMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  serials?: t.Maybe<Array<t.Maybe<t.Scalars['String']>>>;
}>;


export type DeleteDevicesMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'deleteDevices'>
);

export type UnregisterDeviceMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type UnregisterDeviceMutation = (
  { __typename: 'Mutation' }
  & { unregisterDevice: (
    { __typename: 'UnregisterDeviceResponse' }
    & Pick<t.UnregisterDeviceResponse, 'success' | 'error'>
  ) }
);

export type DevicesCardPropsFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'macAddress' | 'internalIp' | 'serialNumber' | 'softwareVersion' | 'softwareBuild' | 'lastDetected' | 'proxyAgent' | 'hardwareModel' | 'id' | 'name' | 'connected' | 'provisioningEnabled' | 'lastConfigRequestDate' | 'dateRegistered' | 'activeApplicationName' | 'supportsSettings' | 'supportsSoftwareUpdate' | 'hasPeripherals' | 'allPeripheralsLinked'>
  & { site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )>, room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'id' | 'name'>
  )> }
  & EntityConnectionsConnectedStateFragment
);

export type EntityConnectionsConnectedStateFragment = (
  { __typename: 'Device' }
  & { entityConnections: (
    { __typename: 'EntityConnectionInfo' }
    & { edges: t.Maybe<Array<(
      { __typename: 'EntityConnectionEdge' }
      & { node: (
        { __typename: 'EntityConnection' }
        & Pick<t.EntityConnection, 'entityId' | 'targetEntityId' | 'type' | 'connected'>
      ) }
    )>> }
  ) }
);

export type DevicesListQueryVariables = t.Exact<{
  filter?: t.Maybe<t.Filter>;
  limit?: t.Maybe<t.Scalars['Int']>;
  sort?: t.Maybe<t.DeviceSort>;
  from: t.Scalars['Int'];
}>;


export type DevicesListQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'countDevices'>
  & { devices: Array<(
    { __typename: 'Device' }
    & DevicesCardPropsFragment
  )> }
);

export type DevicesLocationQueryVariables = t.Exact<{
  aggregations?: t.Maybe<Array<t.Maybe<t.Aggregation>>>;
  noLocationFilter?: t.Maybe<t.Filter>;
  boundsFilter?: t.Maybe<t.Filter>;
  sort?: t.Maybe<t.DeviceSort>;
  from: t.Scalars['Int'];
}>;


export type DevicesLocationQuery = (
  { __typename: 'Query' }
  & { unknownLocationCount: t.Query['countDevices'], deviceCount: t.Query['countDevices'] }
  & { deviceAggregations: Array<(
    { __typename: 'Aggregate' }
    & Pick<t.Aggregate, 'field'>
    & { buckets: Array<(
      { __typename: 'FieldMissingBucket' }
      & Pick<t.FieldMissingBucket, 'count'>
    ) | (
      { __typename: 'KeyBucket' }
      & Pick<t.KeyBucket, 'key' | 'count'>
    ) | (
      { __typename: 'RangeBucket' }
      & Pick<t.RangeBucket, 'count'>
    )> }
  )>, deviceList: Array<(
    { __typename: 'Device' }
    & DevicesCardPropsFragment
  )> }
);

export type StartCallMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
  dialString: t.Scalars['String'];
  options?: t.Maybe<t.CallOptions>;
}>;


export type StartCallMutation = (
  { __typename: 'Mutation' }
  & { startCall: (
    { __typename: 'ActiveCalls' }
    & Pick<t.ActiveCalls, 'success' | 'error'>
  ) }
);

export type EditDeviceDetailsMutationVariables = t.Exact<{
  fields: t.UpdateDeviceRequest;
  id: t.Scalars['String'];
}>;


export type EditDeviceDetailsMutation = (
  { __typename: 'Mutation' }
  & { updateDevice: t.Maybe<(
    { __typename: 'Device' }
    & DeviceFragment
  )> }
);

export type ActiveEntitlementsBySerialQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  productSerial: t.Scalars['String'];
}>;


export type ActiveEntitlementsBySerialQuery = (
  { __typename: 'Query' }
  & { entitlements: (
    { __typename: 'EntitlementConnection' }
    & { edges: Array<(
      { __typename: 'Entitlement' }
      & Pick<t.Entitlement, 'licenseKey'>
    )> }
  ) }
);

export type LinkedDevicesForDeviceQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type LinkedDevicesForDeviceQuery = (
  { __typename: 'Query' }
  & { device: (
    { __typename: 'Device' }
    & EntityConnectionsFragment
  ) }
);

export type ExportDeviceInventoryMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type ExportDeviceInventoryMutation = (
  { __typename: 'Mutation' }
  & { exportDeviceInventory: (
    { __typename: 'ExportDeviceInventoryResponse' }
    & Pick<t.ExportDeviceInventoryResponse, 'success' | 'error' | 'link' | 'recipientEmail'>
  ) }
);

export type ExportDeviceSettingsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type ExportDeviceSettingsQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'exportDeviceSettings'>
);

export type CapabilitiesQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type CapabilitiesQuery = (
  { __typename: 'Query' }
  & { capabilities: Array<(
    { __typename: 'Capability' }
    & Pick<t.Capability, 'id'>
  )> }
);

export type UpdateCapabilitiesMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
  input: t.CapabilitiesInput;
}>;


export type UpdateCapabilitiesMutation = (
  { __typename: 'Mutation' }
  & { capabilitiesMutate: t.Maybe<(
    { __typename: 'Capabilities' }
    & { com: t.Maybe<(
      { __typename: 'com' }
      & { poly: t.Maybe<(
        { __typename: 'poly' }
        & { audio: t.Maybe<(
          { __typename: 'Audio' }
          & { bass: t.Maybe<(
            { __typename: 'StringValue' }
            & Pick<t.StringValue, 'value'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type DeviceConfigParamFragment = (
  { __typename: 'ExtendedConfigParam' }
  & Pick<t.ExtendedConfigParam, 'name' | 'friendlyName' | 'value' | 'type' | 'categories' | 'exportConfigType'>
);

export type StartDeviceConfigExportQueryVariables = t.Exact<{
  deviceId?: t.Maybe<t.Scalars['String']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type StartDeviceConfigExportQuery = (
  { __typename: 'Query' }
  & { startExportDeviceConfigs: t.Maybe<(
    { __typename: 'ExtendedConfigParamsResponse' }
    & Pick<t.ExtendedConfigParamsResponse, 'status' | 'errorMessage'>
  )> }
);

export type DeviceConfigQueryVariables = t.Exact<{
  deviceId?: t.Maybe<t.Scalars['String']>;
  deviceModel?: t.Maybe<t.Scalars['String']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type DeviceConfigQuery = (
  { __typename: 'Query' }
  & { getExtendedConfigParams: t.Maybe<(
    { __typename: 'ExtendedConfigParamsResponse' }
    & Pick<t.ExtendedConfigParamsResponse, 'status' | 'errorMessage'>
    & { configParams: t.Maybe<Array<t.Maybe<(
      { __typename: 'ExtendedConfigParam' }
      & DeviceConfigParamFragment
    )>>> }
  )> }
);

export type NetworkSettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { content: t.Maybe<(
    { __typename: 'PolyOSConfig_content' }
    & { conference: t.Maybe<(
      { __typename: 'PolyOSConfig_content_conference' }
      & Pick<t.PolyOsConfig_Content_Conference, 'qualityPreference'>
    )> }
  )>, qos: t.Maybe<(
    { __typename: 'PolyOSConfig_qos' }
    & Pick<t.PolyOsConfig_Qos, 'tosType' | 'mtuSize' | 'mtuMode'>
    & { intServ: t.Maybe<(
      { __typename: 'PolyOSConfig_qos_intServ' }
      & Pick<t.PolyOsConfig_Qos_IntServ, 'video' | 'audio' | 'fecc' | 'oam'>
    )>, diffServ: t.Maybe<(
      { __typename: 'PolyOSConfig_qos_diffServ' }
      & Pick<t.PolyOsConfig_Qos_DiffServ, 'video' | 'audio' | 'fecc' | 'oam'>
    )>, LPR: t.Maybe<(
      { __typename: 'PolyOSConfig_qos_LPR' }
      & Pick<t.PolyOsConfig_Qos_Lpr, 'enable'>
    )>, rsvp: t.Maybe<(
      { __typename: 'PolyOSConfig_qos_rsvp' }
      & Pick<t.PolyOsConfig_Qos_Rsvp, 'enable'>
    )>, dynamicBandwidth: t.Maybe<(
      { __typename: 'PolyOSConfig_qos_dynamicBandwidth' }
      & Pick<t.PolyOsConfig_Qos_DynamicBandwidth, 'enable'>
    )> }
  )> }
);

export type CalendarSettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { exchange: t.Maybe<(
    { __typename: 'PolyOSConfig_exchange' }
    & Pick<t.PolyOsConfig_Exchange, 'enable' | 'showPrivateMeeting'>
    & { auth: t.Maybe<(
      { __typename: 'PolyOSConfig_exchange_auth' }
      & Pick<t.PolyOsConfig_Exchange_Auth, 'domain' | 'email' | 'password' | 'userName'>
    )>, server: t.Maybe<(
      { __typename: 'PolyOSConfig_exchange_server' }
      & Pick<t.PolyOsConfig_Exchange_Server, 'url'>
    )>, meeting: t.Maybe<(
      { __typename: 'PolyOSConfig_exchange_meeting' }
      & Pick<t.PolyOsConfig_Exchange_Meeting, 'reminderInterval'>
      & { reminderSound: t.Maybe<(
        { __typename: 'PolyOSConfig_exchange_meeting_reminderSound' }
        & Pick<t.PolyOsConfig_Exchange_Meeting_ReminderSound, 'enable'>
      )> }
    )> }
  )> }
);

export type DisplaySettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { video: t.Maybe<(
    { __typename: 'PolyOSConfig_video' }
    & { monitor: t.Maybe<(
      { __typename: 'PolyOSConfig_video_monitor' }
      & { ONE: t.Maybe<(
        { __typename: 'PolyOSConfig_video_monitor_1' }
        & Pick<t.PolyOsConfig_Video_Monitor_1, 'display'>
      )>, TWO: t.Maybe<(
        { __typename: 'PolyOSConfig_video_monitor_2' }
        & Pick<t.PolyOsConfig_Video_Monitor_2, 'display'>
      )> }
    )> }
  )>, homeScreen: t.Maybe<(
    { __typename: 'PolyOSConfig_homeScreen' }
    & Pick<t.PolyOsConfig_HomeScreen, 'backgroundImage'>
  )> }
);

export type CallServerSettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { voIpProt: t.Maybe<(
    { __typename: 'PolyOSConfig_voIpProt' }
    & { H323: t.Maybe<(
      { __typename: 'PolyOSConfig_voIpProt_H323' }
      & Pick<t.PolyOsConfig_VoIpProt_H323, 'enable' | 'e164' | 'name'>
      & { gk: t.Maybe<(
        { __typename: 'PolyOSConfig_voIpProt_H323_gk' }
        & Pick<t.PolyOsConfig_VoIpProt_H323_Gk, 'ipAddress' | 'mode'>
        & { auth: t.Maybe<(
          { __typename: 'PolyOSConfig_voIpProt_H323_gk_auth' }
          & Pick<t.PolyOsConfig_VoIpProt_H323_Gk_Auth, 'enable' | 'password' | 'userId'>
        )> }
      )> }
    )>, SIP: t.Maybe<(
      { __typename: 'PolyOSConfig_voIpProt_SIP' }
      & Pick<t.PolyOsConfig_VoIpProt_Sip, 'enable' | 'bfcpTransportPreference' | 'forceConnectionReuse' | 'proxyServer' | 'registrarServer' | 'registrarServerType' | 'serverType' | 'transport' | 'userName'>
      & { auth: t.Maybe<(
        { __typename: 'PolyOSConfig_voIpProt_SIP_auth' }
        & Pick<t.PolyOsConfig_VoIpProt_Sip_Auth, 'userId' | 'password'>
      )> }
    )> }
  )> }
);

export type UpgradeSettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { upgrade: t.Maybe<(
    { __typename: 'PolyOSConfig_upgrade' }
    & { auto: t.Maybe<(
      { __typename: 'PolyOSConfig_upgrade_auto' }
      & Pick<t.PolyOsConfig_Upgrade_Auto, 'enable'>
      & { server: t.Maybe<(
        { __typename: 'PolyOSConfig_upgrade_auto_server' }
        & Pick<t.PolyOsConfig_Upgrade_Auto_Server, 'type' | 'address'>
      )>, polling: t.Maybe<(
        { __typename: 'PolyOSConfig_upgrade_auto_polling' }
        & Pick<t.PolyOsConfig_Upgrade_Auto_Polling, 'interval'>
      )>, timeFrame: t.Maybe<(
        { __typename: 'PolyOSConfig_upgrade_auto_timeFrame' }
        & Pick<t.PolyOsConfig_Upgrade_Auto_TimeFrame, 'enable' | 'startTime' | 'stopTime'>
      )> }
    )> }
  )> }
);

export type DateTimeSettingsFragment = (
  { __typename: 'PolyOSConfig' }
  & { device: t.Maybe<(
    { __typename: 'PolyOSConfig_device' }
    & { local: t.Maybe<(
      { __typename: 'PolyOSConfig_device_local' }
      & Pick<t.PolyOsConfig_Device_Local, 'timezone'>
      & { autoDaylightSavings: t.Maybe<(
        { __typename: 'PolyOSConfig_device_local_autoDaylightSavings' }
        & Pick<t.PolyOsConfig_Device_Local_AutoDaylightSavings, 'enable'>
      )>, datetime: t.Maybe<(
        { __typename: 'PolyOSConfig_device_local_datetime' }
        & { date: t.Maybe<(
          { __typename: 'PolyOSConfig_device_local_datetime_date' }
          & Pick<t.PolyOsConfig_Device_Local_Datetime_Date, 'format'>
        )>, time: t.Maybe<(
          { __typename: 'PolyOSConfig_device_local_datetime_time' }
          & Pick<t.PolyOsConfig_Device_Local_Datetime_Time, 'TWO4HourClock'>
        )> }
      )>, ntpServer: t.Maybe<(
        { __typename: 'PolyOSConfig_device_local_ntpServer' }
        & Pick<t.PolyOsConfig_Device_Local_NtpServer, 'address' | 'mode'>
      )> }
    )> }
  )> }
);

export type DeviceSettingsQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  noCache?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type DeviceSettingsQuery = (
  { __typename: 'Query' }
  & { deviceSettings: (
    { __typename: 'SettingResponse' }
    & Pick<t.SettingResponse, 'id' | 'fetchedAt'>
    & { settings: t.Maybe<(
      { __typename: 'PolyOSConfig' }
      & NetworkSettingsFragment
      & DisplaySettingsFragment
      & CalendarSettingsFragment
      & CallServerSettingsFragment
      & UpgradeSettingsFragment
      & DateTimeSettingsFragment
    )> }
  ) }
);

export type DeviceSettingsAvailabilityQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  noCache?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type DeviceSettingsAvailabilityQuery = (
  { __typename: 'Query' }
  & { deviceSettings: (
    { __typename: 'SettingResponse' }
    & Pick<t.SettingResponse, 'fetchedAt'>
    & { settings: t.Maybe<(
      { __typename: 'PolyOSConfig' }
      & { prov: t.Maybe<(
        { __typename: 'PolyOSConfig_prov' }
        & Pick<t.PolyOsConfig_Prov, 'enabled'>
      )> }
    )> }
  ) }
);

export type UpsertDeviceSettingsMutationVariables = t.Exact<{
  settings: t.PolyOsConfigInput;
  id: t.Scalars['String'];
}>;


export type UpsertDeviceSettingsMutation = (
  { __typename: 'Mutation' }
  & { upsertDeviceSettings: (
    { __typename: 'SettingResponse' }
    & Pick<t.SettingResponse, 'fetchedAt'>
  ) }
);

export type DeviceSettingsAsXmlQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  waitForDevice?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type DeviceSettingsAsXmlQuery = (
  { __typename: 'Query' }
  & { deviceSettingsAsXML: (
    { __typename: 'SettingXMLResponse' }
    & Pick<t.SettingXmlResponse, 'id' | 'fetchedAt' | 'settings'>
  ) }
);

export type SetDeviceSettingsWithXmlMutationVariables = t.Exact<{
  settingsXML: t.Scalars['String'];
  id: t.Scalars['String'];
}>;


export type SetDeviceSettingsWithXmlMutation = (
  { __typename: 'Mutation' }
  & { setDeviceSettingsWithXML: (
    { __typename: 'SettingResponse' }
    & Pick<t.SettingResponse, 'fetchedAt'>
  ) }
);

export type HardwareModelWithAvailableSoftwareQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type HardwareModelWithAvailableSoftwareQuery = (
  { __typename: 'Query' }
  & { hardwareModel: (
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'name'>
    & { hardwareProducts: Array<(
      { __typename: 'HardwareProduct' }
      & Pick<t.HardwareProduct, 'id'>
      & { availableProductSoftware: t.Maybe<(
        { __typename: 'ProductSoftware' }
        & Pick<t.ProductSoftware, 'version'>
        & { productBuild: t.Maybe<(
          { __typename: 'ProductBuild' }
          & Pick<t.ProductBuild, 'version' | 'build'>
        )> }
      )> }
    )> }
  ) }
);

export type NormalizedDeviceSettingsQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type NormalizedDeviceSettingsQuery = (
  { __typename: 'Query' }
  & { normalizedDeviceSettings: (
    { __typename: 'NormalizedDeviceSettingsResponse' }
    & Pick<t.NormalizedDeviceSettingsResponse, 'id' | 'fetchedAt'>
    & { settings: Array<(
      { __typename: 'NormalizedDeviceSetting' }
      & Pick<t.NormalizedDeviceSetting, 'name' | 'value'>
    )> }
  ) }
);

export type UpsertNormalizedDeviceSettingsMutationVariables = t.Exact<{
  id: t.Scalars['String'];
  settings: Array<t.NormalizedDeviceSettingInput>;
}>;


export type UpsertNormalizedDeviceSettingsMutation = (
  { __typename: 'Mutation' }
  & { upsertNormalizedDeviceSettings: (
    { __typename: 'NormalizedDeviceSettingsResponse' }
    & Pick<t.NormalizedDeviceSettingsResponse, 'id' | 'fetchedAt'>
    & { settings: Array<(
      { __typename: 'NormalizedDeviceSetting' }
      & Pick<t.NormalizedDeviceSetting, 'name' | 'value'>
    )> }
  ) }
);

export type SwSupportUpdatePathFragment = (
  { __typename: 'SoftwareSupportUpdatePath' }
  & Pick<t.SoftwareSupportUpdatePath, 'deviceModel' | 'swPath'>
);

export type PolicyFragment = (
  { __typename: 'Policy' }
  & Pick<t.Policy, 'policyId' | 'name' | 'tenantId' | 'deviceId' | 'deviceType' | 'deviceModelUuid' | 'deviceModel' | 'siteId' | 'groupId' | 'policyType' | 'policyDeploymentScope' | 'swUpdatePath' | 'customSwUpdatePath' | 'swUpdateSource'>
  & { configurationAttributes: t.Maybe<Array<t.Maybe<(
    { __typename: 'ConfigurationAttribute' }
    & Pick<t.ConfigurationAttribute, 'name' | 'currentValue'>
    & { paramArray: t.Maybe<Array<t.Maybe<(
      { __typename: 'ParamArrayItem' }
      & Pick<t.ParamArrayItem, 'replace1' | 'currentValue'>
    )>>>, param2DArray: t.Maybe<Array<t.Maybe<(
      { __typename: 'Param2DArrayItem' }
      & Pick<t.Param2DArrayItem, 'replace1' | 'replace2' | 'currentValue'>
    )>>> }
  )>>>, customSwSupportUpdatePath: t.Maybe<Array<t.Maybe<(
    { __typename: 'SoftwareSupportUpdatePath' }
    & SwSupportUpdatePathFragment
  )>>> }
);

export type PoliciesQueryVariables = t.Exact<{
  deviceModel?: t.Maybe<t.Scalars['String']>;
  deviceId?: t.Maybe<t.Scalars['String']>;
  siteId?: t.Maybe<t.Scalars['String']>;
  groupId?: t.Maybe<t.Scalars['String']>;
  scope?: t.Maybe<t.PolicyDeploymentScope>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type PoliciesQuery = (
  { __typename: 'Query' }
  & { getPolicies: t.Maybe<Array<t.Maybe<(
    { __typename: 'Policy' }
    & PolicyFragment
  )>>> }
);

export type ExternalPolicyFragment = (
  { __typename: 'Policy' }
  & Pick<t.Policy, 'lastSuccessfullyUpdated' | 'lastSuccessfullyUpdatedTime'>
);

export type ExternalPolicyQueryVariables = t.Exact<{
  deviceId?: t.Maybe<t.Scalars['String']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type ExternalPolicyQuery = (
  { __typename: 'Query' }
  & { getPolicies: t.Maybe<Array<t.Maybe<(
    { __typename: 'Policy' }
    & ExternalPolicyFragment
  )>>> }
);

export type CreatePolicyMutationVariables = t.Exact<{
  policy?: t.Maybe<t.PolicyInput>;
  taskExecuteTime?: t.Maybe<t.Scalars['String']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type CreatePolicyMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'createPolicy'>
);

export type UpdatePolicyMutationVariables = t.Exact<{
  policy?: t.Maybe<t.PolicyInput>;
  taskExecuteTime?: t.Maybe<t.Scalars['String']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type UpdatePolicyMutation = (
  { __typename: 'Mutation' }
  & { updatePolicy: t.Maybe<(
    { __typename: 'Policy' }
    & PolicyFragment
  )> }
);

export type DeletePolicyMutationVariables = t.Exact<{
  policyId?: t.Maybe<t.Scalars['String']>;
}>;


export type DeletePolicyMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'deletePolicyById'>
);

export type DeletePoliciesMutationVariables = t.Exact<{
  policyIds?: t.Maybe<Array<t.Maybe<t.Scalars['String']>>>;
}>;


export type DeletePoliciesMutation = (
  { __typename: 'Mutation' }
  & { deletePolicies: t.Maybe<(
    { __typename: 'PolicyResponse' }
    & Pick<t.PolicyResponse, 'ids'>
  )> }
);

export type DeletePoliciesForSitesMutationVariables = t.Exact<{
  siteIds?: t.Maybe<Array<t.Maybe<t.Scalars['String']>>>;
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type DeletePoliciesForSitesMutation = (
  { __typename: 'Mutation' }
  & { deletePoliciesBySiteId: t.Maybe<(
    { __typename: 'PolicyResponse' }
    & Pick<t.PolicyResponse, 'ids'>
  )> }
);

export type DeviceParameterFragment = (
  { __typename: 'DeviceParameterDTO' }
  & Pick<t.DeviceParameterDto, 'displayName' | 'modelName' | 'name' | 'friendlyName' | 'paramType' | 'type' | 'defaultValue' | 'help' | 'templates' | 'callback' | 'accessType' | 'categories' | 'grouping' | 'groupingOrder' | 'lensUserType' | 'lensConditional' | 'lensConditionalValue' | 'languageKey' | 'min' | 'max' | 'numReplace1Max' | 'numReplace2Max' | 'param2DArray' | 'paramArray' | 'featureCategory'>
  & { enumVal: t.Maybe<Array<t.Maybe<(
    { __typename: 'EnumVal' }
    & Pick<t.EnumVal, 'value' | 'friendlyValue' | 'featureCategory'>
  )>>> }
);

export type ExtendedDeviceParameterFragment = (
  { __typename: 'ExtendedDeviceParameterDTO' }
  & Pick<t.ExtendedDeviceParameterDto, 'name' | 'policyDeploymentScope'>
  & { policyAttribute: t.Maybe<(
    { __typename: 'ConfigurationAttribute' }
    & Pick<t.ConfigurationAttribute, 'name' | 'currentValue'>
    & { paramArray: t.Maybe<Array<t.Maybe<(
      { __typename: 'ParamArrayItem' }
      & Pick<t.ParamArrayItem, 'replace1' | 'currentValue'>
    )>>>, param2DArray: t.Maybe<Array<t.Maybe<(
      { __typename: 'Param2DArrayItem' }
      & Pick<t.Param2DArrayItem, 'replace1' | 'replace2' | 'currentValue'>
    )>>> }
  )>, metadata: t.Maybe<(
    { __typename: 'DeviceParameterDTO' }
    & DeviceParameterFragment
  )> }
);

export type DeviceParametersQueryVariables = t.Exact<{
  deviceId?: t.Maybe<t.Scalars['String']>;
  deviceModel?: t.Maybe<t.Scalars['String']>;
  siteId?: t.Maybe<t.Scalars['String']>;
  sendOnlyChanged?: t.Maybe<t.Scalars['Boolean']>;
  tenantId?: t.Maybe<t.Scalars['String']>;
  groupId?: t.Maybe<t.Scalars['String']>;
}>;


export type DeviceParametersQuery = (
  { __typename: 'Query' }
  & { getDeviceParametersExtended: t.Maybe<Array<t.Maybe<(
    { __typename: 'ExtendedDeviceParameterDTO' }
    & ExtendedDeviceParameterFragment
  )>>> }
);

export type ProvisioningSyncMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type ProvisioningSyncMutation = (
  { __typename: 'Mutation' }
  & { requestProvisioningSync: (
    { __typename: 'DeviceAPIResponse' }
    & Pick<t.DeviceApiResponse, 'success' | 'error'>
  ) }
);

export type UpdateImageFragment = (
  { __typename: 'EpUpdateImage' }
  & Pick<t.EpUpdateImage, 'imageType' | 'imagePolicyType' | 'imageVersion' | 'fileName' | 'description' | 'directory' | 'status' | 'size'>
  & { swSupportUpdatePath: t.Maybe<Array<t.Maybe<(
    { __typename: 'SoftwareSupportUpdatePath' }
    & SwSupportUpdatePathFragment
  )>>> }
);

export type EpUpdateImagesQueryVariables = t.Exact<{
  deviceModel?: t.Maybe<t.Scalars['String']>;
  isGlobal?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type EpUpdateImagesQuery = (
  { __typename: 'Query' }
  & { getEpUpdateImages: t.Maybe<Array<t.Maybe<(
    { __typename: 'EpUpdateImage' }
    & UpdateImageFragment
  )>>> }
);

export type DeviceCertificateFragment = (
  { __typename: 'CertificateResponse' }
  & Pick<t.CertificateResponse, 'success' | 'deviceId' | 'error' | 'subjectCN' | 'issuerCN' | 'expiry' | 'checksum' | 'sans'>
);

export type DescribeCertificateQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type DescribeCertificateQuery = (
  { __typename: 'Query' }
  & { describeCertificate: (
    { __typename: 'CertificateResponse' }
    & DeviceCertificateFragment
  ) }
);

export type InstallCertificateMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
  certificate: t.DeviceCertificate;
}>;


export type InstallCertificateMutation = (
  { __typename: 'Mutation' }
  & { installCertificate: (
    { __typename: 'CertificateResponse' }
    & DeviceCertificateFragment
  ) }
);

export type UninstallCertificateMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type UninstallCertificateMutation = (
  { __typename: 'Mutation' }
  & { uninstallCertificate: (
    { __typename: 'APIResponse' }
    & Pick<t.ApiResponse, 'success' | 'error' | 'deviceId'>
  ) }
);

export type UpdateDeviceOsMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type UpdateDeviceOsMutation = (
  { __typename: 'Mutation' }
  & { updateDeviceOS: (
    { __typename: 'DeviceAPIResponse' }
    & Pick<t.DeviceApiResponse, 'success' | 'error'>
  ) }
);

export type TenantRelayDeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'tenantId' | 'name' | 'hardwareModel'>
);

export type TenantRelayDevicesQueryVariables = t.Exact<{
  filter?: t.Maybe<t.Filter>;
  limit?: t.Maybe<t.Scalars['Int']>;
  sort?: t.Maybe<t.DeviceSort>;
  from?: t.Maybe<t.Scalars['Int']>;
}>;


export type TenantRelayDevicesQuery = (
  { __typename: 'Query' }
  & { devices: Array<(
    { __typename: 'Device' }
    & TenantRelayDeviceFragment
  )> }
);

export type DeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'name' | 'organization' | 'hardwareModel' | 'hardwareFamily' | 'hasPeripherals' | 'allPeripheralsLinked' | 'softwareVersion' | 'proxyAgent' | 'lastDetected' | 'softwareBuild' | 'externalIp' | 'internalIp' | 'macAddress' | 'serialNumber' | 'connected' | 'provisioningEnabled' | 'lastConfigRequestDate' | 'activeApplicationName' | 'dateRegistered' | 'supportsSettings' | 'supportsSoftwareUpdate'>
  & { tenant: t.Maybe<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
  )>, user: t.Maybe<(
    { __typename: 'User' }
    & Pick<t.User, 'user_id' | 'name'>
  )>, product: t.Maybe<(
    { __typename: 'HardwareProduct' }
    & Pick<t.HardwareProduct, 'id'>
  )>, model: t.Maybe<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
    & { address: t.Maybe<(
      { __typename: 'Address' }
      & Pick<t.Address, 'formattedAddress' | 'address1' | 'country' | 'city' | 'region' | 'postalCode'>
    )> }
  )>, room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'id' | 'name' | 'floor'>
  )> }
  & ConnectedDevicesFragment
  & EntityConnectionsFragment
);

export type ConnectedDeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'name' | 'serialNumber' | 'softwareVersion' | 'lastDetected' | 'hardwareModel' | 'hardwareProduct' | 'hardwareRevision' | 'macAddress' | 'connected'>
  & { tenant: t.Maybe<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )>, bandwidth: t.Maybe<(
    { __typename: 'Bandwidth' }
    & Pick<t.Bandwidth, 'endTime' | 'pingLatencyMs' | 'pingJitterMs' | 'pingLossPercent' | 'uploadMbps' | 'downloadMbps'>
  )> }
);

export type ConnectedEntityFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'name' | 'serialNumber' | 'softwareVersion' | 'lastDetected' | 'hardwareModel' | 'hardwareRevision' | 'macAddress' | 'connected' | 'lastConfigRequestDate' | 'supportsSettings' | 'supportsSoftwareUpdate' | 'provisioningEnabled'>
  & { tenant: t.Maybe<(
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
  )>, site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )> }
);

export type ConnectedDevicesFragment = (
  { __typename: 'Device' }
  & { connections: t.Maybe<Array<(
    { __typename: 'Device' }
    & DeviceWithConnectionsFragment
  )>> }
);

export type DeviceWithConnectionsFragment = (
  { __typename: 'Device' }
  & { connections: t.Maybe<Array<(
    { __typename: 'Device' }
    & ConnectedDeviceFragment
  )>> }
  & ConnectedDeviceFragment
);

export type EntityConnectionFragment = (
  { __typename: 'EntityConnection' }
  & Pick<t.EntityConnection, 'entityId' | 'targetEntityId' | 'type' | 'connected' | 'createdOn' | 'updatedOn'>
  & { targetEntity: (
    { __typename: 'Device' }
    & ConnectedEntityFragment
  ) }
);

export type EntityConnectionsFragment = (
  { __typename: 'Device' }
  & { entityConnections: (
    { __typename: 'EntityConnectionInfo' }
    & Pick<t.EntityConnectionInfo, 'total'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<t.PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: t.Maybe<Array<(
      { __typename: 'EntityConnectionEdge' }
      & Pick<t.EntityConnectionEdge, 'cursor'>
      & { node: (
        { __typename: 'EntityConnection' }
        & EntityConnectionFragment
      ) }
    )>> }
  ) }
);

export type DeviceDetailsQueryVariables = t.Exact<{
  filter?: t.Maybe<t.Filter>;
  limit?: t.Maybe<t.Scalars['Int']>;
  from?: t.Maybe<t.Scalars['Int']>;
}>;


export type DeviceDetailsQuery = (
  { __typename: 'Query' }
  & { devices: Array<(
    { __typename: 'Device' }
    & DeviceFragment
  )> }
);

export type DeviceQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type DeviceQuery = (
  { __typename: 'Query' }
  & { device: (
    { __typename: 'Device' }
    & DeviceFragment
  ) }
);

export type RestartDeviceMutationVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type RestartDeviceMutation = (
  { __typename: 'Mutation' }
  & { rebootDevice: (
    { __typename: 'DeviceAPIResponse' }
    & Pick<t.DeviceApiResponse, 'success' | 'error'>
  ) }
);

export type FactoryResetMutationVariables = t.Exact<{
  options?: t.Maybe<t.FactoryResetOptions>;
  deviceId: t.Scalars['String'];
}>;


export type FactoryResetMutation = (
  { __typename: 'Mutation' }
  & { factoryReset: (
    { __typename: 'DeviceAPIResponse' }
    & Pick<t.DeviceApiResponse, 'success' | 'error'>
  ) }
);

export type DeviceProvisioningScopeQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  deviceModel?: t.Maybe<t.Scalars['String']>;
  deviceId?: t.Maybe<t.Scalars['String']>;
  siteId?: t.Maybe<t.Scalars['String']>;
}>;


export type DeviceProvisioningScopeQuery = (
  { __typename: 'Query' }
  & { getDeviceParametersExtended: t.Maybe<Array<t.Maybe<(
    { __typename: 'ExtendedDeviceParameterDTO' }
    & Pick<t.ExtendedDeviceParameterDto, 'policyDeploymentScope'>
  )>>> }
);

export type DeviceLineFragment = (
  { __typename: 'C10OutputServiceInformation' }
  & { deviceid: (
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  ), lineid: t.Maybe<(
    { __typename: 'NumberValue' }
    & Pick<t.NumberValue, 'value'>
  )>, serveraddr: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, status: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, linetype: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, regtype: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, userid: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, email: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, expiry: t.Maybe<(
    { __typename: 'NumberValue' }
    & Pick<t.NumberValue, 'value'>
  )>, displayname: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, sipport: t.Maybe<(
    { __typename: 'NumberValue' }
    & Pick<t.NumberValue, 'value'>
  )>, sipaddr: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, siptranport: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, sipaccountname: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, sipdomainname: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, sipusername: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, srvplatform: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, failurereason: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, outboundproxy: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, outboundproxytransport: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, uploadtime: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, versioninfo: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, registeredip: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, domain: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, authtype: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, basedn: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, defaultgroup: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, enablessl: t.Maybe<(
    { __typename: 'BooleanValue' }
    & Pick<t.BooleanValue, 'value'>
  )>, globalserver: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, serverport: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )> }
);

export type DeviceLinesQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type DeviceLinesQuery = (
  { __typename: 'Query' }
  & { capabilitiesQuery: t.Maybe<(
    { __typename: 'Capabilities' }
    & { com: t.Maybe<(
      { __typename: 'com' }
      & { poly: t.Maybe<(
        { __typename: 'poly' }
        & { service_information: t.Maybe<Array<(
          { __typename: 'C10OutputServiceInformation' }
          & DeviceLineFragment
        )>> }
      )> }
    )> }
  )> }
);

export type RequestDeviceLogsMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type RequestDeviceLogsMutation = (
  { __typename: 'Mutation' }
  & { requestUploadDeviceLog: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error'>
  ) }
);

export type FetchDeviceLogsQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type FetchDeviceLogsQuery = (
  { __typename: 'Query' }
  & { accessLogUrl: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'uploadedOn' | 'url'>
  ) }
);

export type RequestToggleFlashMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
  enableFlash: t.Scalars['Boolean'];
}>;


export type RequestToggleFlashMutation = (
  { __typename: 'Mutation' }
  & { toggleLogToFlash: (
    { __typename: 'LogToFlashAPIResponse' }
    & Pick<t.LogToFlashApiResponse, 'requestedValue' | 'result' | 'error'>
  ) }
);

export type GetFlashStatusQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type GetFlashStatusQuery = (
  { __typename: 'Query' }
  & { logToFlashStatus: (
    { __typename: 'LogToFlashAPIResponse' }
    & Pick<t.LogToFlashApiResponse, 'requestedValue' | 'result' | 'error'>
  ) }
);

export type RequestStartUploadPcapMutationVariables = t.Exact<{
  filter: t.Scalars['String'];
  interval: t.Scalars['Int'];
  timeout: t.Scalars['Int'];
  size: t.Scalars['Int'];
  deviceId: t.Scalars['String'];
}>;


export type RequestStartUploadPcapMutation = (
  { __typename: 'Mutation' }
  & { requestStartUploadDevicePCAP: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error' | 'pcapStopTime'>
  ) }
);

export type RequestStopUploadPcapMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type RequestStopUploadPcapMutation = (
  { __typename: 'Mutation' }
  & { requestStopUploadDevicePCAP: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error'>
  ) }
);

export type FetchDevicePcapQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type FetchDevicePcapQuery = (
  { __typename: 'Query' }
  & { accessPCAPUrl: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error' | 'uploadedOn' | 'url' | 'pcapStopTime'>
  ) }
);

export type GetPcapEnabledQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type GetPcapEnabledQuery = (
  { __typename: 'Query' }
  & { getPolicies: t.Maybe<Array<t.Maybe<(
    { __typename: 'Policy' }
    & Pick<t.Policy, 'groupId' | 'modifiedBy' | 'priority'>
    & { swSupportUpdatePath: t.Maybe<Array<t.Maybe<(
      { __typename: 'SoftwareSupportUpdatePath' }
      & Pick<t.SoftwareSupportUpdatePath, 'deviceModel' | 'swPath'>
    )>>> }
    & PolicyFragment
  )>>> }
);

export type SetPcapEnabledMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  policy: t.PolicyInput;
}>;


export type SetPcapEnabledMutation = (
  { __typename: 'Mutation' }
  & { updatePolicy: t.Maybe<(
    { __typename: 'Policy' }
    & Pick<t.Policy, 'groupId' | 'modifiedBy' | 'priority'>
    & { swSupportUpdatePath: t.Maybe<Array<t.Maybe<(
      { __typename: 'SoftwareSupportUpdatePath' }
      & Pick<t.SoftwareSupportUpdatePath, 'deviceModel' | 'swPath'>
    )>>> }
    & PolicyFragment
  )> }
);

export type RequestUploadDeviceScreenMutationVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type RequestUploadDeviceScreenMutation = (
  { __typename: 'Mutation' }
  & { requestUploadDeviceScreen: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error' | 'url' | 'uploadedOn' | 'pcapStopTime'>
  ) }
);

export type AccessScreenUrlQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type AccessScreenUrlQuery = (
  { __typename: 'Query' }
  & { accessScreenUrl: (
    { __typename: 'DeviceLogsAPIResponse' }
    & Pick<t.DeviceLogsApiResponse, 'success' | 'error' | 'url' | 'uploadedOn' | 'pcapStopTime'>
  ) }
);

export type NetworkLinesQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type NetworkLinesQuery = (
  { __typename: 'Query' }
  & { capabilitiesQuery: t.Maybe<(
    { __typename: 'Capabilities' }
    & { com: t.Maybe<(
      { __typename: 'com' }
      & { poly: t.Maybe<(
        { __typename: 'poly' }
        & { network_information: t.Maybe<(
          { __typename: 'C10NetworkInformation' }
          & { interfaces: t.Maybe<(
            { __typename: 'C10NetworkInformationInterfaces' }
            & { value: t.Maybe<Array<(
              { __typename: 'C10NetworkInformationValue' }
              & Pick<t.C10NetworkInformationValue, 'status' | 'cdpstatus' | 'connectionmode' | 'connectionspeed' | 'connectiontype' | 'dnsalternativeaddress' | 'dnsdomain' | 'dnsprimaryaddress' | 'eapmethod' | 'ipv4address' | 'ipv4addresssource' | 'ipv4gateway' | 'ipv4subnet' | 'ipv4vlan' | 'ipv6addresssource' | 'ipv6globaladdress' | 'ipv6linklocaladdress' | 'ipv6ula' | 'lldplocationinformation' | 'lldpneighbors' | 'lldpstatus' | 'ntpserver' | 'provisioningprotocol' | 'pcportstatus' | 'interfacename' | 'vlan' | 'security' | 'ssid' | 'wifistatus'>
            )>> }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type C10PdiFragment = (
  { __typename: 'C10PrimaryDeviceInformation' }
  & { reboottype: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, regioncode: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, powersource: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, softwarebuild: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hardwarepn: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, versioninfo: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, updaterversion: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, uploadtime: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hostos: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hostosbuild: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hostosversion: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, productname: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hosthardware: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, eventmonotonictime: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, productid: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, proxyagent: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, proxyagentversion: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, proxyagentid: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, featurevariation: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, devicesignature: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, softwarerelease: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, serialnumber: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hardwaremodel: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, offsetgmt: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, macaddress: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, productfamily: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, deviceid: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, hardwarerevision: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )>, manufacturer: t.Maybe<(
    { __typename: 'StringValue' }
    & Pick<t.StringValue, 'value'>
  )> }
);

export type PrimaryDeviceInfoLinesQueryVariables = t.Exact<{
  deviceId: t.Scalars['String'];
}>;


export type PrimaryDeviceInfoLinesQuery = (
  { __typename: 'Query' }
  & { capabilitiesQuery: t.Maybe<(
    { __typename: 'Capabilities' }
    & { com: t.Maybe<(
      { __typename: 'com' }
      & { poly: t.Maybe<(
        { __typename: 'poly' }
        & { primary_device_information: t.Maybe<(
          { __typename: 'C10PrimaryDeviceInformation' }
          & C10PdiFragment
        )> }
      )> }
    )> }
  )> }
);

export type GetDeviceSettingsNameQueryVariables = t.Exact<{
  deviceModel?: t.Maybe<t.Scalars['String']>;
}>;


export type GetDeviceSettingsNameQuery = (
  { __typename: 'Query' }
  & { getAllDeviceParameters: t.Maybe<Array<t.Maybe<(
    { __typename: 'DeviceParameterDTO' }
    & Pick<t.DeviceParameterDto, 'name' | 'friendlyName' | 'type'>
  )>>> }
);

export type GetSiteQueryVariables = t.Exact<{
  site: t.Scalars['String'];
}>;


export type GetSiteQuery = (
  { __typename: 'Query' }
  & { getSite: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
    & { address: t.Maybe<(
      { __typename: 'Address' }
      & Pick<t.Address, 'address1' | 'country' | 'city' | 'region' | 'postalCode'>
    )>, rooms: Array<(
      { __typename: 'Room' }
      & Pick<t.Room, 'id' | 'name'>
    )> }
  )> }
);

export type HardwareModelDetailsQueryVariables = t.Exact<{
  id: t.Scalars['ID'];
}>;


export type HardwareModelDetailsQuery = (
  { __typename: 'Query' }
  & { hardwareModel: (
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name' | 'supportsPolicies' | 'aliases'>
  ) }
);

export type OsStateFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'connected' | 'softwareVersion' | 'softwareBuild'>
  & { availableOSs: t.Maybe<Array<(
    { __typename: 'AvailableOS' }
    & { version: (
      { __typename: 'OSVersion' }
      & Pick<t.OsVersion, 'id' | 'version' | 'displayName'>
    ) }
  )>>, currentOSState: t.Maybe<(
    { __typename: 'OSState' }
    & { updateStatus: t.Maybe<(
      { __typename: 'SoftwareUpdateStatus' }
      & Pick<t.SoftwareUpdateStatus, 'maxTime' | 'percentage' | 'percentageComplete' | 'progressState' | 'softUpdateStage' | 'softUpdateStatus'>
    )> }
  )> }
);

export type OsStateQueryVariables = t.Exact<{
  filter?: t.Maybe<t.Filter>;
}>;


export type OsStateQuery = (
  { __typename: 'Query' }
  & { devices: Array<(
    { __typename: 'Device' }
    & OsStateFragment
  )> }
);

export type UpdateSiteMutationVariables = t.Exact<{
  site: t.UpsertSiteRequest;
}>;


export type UpdateSiteMutation = (
  { __typename: 'Mutation' }
  & { upsertSite: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )> }
);

export type DeviceStateSubscriptionQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type DeviceStateSubscriptionQuery = (
  { __typename: 'Query' }
  & { device: (
    { __typename: 'Device' }
    & Pick<t.Device, 'id' | 'callStatus'>
  ) }
);

export type GetAccessTokenListQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type GetAccessTokenListQuery = (
  { __typename: 'Query' }
  & { searchAccessTokens: (
    { __typename: 'ns_ls_ClientAuthTokenConnection' }
    & AccessTokenDataConnectionFragment
  ) }
);

export type GetAccessTokenQueryVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type GetAccessTokenQuery = (
  { __typename: 'Query' }
  & { getAccessToken: t.Maybe<(
    { __typename: 'ns_ls_ClientAuthToken' }
    & AccessTokenDataFragment
  )> }
);

export type CreateAccessTokenMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type CreateAccessTokenMutation = (
  { __typename: 'Mutation' }
  & { createAccessToken: (
    { __typename: 'ns_ls_ClientAuthToken' }
    & AccessTokenDataFragment
  ) }
);

export type DeleteAccessTokenMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type DeleteAccessTokenMutation = (
  { __typename: 'Mutation' }
  & { deleteAccessToken: (
    { __typename: 'ns_ls_ClientAuthToken' }
    & AccessTokenDataFragment
  ) }
);

export type AccessTokenDataConnectionFragment = (
  { __typename: 'ns_ls_ClientAuthTokenConnection' }
  & Pick<t.Ns_Ls_ClientAuthTokenConnection, 'totalCount'>
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
  ), edges: Array<(
    { __typename: 'ns_ls_ClientAuthTokenEdge' }
    & AccessTokenDataEdgeFragment
  )> }
);

export type AccessTokenDataEdgeFragment = (
  { __typename: 'ns_ls_ClientAuthTokenEdge' }
  & Pick<t.Ns_Ls_ClientAuthTokenEdge, 'cursor'>
  & { node: (
    { __typename: 'ns_ls_ClientAuthToken' }
    & AccessTokenDataFragment
  ) }
);

export type AccessTokenDataFragment = (
  { __typename: 'ns_ls_ClientAuthToken' }
  & Pick<t.Ns_Ls_ClientAuthToken, 'creationTime' | 'lastModifiedTime' | 'lastUsedTime' | 'recordId' | 'tenantId' | 'token'>
);

export type GetAuditEventListQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type GetAuditEventListQuery = (
  { __typename: 'Query' }
  & { searchAuditEvents: (
    { __typename: 'ns_ls_AuditEventConnection' }
    & AuditEventDataConnectionFragment
  ) }
);

export type GetAuditEventQueryVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type GetAuditEventQuery = (
  { __typename: 'Query' }
  & { getAuditEvent: t.Maybe<(
    { __typename: 'ns_ls_AuditEvent' }
    & AuditEventDataFragment
  )> }
);

export type AuditEventDataConnectionFragment = (
  { __typename: 'ns_ls_AuditEventConnection' }
  & Pick<t.Ns_Ls_AuditEventConnection, 'totalCount'>
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
  ), edges: Array<(
    { __typename: 'ns_ls_AuditEventEdge' }
    & AuditEventDataEdgeFragment
  )> }
);

export type AuditEventDataEdgeFragment = (
  { __typename: 'ns_ls_AuditEventEdge' }
  & Pick<t.Ns_Ls_AuditEventEdge, 'cursor'>
  & { node: (
    { __typename: 'ns_ls_AuditEvent' }
    & AuditEventDataFragment
  ) }
);

export type AuditEventDataFragment = (
  { __typename: 'ns_ls_AuditEvent' }
  & Pick<t.Ns_Ls_AuditEvent, 'additionalInfo' | 'creationTime' | 'entitlementName' | 'etag' | 'eventTime' | 'eventType' | 'instanceName' | 'newValue' | 'onObjectId' | 'previousValue' | 'recordId' | 'tenantId' | 'userName'>
);

export type EntitlementGroupingSetListQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  groupingId?: t.Maybe<t.Scalars['String']>;
  assignedToTenant?: t.Maybe<t.Scalars['Boolean']>;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type EntitlementGroupingSetListQuery = (
  { __typename: 'Query' }
  & { searchResult: (
    { __typename: 'ns_ls_EntitlementGroupingSetConnection' }
    & EntitlementGroupingSetConnectionFragment
  ) }
);

export type GetEntitlementQueryVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type GetEntitlementQuery = (
  { __typename: 'Query' }
  & { entitlement: t.Maybe<(
    { __typename: 'ns_ls_Entitlement' }
    & EntitlementDataFragment
  )> }
);

export type AssignEntitlementValueMutationVariables = t.Exact<{
  groupingId: t.Scalars['ID'];
  instanceRecordId: t.Scalars['ID'];
  value: t.Scalars['Int'];
}>;


export type AssignEntitlementValueMutation = (
  { __typename: 'Mutation' }
  & { assignEntitlementValue: (
    { __typename: 'ns_ls_EntitlementGroupingSet' }
    & EntitlementGroupingSetDataFragment
  ) }
);

export type DeleteEntitlementGroupMutationVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  groupingId: t.Scalars['String'];
}>;


export type DeleteEntitlementGroupMutation = (
  { __typename: 'Mutation' }
  & { searchDeleteEntitlements: t.Mutation['ns_ls_searchDeleteEntitlements'] }
);

export type ReleaseEntitlementValueMutationVariables = t.Exact<{
  groupingId: t.Scalars['ID'];
  instanceRecordId: t.Scalars['ID'];
  value: t.Scalars['Int'];
}>;


export type ReleaseEntitlementValueMutation = (
  { __typename: 'Mutation' }
  & { releaseEntitlementValue: (
    { __typename: 'ns_ls_EntitlementGroupingSet' }
    & EntitlementGroupingSetDataFragment
  ) }
);

export type CreateEntitlementMutationVariables = t.Exact<{
  entitlement: t.Ns_Ls_EntitlementIn;
}>;


export type CreateEntitlementMutation = (
  { __typename: 'Mutation' }
  & { createEntitlement: (
    { __typename: 'ns_ls_Entitlement' }
    & EntitlementDataFragment
  ) }
);

export type ReleaseEntitlementMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type ReleaseEntitlementMutation = (
  { __typename: 'Mutation' }
  & { releaseEntitlement: (
    { __typename: 'ns_ls_Entitlement' }
    & EntitlementDataFragment
  ) }
);

export type EntitlementGroupingSetConnectionFragment = (
  { __typename: 'ns_ls_EntitlementGroupingSetConnection' }
  & Pick<t.Ns_Ls_EntitlementGroupingSetConnection, 'totalCount'>
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
  ), edges: Array<(
    { __typename: 'ns_ls_EntitlementGroupingSetEdge' }
    & Pick<t.Ns_Ls_EntitlementGroupingSetEdge, 'cursor'>
    & { node: (
      { __typename: 'ns_ls_EntitlementGroupingSet' }
      & EntitlementGroupingSetDataFragment
    ) }
  )> }
);

export type EntitlementGroupingSetDataFragment = (
  { __typename: 'ns_ls_EntitlementGroupingSet' }
  & Pick<t.Ns_Ls_EntitlementGroupingSet, 'assignedToTenant' | 'assignedValueSum' | 'assignmentRecordIds' | 'availableValueSum' | 'awaitingReassignValueSum' | 'awaitingReleaseValueSum' | 'groupingId' | 'isBoolean' | 'isUnlimitedBoolean' | 'normalValueSum' | 'orphanedCount' | 'orphanedValueSum' | 'totalAssignedValueSum' | 'usedValueSum' | 'valueSum'>
  & { assignmentGroupingSets: Array<(
    { __typename: 'ns_ls_EntitlementGroupingAssignmentSet' }
    & EntitlementGroupingAssignmentSetDataFragment
  )>, entitlements: Array<(
    { __typename: 'ns_ls_Entitlement' }
    & EntitlementDataFragment
  )> }
);

export type EntitlementGroupingAssignmentSetDataFragment = (
  { __typename: 'ns_ls_EntitlementGroupingAssignmentSet' }
  & Pick<t.Ns_Ls_EntitlementGroupingAssignmentSet, 'assignedToTenant' | 'assignedValueSum' | 'awaitingReassignEntitlementIds' | 'awaitingReassignValueSum' | 'awaitingReleaseValueSum' | 'entitlementIds' | 'groupingId' | 'orphanedCount' | 'orphanedValueSum' | 'recordId' | 'totalAssignedValueSum' | 'usedValueSum' | 'valueSum'>
);

export type EntitlementDataFragment = (
  { __typename: 'ns_ls_Entitlement' }
  & Pick<t.Ns_Ls_Entitlement, 'activationCode' | 'assignedToRecordId' | 'begins' | 'creationTime' | 'etag' | 'expires' | 'groupingId' | 'lastModifiedTime' | 'mappingId1' | 'mappingId2' | 'name' | 'pendingAssignedToRecordId' | 'productId' | 'productVersion' | 'recordId' | 'state' | 'stringValue' | 'tenantId' | 'assignedToTenant' | 'type' | 'value' | 'valueType'>
);

export type InstanceListQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  after?: t.Maybe<t.Scalars['Cursor']>;
  first?: t.Maybe<t.Scalars['Int']>;
}>;


export type InstanceListQuery = (
  { __typename: 'Query' }
  & { searchResult: (
    { __typename: 'ns_ls_InstanceConnection' }
    & InstanceListConnectionFragment
  ) }
);

export type GetInstanceQueryVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type GetInstanceQuery = (
  { __typename: 'Query' }
  & { getInstance: t.Maybe<(
    { __typename: 'ns_ls_Instance' }
    & InstanceDataFragment
  )> }
);

export type GetLicenseQueryVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type GetLicenseQuery = (
  { __typename: 'Query' }
  & { getLicense: t.Query['ns_ls_getLastLicense'] }
);

export type CreateInstanceMutationVariables = t.Exact<{
  requestValue: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type CreateInstanceMutation = (
  { __typename: 'Mutation' }
  & { createInstance: (
    { __typename: 'ns_ls_Instance' }
    & InstanceDataFragment
  ) }
);

export type CreateAltInstanceMutationVariables = t.Exact<{
  createFromData: t.Ns_Ls_CreateRestrictiveInstanceDataIn;
}>;


export type CreateAltInstanceMutation = (
  { __typename: 'Mutation' }
  & { createAltInstance: (
    { __typename: 'ns_ls_Instance' }
    & InstanceDataFragment
  ) }
);

export type DeleteInstanceMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
}>;


export type DeleteInstanceMutation = (
  { __typename: 'Mutation' }
  & { deleteInstance: (
    { __typename: 'ns_ls_Instance' }
    & InstanceDataFragment
  ) }
);

export type ProcessLicenseRequestMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
  requestValue: t.Scalars['String'];
}>;


export type ProcessLicenseRequestMutation = (
  { __typename: 'Mutation' }
  & { processLicenseRequest: t.Mutation['ns_ls_processLicenseRequest'] }
);

export type ProcessAltLicenseRequestMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
  requestValue: t.Scalars['String'];
}>;


export type ProcessAltLicenseRequestMutation = (
  { __typename: 'Mutation' }
  & { processAltLicenseRequest: t.Mutation['ns_ls_generateAlternateLicense'] }
);

export type ProcessLicenseAckMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
  requestValue: t.Scalars['String'];
}>;


export type ProcessLicenseAckMutation = (
  { __typename: 'Mutation' }
  & { ackInstance: t.Mutation['ns_ls_ackInstance'] }
);

export type ReleaseInstanceMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
  requestValue: t.Scalars['String'];
}>;


export type ReleaseInstanceMutation = (
  { __typename: 'Mutation' }
  & { releaseInstance: t.Mutation['ns_ls_releaseInstance'] }
);

export type UpdateInstanceMutationVariables = t.Exact<{
  recordId: t.Scalars['ID'];
  hostName?: t.Maybe<t.Scalars['String']>;
  niceName?: t.Maybe<t.Scalars['String']>;
  version?: t.Maybe<t.Scalars['String']>;
  serialNumber?: t.Maybe<t.Scalars['String']>;
}>;


export type UpdateInstanceMutation = (
  { __typename: 'Mutation' }
  & { updateInstance: (
    { __typename: 'ns_ls_Instance' }
    & InstanceDataFragment
  ) }
);

export type InstanceListConnectionFragment = (
  { __typename: 'ns_ls_InstanceConnection' }
  & Pick<t.Ns_Ls_InstanceConnection, 'totalCount'>
  & { pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<t.PageInfo, 'hasNextPage' | 'endCursor'>
  ), edges: Array<(
    { __typename: 'ns_ls_InstanceEdge' }
    & Pick<t.Ns_Ls_InstanceEdge, 'cursor'>
    & { node: (
      { __typename: 'ns_ls_Instance' }
      & InstanceDataFragment
    ) }
  )> }
);

export type InstanceDataFragment = (
  { __typename: 'ns_ls_Instance' }
  & Pick<t.Ns_Ls_Instance, 'creationTime' | 'entitlements' | 'etag' | 'hasEncodedLicense' | 'hasInitialEncodedRequest' | 'hasServerChainToken' | 'hostname' | 'instanceId' | 'lastLicenseExpires' | 'lastLicenseHadExpiredEntitlements' | 'lastLicensedTime' | 'lastModifiedTime' | 'macs' | 'niceName' | 'pendingEntitlements' | 'productId' | 'productVersion' | 'recordId' | 'serialNumber' | 'tenantId' | 'useAlternateLicencing'>
);

export type LatestProductVersionsListQueryVariables = t.Exact<{ [key: string]: never; }>;


export type LatestProductVersionsListQuery = (
  { __typename: 'Query' }
  & { getLatestProductVersions: t.Maybe<(
    { __typename: 'ns_ls_ProductLatestVersionList' }
    & ProductLatestVersionListDataFragment
  )> }
);

export type ProductIdsQueryVariables = t.Exact<{ [key: string]: never; }>;


export type ProductIdsQuery = (
  { __typename: 'Query' }
  & { getProductIds: t.Maybe<(
    { __typename: 'ns_ls_ProductList' }
    & Pick<t.Ns_Ls_ProductList, 'productIds'>
  )> }
);

export type ProductVersionsQueryVariables = t.Exact<{
  productId: t.Scalars['String'];
}>;


export type ProductVersionsQuery = (
  { __typename: 'Query' }
  & { getProductVersions: t.Maybe<(
    { __typename: 'ns_ls_ProductVersions' }
    & ProductVersionsDataFragment
  )> }
);

export type ProductSoftwareCatalogQueryVariables = t.Exact<{
  productId: t.Scalars['String'];
  version: t.Scalars['String'];
}>;


export type ProductSoftwareCatalogQuery = (
  { __typename: 'Query' }
  & { getProductSoftwareCatalog: t.Maybe<(
    { __typename: 'ns_ls_SoftwareCatalog' }
    & ProductSoftwareCatalogDataFragment
  )> }
);

export type ProductLatestVersionListDataFragment = (
  { __typename: 'ns_ls_ProductLatestVersionList' }
  & { latestVersions: Array<(
    { __typename: 'ns_ls_ProductLatestVersion' }
    & ProductLatestVersionDataFragment
  )> }
);

export type ProductLatestVersionDataFragment = (
  { __typename: 'ns_ls_ProductLatestVersion' }
  & Pick<t.Ns_Ls_ProductLatestVersion, 'productId' | 'latestVersion'>
);

export type ProductVersionsDataFragment = (
  { __typename: 'ns_ls_ProductVersions' }
  & Pick<t.Ns_Ls_ProductVersions, 'productId' | 'versions'>
);

export type ProductSoftwareCatalogDataFragment = (
  { __typename: 'ns_ls_SoftwareCatalog' }
  & Pick<t.Ns_Ls_SoftwareCatalog, 'productId' | 'version'>
  & { softwareArtifacts: Array<(
    { __typename: 'ns_ls_SoftwareEntry' }
    & ProductSoftwareEntryDataFragment
  )> }
);

export type ProductSoftwareEntryDataFragment = (
  { __typename: 'ns_ls_SoftwareEntry' }
  & Pick<t.Ns_Ls_SoftwareEntry, 'artifactName' | 'fileSize' | 'lastModifiedTime' | 'url'>
);

export type DeleteMockRecordsMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type DeleteMockRecordsMutation = (
  { __typename: 'Mutation' }
  & { deleteMockRecords: (
    { __typename: 'DeleteMockRecordsResult' }
    & Pick<t.DeleteMockRecordsResult, 'resultCode'>
  ) }
);

export type GenerateLicenseMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  userId: t.Scalars['String'];
  quantity?: t.Maybe<t.Scalars['Float']>;
  sku?: t.Maybe<t.Scalars['String']>;
}>;


export type GenerateLicenseMutation = (
  { __typename: 'Mutation' }
  & { generateLicense: (
    { __typename: 'LicenseInfo' }
    & Pick<t.LicenseInfo, 'licenseKey' | 'sku' | 'endDate' | 'activationDate' | 'tenantId' | 'userId' | 'details' | 'quantity'>
  ) }
);

export type EntitleAllDevicesForModelMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  modelId: t.Scalars['String'];
}>;


export type EntitleAllDevicesForModelMutation = (
  { __typename: 'Mutation' }
  & { entitleAllDevicesForModel: Array<(
    { __typename: 'EntitleDeviceResult' }
    & Pick<t.EntitleDeviceResult, 'licenseKey' | 'productSerial' | 'resultCode' | 'resultErrorMessage'>
  )> }
);

export type EntitleDevicesMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  modelId: t.Scalars['String'];
  productSerials: Array<t.Scalars['String']>;
}>;


export type EntitleDevicesMutation = (
  { __typename: 'Mutation' }
  & { entitleDevices: Array<(
    { __typename: 'EntitleDeviceResult' }
    & Pick<t.EntitleDeviceResult, 'licenseKey' | 'productSerial' | 'resultCode' | 'resultErrorMessage'>
  )> }
);

export type LicenseAggregationsByModelQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
}>;


export type LicenseAggregationsByModelQuery = (
  { __typename: 'Query' }
  & { licenseAggregationsByModel: Array<(
    { __typename: 'LicenseAggregations' }
    & Pick<t.LicenseAggregations, 'id' | 'name' | 'activeLicenseCount' | 'expiredLicenseCount' | 'availableLicenseCount' | 'eligibleDeviceCount' | 'ineligibleDeviceCount' | 'availableDeviceCount' | 'entitledDeviceCount'>
  )>, hardwareModels: Array<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
  )> }
);

export type LicenseDetailsQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  licenseKey: t.Scalars['String'];
}>;


export type LicenseDetailsQuery = (
  { __typename: 'Query' }
  & { licenseAggregationsByModel: Array<(
    { __typename: 'LicenseAggregations' }
    & Pick<t.LicenseAggregations, 'id' | 'name' | 'activeLicenseCount' | 'entitledDeviceCount' | 'availableDeviceCount' | 'availableLicenseCount' | 'eligibleDeviceCount' | 'expiredLicenseCount' | 'ineligibleDeviceCount'>
  )>, license: (
    { __typename: 'License' }
    & Pick<t.License, 'licenseKey' | 'sku' | 'userId' | 'endDate' | 'tenantId' | 'activationDate' | 'quantity' | 'isMockLicense' | 'consolidatedKey' | 'type' | 'expired' | 'models' | 'canceled'>
  ) }
);

export type LicenseCountQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  type?: t.Maybe<t.LicenseTypeInput>;
  canceled?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type LicenseCountQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'licenseCount'>
);

export type LicensesQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  type?: t.Maybe<t.LicenseTypeInput>;
  searchTerm?: t.Maybe<t.Scalars['String']>;
  canceled?: t.Maybe<t.Scalars['Boolean']>;
  sort?: t.Maybe<t.LicenseSortObject>;
  from?: t.Maybe<t.Scalars['Int']>;
  limit?: t.Maybe<t.Scalars['Int']>;
}>;


export type LicensesQuery = (
  { __typename: 'Query' }
  & { count: t.Query['licenseCount'] }
  & { licenses: Array<(
    { __typename: 'License' }
    & Pick<t.License, 'licenseKey' | 'userId' | 'endDate' | 'activationDate' | 'quantity' | 'type'>
  )> }
);

export type ActivateLicenseMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  userId: t.Scalars['String'];
  licenseKey: t.Scalars['String'];
}>;


export type ActivateLicenseMutation = (
  { __typename: 'Mutation' }
  & { activateLicense: Array<(
    { __typename: 'LicenseInfo' }
    & Pick<t.LicenseInfo, 'licenseKey' | 'sku' | 'endDate' | 'activationDate' | 'tenantId' | 'userId' | 'details'>
  )> }
);

export type VerifyLicenseKeyQueryVariables = t.Exact<{
  licenseKey: t.Scalars['String'];
}>;


export type VerifyLicenseKeyQuery = (
  { __typename: 'Query' }
  & { verifyLicenseKey: (
    { __typename: 'VerifyLicenseKeyResult' }
    & Pick<t.VerifyLicenseKeyResult, 'success' | 'error'>
    & { availableLicenses: t.Maybe<Array<(
      { __typename: 'License' }
      & AvailableLicenseFragment
    )>> }
  ) }
);

export type AvailableLicenseFragment = (
  { __typename: 'License' }
  & Pick<t.License, 'licenseKey' | 'quantity' | 'endDate' | 'models'>
);

export type CreateGroupPolicyMutationVariables = t.Exact<{
  input: t.GroupPolicyInput;
}>;


export type CreateGroupPolicyMutation = (
  { __typename: 'Mutation' }
  & { createPolicyCapabilities: (
    { __typename: 'GroupPolicy' }
    & Pick<t.GroupPolicy, 'id' | 'collectionId' | 'name' | 'priority' | 'type' | 'settingsCount'>
    & { hardwareModel: t.Maybe<(
      { __typename: 'HardwareModel' }
      & Pick<t.HardwareModel, 'id' | 'name'>
    )> }
  ) }
);

export type UpdateGroupPolicyMutationVariables = t.Exact<{
  input: t.GroupPolicyInput;
}>;


export type UpdateGroupPolicyMutation = (
  { __typename: 'Mutation' }
  & { updatePolicyCapabilities: (
    { __typename: 'GroupPolicy' }
    & Pick<t.GroupPolicy, 'id'>
  ) }
);

export type DeleteGroupPoliciesMutationVariables = t.Exact<{
  policyIds: Array<t.Scalars['String']>;
}>;


export type DeleteGroupPoliciesMutation = (
  { __typename: 'Mutation' }
  & Pick<t.Mutation, 'deletePoliciesCapabilities'>
);

export type GroupPoliciesQueryVariables = t.Exact<{
  rules: t.Rule;
}>;


export type GroupPoliciesQuery = (
  { __typename: 'Query' }
  & { policiesCapabilities: Array<(
    { __typename: 'GroupPolicy' }
    & Pick<t.GroupPolicy, 'id' | 'name' | 'collectionId' | 'settingsCount' | 'priority' | 'type'>
    & { hardwareModel: t.Maybe<(
      { __typename: 'HardwareModel' }
      & Pick<t.HardwareModel, 'id' | 'name'>
    )> }
  )> }
);

export type UserGroupPoliciesPrioritiesQueryVariables = t.Exact<{
  rules: t.Rule;
}>;


export type UserGroupPoliciesPrioritiesQuery = (
  { __typename: 'Query' }
  & { policiesCapabilities: Array<(
    { __typename: 'GroupPolicy' }
    & Pick<t.GroupPolicy, 'id' | 'priority'>
  )> }
);

export type AvailablePolicyCapabilitiesQueryVariables = t.Exact<{
  propertyValue: t.Scalars['String'];
  propertyPath: t.Scalars['String'];
}>;


export type AvailablePolicyCapabilitiesQuery = (
  { __typename: 'Query' }
  & { capabilitiesSuperset: Array<(
    { __typename: 'Capability' }
    & Pick<t.Capability, 'id'>
    & { constraints: t.Maybe<(
      { __typename: 'Constraints' }
      & Pick<t.Constraints, 'options'>
    )> }
  )> }
);

export type AutoCreatedPoliciesQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type AutoCreatedPoliciesQuery = (
  { __typename: 'Query' }
  & { getAutoCreatedPolicies: t.Maybe<Array<t.Maybe<(
    { __typename: 'Policy' }
    & Pick<t.Policy, 'deviceModel' | 'deviceModelUuid'>
  )>>> }
);

export type ReadGroupQueryVariables = t.Exact<{
  groupId: t.Scalars['String'];
}>;


export type ReadGroupQuery = (
  { __typename: 'Query' }
  & { readGroup: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'groupId'>
  ) }
);

export type AllPoliciesGroupsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type AllPoliciesGroupsQuery = (
  { __typename: 'Query' }
  & { getAllGroups: (
    { __typename: 'GroupAPIResponse' }
    & Pick<t.GroupApiResponse, 'groupId'>
    & { groups: t.Maybe<(
      { __typename: 'GroupDtos' }
      & { groups: Array<(
        { __typename: 'GroupDto' }
        & Pick<t.GroupDto, 'name' | 'id' | 'policies'>
      )> }
    )> }
  ) }
);

export type UserGroupsForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type UserGroupsForTenantQuery = (
  { __typename: 'Query' }
  & { userGroupsForTenant: Array<(
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name' | 'source'>
  )> }
);

export type GetUserGroupDevicesQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type GetUserGroupDevicesQuery = (
  { __typename: 'Query' }
  & { getUserGroup: (
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name'>
    & { users: Array<(
      { __typename: 'UserResponse' }
      & { user: t.Maybe<(
        { __typename: 'User' }
        & Pick<t.User, 'user_id' | 'name'>
        & { connections: t.Maybe<Array<(
          { __typename: 'Device' }
          & Pick<t.Device, 'tenantId' | 'id' | 'name' | 'supportsSettings'>
          & { model: t.Maybe<(
            { __typename: 'HardwareModel' }
            & Pick<t.HardwareModel, 'name' | 'id' | 'supportsPolicies'>
          )> }
        )>> }
      )> }
    )> }
  ) }
);

export type GetUserGroupQueryVariables = t.Exact<{
  id: t.Scalars['String'];
  tenantId: t.Scalars['String'];
}>;


export type GetUserGroupQuery = (
  { __typename: 'Query' }
  & { getUserGroup: (
    { __typename: 'UserGroup' }
    & Pick<t.UserGroup, 'id' | 'name'>
  ) }
);

export type GetDeviceNameQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type GetDeviceNameQuery = (
  { __typename: 'Query' }
  & { device: (
    { __typename: 'Device' }
    & Pick<t.Device, 'id' | 'name' | 'productId' | 'serialNumber' | 'hardwareModel' | 'lastConfigRequestDate'>
  ) }
);

export type AddressLookupQueryVariables = t.Exact<{
  address: t.Scalars['ID'];
}>;


export type AddressLookupQuery = (
  { __typename: 'Query' }
  & { postalLookup: Array<(
    { __typename: 'Location' }
    & Pick<t.Location, 'formattedAddress' | 'buildingNumber' | 'street' | 'countryName' | 'city' | 'regionCode' | 'zip' | 'geohash'>
  )> }
);

export type HardwareModelFragment = (
  { __typename: 'HardwareModel' }
  & Pick<t.HardwareModel, 'id' | 'name' | 'aliases' | 'supportsProvisioning' | 'supportsPolicies'>
  & { skus: t.Maybe<Array<(
    { __typename: 'Sku' }
    & Pick<t.Sku, 'id'>
  )>> }
);

export type HardwareModelsQueryVariables = t.Exact<{ [key: string]: never; }>;


export type HardwareModelsQuery = (
  { __typename: 'Query' }
  & { hardwareModels: Array<(
    { __typename: 'HardwareModel' }
    & HardwareModelFragment
  )> }
);

export type SupportsProvisioningOnboardingQueryVariables = t.Exact<{ [key: string]: never; }>;


export type SupportsProvisioningOnboardingQuery = (
  { __typename: 'Query' }
  & { hardwareModels: Array<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
  )> }
);

export type SupportsUsbOnboardingQueryVariables = t.Exact<{ [key: string]: never; }>;


export type SupportsUsbOnboardingQuery = (
  { __typename: 'Query' }
  & { hardwareModels: Array<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
    & { skus: t.Maybe<Array<(
      { __typename: 'Sku' }
      & Pick<t.Sku, 'id'>
    )>> }
  )> }
);

export type RegisterDeviceMutationVariables = t.Exact<{
  device: t.RegisterDeviceRequest;
}>;


export type RegisterDeviceMutation = (
  { __typename: 'Mutation' }
  & { registerDevice: (
    { __typename: 'RegisterDeviceResponse' }
    & Pick<t.RegisterDeviceResponse, 'success' | 'deviceId' | 'error'>
  ) }
);

export type SitesAndRoomsQueryVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
}>;


export type SitesAndRoomsQuery = (
  { __typename: 'Query' }
  & { sites: Array<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name' | 'deviceCount' | 'roomCount'>
    & { address: t.Maybe<(
      { __typename: 'Address' }
      & Pick<t.Address, 'formattedAddress' | 'address1' | 'city' | 'region' | 'postalCode' | 'country' | 'geohash'>
    )>, rooms: Array<(
      { __typename: 'Room' }
      & Pick<t.Room, 'id' | 'name' | 'floor' | 'capacity'>
      & { devices: t.Maybe<Array<(
        { __typename: 'Device' }
        & RoomDeviceFragment
      )>> }
    )> }
  )> }
);

export type ResourceFileFragment = (
  { __typename: 'ResourceFileDTO' }
  & Pick<t.ResourceFileDto, 'tenantId' | 'fileName' | 'fileSize' | 'uploadedBy' | 'uploadedTime'>
);

export type GetResourceFilesQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type GetResourceFilesQuery = (
  { __typename: 'Query' }
  & { getAllResourceFiles: t.Maybe<Array<t.Maybe<(
    { __typename: 'ResourceFileDTO' }
    & ResourceFileFragment
  )>>> }
);

export type AddResourceFileMutationVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  userId?: t.Maybe<t.Scalars['String']>;
  file?: t.Maybe<t.Scalars['String']>;
  fileName: t.Scalars['String'];
  fileSize?: t.Maybe<t.Scalars['Float']>;
}>;


export type AddResourceFileMutation = (
  { __typename: 'Mutation' }
  & { addResourceFile: t.Maybe<(
    { __typename: 'ResourceFileResponse' }
    & Pick<t.ResourceFileResponse, 'status' | 'errors'>
  )> }
);

export type DeleteResourceFilesMutationVariables = t.Exact<{
  tenantId?: t.Maybe<t.Scalars['String']>;
  fileNames?: t.Maybe<Array<t.Maybe<t.Scalars['String']>>>;
}>;


export type DeleteResourceFilesMutation = (
  { __typename: 'Mutation' }
  & { deleteResourceFiles: t.Maybe<(
    { __typename: 'ResourceFileResponse' }
    & Pick<t.ResourceFileResponse, 'status' | 'errors'>
  )> }
);

export type CreateRoomMutationVariables = t.Exact<{
  fields: t.UpsertRoomRequest;
}>;


export type CreateRoomMutation = (
  { __typename: 'Mutation' }
  & { upsertRoom: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'id' | 'name' | 'floor' | 'capacity'>
    & { site: (
      { __typename: 'Site' }
      & Pick<t.Site, 'name'>
    ) }
  )> }
);

export type RoomDeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'id' | 'name' | 'macAddress' | 'hardwareModel' | 'softwareVersion' | 'internalIp' | 'connected'>
  & { model: t.Maybe<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
  )> }
);

export type MtrRoomDeviceFragment = (
  { __typename: 'Device' }
  & Pick<t.Device, 'serialNumber'>
  & { model: t.Maybe<(
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
    & { images: Array<(
      { __typename: 'HardwareModelImage' }
      & Pick<t.HardwareModelImage, 'url'>
    )>, hardwareFamily: (
      { __typename: 'HardwareFamily' }
      & Pick<t.HardwareFamily, 'id'>
    ) }
  )>, product: t.Maybe<(
    { __typename: 'HardwareProduct' }
    & Pick<t.HardwareProduct, 'id'>
  )> }
  & RoomDeviceFragment
);

export type RoomDataFragment = (
  { __typename: 'Room' }
  & Pick<t.Room, 'id' | 'name' | 'floor' | 'capacity'>
  & { site: (
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  ), devices: t.Maybe<Array<(
    { __typename: 'Device' }
    & RoomDeviceFragment
  )>> }
);

export type RoomQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type RoomQuery = (
  { __typename: 'Query' }
  & { room: t.Maybe<(
    { __typename: 'Room' }
    & RoomDataFragment
  )> }
);

export type MtrRoomDevicesQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type MtrRoomDevicesQuery = (
  { __typename: 'Query' }
  & { room: t.Maybe<(
    { __typename: 'Room' }
    & Pick<t.Room, 'id'>
    & { devices: t.Maybe<Array<(
      { __typename: 'Device' }
      & MtrRoomDeviceFragment
    )>> }
  )> }
);

export type UpdateRoomMutationVariables = t.Exact<{
  details: t.UpsertRoomRequest;
}>;


export type UpdateRoomMutation = (
  { __typename: 'Mutation' }
  & { upsertRoom: t.Maybe<(
    { __typename: 'Room' }
    & RoomDataFragment
  )> }
);

export type SwitchRoomSiteMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  siteId: t.Scalars['String'];
  roomId: t.Scalars['String'];
}>;


export type SwitchRoomSiteMutation = (
  { __typename: 'Mutation' }
  & { switchSite: t.Maybe<(
    { __typename: 'Room' }
    & RoomDataFragment
  )> }
);

export type DeleteRoomsMutationVariables = t.Exact<{
  tenantId: t.Scalars['String'];
  roomIds: Array<t.Scalars['String']>;
}>;


export type DeleteRoomsMutation = (
  { __typename: 'Mutation' }
  & { deleteRooms: t.Maybe<Array<(
    { __typename: 'DeleteRoomsResponse' }
    & Pick<t.DeleteRoomsResponse, 'error' | 'success' | 'id'>
  )>> }
);

export type CountDevicesQueryVariables = t.Exact<{
  totalCountFilter: t.Filter;
  connectedCountFilter: t.Filter;
}>;


export type CountDevicesQuery = (
  { __typename: 'Query' }
  & { count: t.Query['countDevices'], connectedCount: t.Query['countDevices'] }
);

export type CountUnassignedDevicesQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type CountUnassignedDevicesQuery = (
  { __typename: 'Query' }
  & { count: t.Query['countDevices'] }
);

export type CountDevicesInUnassignedRoomsQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type CountDevicesInUnassignedRoomsQuery = (
  { __typename: 'Query' }
  & { count: t.Query['countDevices'] }
);

export type SiteOnRoomFragment = (
  { __typename: 'Site' }
  & Pick<t.Site, 'id' | 'name'>
);

export type SitesListEdgesFragment = (
  { __typename: 'SiteConnectionEdge' }
  & Pick<t.SiteConnectionEdge, 'cursor'>
  & { node: (
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name' | 'roomCount' | 'deviceCount' | 'devicesOnlinePercentage'>
  ) }
);

export type RoomsListEdgesFragment = (
  { __typename: 'RoomConnectionEdge' }
  & Pick<t.RoomConnectionEdge, 'cursor'>
  & { node: (
    { __typename: 'Room' }
    & Pick<t.Room, 'id' | 'name' | 'deviceCount' | 'devicesOnlinePercentage' | 'capacity'>
    & { site: (
      { __typename: 'Site' }
      & SiteOnRoomFragment
    ) }
  ) }
);

export type SitesListForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  params?: t.Maybe<t.SiteConnectionParams>;
}>;


export type SitesListForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { siteData: (
      { __typename: 'SiteConnectionObject' }
      & Pick<t.SiteConnectionObject, 'total'>
      & { pageInfo: (
        { __typename: 'PageInformation' }
        & Pick<t.PageInformation, 'hasNextPage' | 'endCursor'>
      ), edges: t.Maybe<Array<(
        { __typename: 'SiteConnectionEdge' }
        & SitesListEdgesFragment
      )>> }
    ) }
  ) }
);

export type SitesCountForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
}>;


export type SitesCountForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { siteCount: (
      { __typename: 'SiteConnectionObject' }
      & Pick<t.SiteConnectionObject, 'total'>
      & { edges: t.Maybe<Array<(
        { __typename: 'SiteConnectionEdge' }
        & { node: (
          { __typename: 'Site' }
          & Pick<t.Site, 'id' | 'name'>
        ) }
      )>> }
    ) }
  ) }
);

export type RoomsListForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['ID'];
  params?: t.Maybe<t.RoomConnectionParams>;
}>;


export type RoomsListForTenantQuery = (
  { __typename: 'Query' }
  & { tenant: (
    { __typename: 'Tenant' }
    & Pick<t.Tenant, 'id'>
    & { roomData: (
      { __typename: 'RoomConnectionObject' }
      & Pick<t.RoomConnectionObject, 'total'>
      & { pageInfo: (
        { __typename: 'PageInformation' }
        & Pick<t.PageInformation, 'hasNextPage' | 'endCursor'>
      ), edges: t.Maybe<Array<(
        { __typename: 'RoomConnectionEdge' }
        & RoomsListEdgesFragment
      )>> }
    ), roomCount: (
      { __typename: 'RoomConnectionObject' }
      & Pick<t.RoomConnectionObject, 'total'>
    ) }
  ) }
);

export type GetSubnetRulesQueryVariables = t.Exact<{
  input: t.GetSubnetRulesInput;
}>;


export type GetSubnetRulesQuery = (
  { __typename: 'Query' }
  & { getSubnetRules: t.Maybe<Array<(
    { __typename: 'SubnetRule' }
    & Pick<t.SubnetRule, 'id' | 'publicCidr' | 'privateCidr'>
  )>> }
);

export type CheckSubnetRuleValidityQueryVariables = t.Exact<{
  input: t.SubnetRuleValidityInput;
}>;


export type CheckSubnetRuleValidityQuery = (
  { __typename: 'Query' }
  & { getSubnetRuleValidity: t.Maybe<(
    { __typename: 'SubnetRuleValidityResponse' }
    & Pick<t.SubnetRuleValidityResponse, 'result' | 'ruleId' | 'siteId' | 'siteName'>
  )> }
);

export type UpdateSubnetRuleMutationVariables = t.Exact<{
  input: t.UpdateSubnetRuleInput;
}>;


export type UpdateSubnetRuleMutation = (
  { __typename: 'Mutation' }
  & { updateSubnetRule: t.Maybe<(
    { __typename: 'SubnetRule' }
    & Pick<t.SubnetRule, 'id'>
  )> }
);

export type DeleteSubnetRuleMutationVariables = t.Exact<{
  input: t.DeleteSubnetRuleInput;
}>;


export type DeleteSubnetRuleMutation = (
  { __typename: 'Mutation' }
  & { deleteSubnetRule: t.Maybe<(
    { __typename: 'SubnetRule' }
    & Pick<t.SubnetRule, 'id'>
  )> }
);

export type CreateSubnetRuleMutationVariables = t.Exact<{
  input: t.CreateSubnetRuleInput;
}>;


export type CreateSubnetRuleMutation = (
  { __typename: 'Mutation' }
  & { createSubnetRule: t.Maybe<(
    { __typename: 'SubnetRule' }
    & Pick<t.SubnetRule, 'id' | 'publicCidr' | 'privateCidr'>
  )> }
);

export type SiteOverviewQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type SiteOverviewQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'countDevices'>
  & { getSite: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'name'>
    & { rooms: Array<(
      { __typename: 'Room' }
      & Pick<t.Room, 'id' | 'name' | 'floor' | 'capacity'>
      & { devices: t.Maybe<Array<(
        { __typename: 'Device' }
        & Pick<t.Device, 'id' | 'name'>
      )>> }
    )>, address: t.Maybe<(
      { __typename: 'Address' }
      & Pick<t.Address, 'address1' | 'formattedAddress'>
    )> }
  )> }
);

export type SiteIdsForTenantQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type SiteIdsForTenantQuery = (
  { __typename: 'Query' }
  & { sites: Array<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id'>
  )> }
);

export type SiteNameAndAddressQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type SiteNameAndAddressQuery = (
  { __typename: 'Query' }
  & { site: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'name'>
    & { address: t.Maybe<(
      { __typename: 'Address' }
      & Pick<t.Address, 'address1' | 'address2' | 'city' | 'region' | 'postalCode' | 'country' | 'latitude' | 'longitude' | 'geohash' | 'formattedAddress'>
    )> }
  )> }
);

export type SiteNameQueryVariables = t.Exact<{
  id: t.Scalars['String'];
}>;


export type SiteNameQuery = (
  { __typename: 'Query' }
  & { siteName: t.Maybe<(
    { __typename: 'Site' }
    & Pick<t.Site, 'id' | 'name'>
  )> }
);

export type DeleteSitesMutationVariables = t.Exact<{
  ids: Array<t.Scalars['String']>;
  tenantId: t.Scalars['String'];
  deleteRooms?: t.Maybe<t.Scalars['Boolean']>;
}>;


export type DeleteSitesMutation = (
  { __typename: 'Mutation' }
  & { deleteSites: t.Maybe<Array<(
    { __typename: 'DeleteSitesResponse' }
    & Pick<t.DeleteSitesResponse, 'id' | 'success' | 'error'>
  )>> }
);

export type RestartDevicesBySiteMutationVariables = t.Exact<{
  siteId: t.Scalars['String'];
}>;


export type RestartDevicesBySiteMutation = (
  { __typename: 'Mutation' }
  & { rebootDevicesBySiteId: (
    { __typename: 'DeviceAPIResponse' }
    & Pick<t.DeviceApiResponse, 'success' | 'error'>
  ) }
);

export type ResendVerifyEmailMutationVariables = t.Exact<{
  id: t.Scalars['ID'];
  clientId?: t.Maybe<t.Scalars['ID']>;
}>;


export type ResendVerifyEmailMutation = (
  { __typename: 'Mutation' }
  & { resendVerifyEmail: (
    { __typename: 'ResendVerificationResponse' }
    & Pick<t.ResendVerificationResponse, 'userId'>
  ) }
);

export type EmailVerifiedQueryVariables = t.Exact<{ [key: string]: never; }>;


export type EmailVerifiedQuery = (
  { __typename: 'Query' }
  & { user: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & Pick<t.User, 'user_id' | 'email_verified'>
    )> }
  ) }
);

export type ProductFragment = (
  { __typename: 'HardwareProduct' }
  & Pick<t.HardwareProduct, 'id' | 'name'>
  & { images: Array<(
    { __typename: 'HardwareImage' }
    & Pick<t.HardwareImage, 'id' | 'url'>
  )>, hardwareModel: (
    { __typename: 'HardwareModel' }
    & Pick<t.HardwareModel, 'id' | 'name'>
    & { hardwareFamily: (
      { __typename: 'HardwareFamily' }
      & Pick<t.HardwareFamily, 'id' | 'name'>
    ), hardwareManufacturer: (
      { __typename: 'HardwareManufacturer' }
      & Pick<t.HardwareManufacturer, 'id' | 'name'>
    ) }
  ) }
);

export type HardwareProductsQueryVariables = t.Exact<{ [key: string]: never; }>;


export type HardwareProductsQuery = (
  { __typename: 'Query' }
  & { hardwareProducts: Array<(
    { __typename: 'HardwareProduct' }
    & ProductFragment
  )> }
);

export type PolyPlusEnabledQueryVariables = t.Exact<{
  tenantId: t.Scalars['String'];
}>;


export type PolyPlusEnabledQuery = (
  { __typename: 'Query' }
  & Pick<t.Query, 'polyPlusEnabled'>
);

export type SetUserMetaDataMutationVariables = t.Exact<{
  input: t.UserMetaDataInput;
}>;


export type SetUserMetaDataMutation = (
  { __typename: 'Mutation' }
  & { setUserMetaData: (
    { __typename: 'UserResponse' }
    & { user: t.Maybe<(
      { __typename: 'User' }
      & { user_metadata: t.Maybe<(
        { __typename: 'UserMetadata' }
        & { info: t.Maybe<(
          { __typename: 'UserMetaDataInfo' }
          & Pick<t.UserMetaDataInfo, 'acceptedToS' | 'theme' | 'highContrastCharts' | 'lastTenantId' | 'ackAdblockWarning' | 'subnetInstructions'>
        )> }
      )> }
    )> }
  ) }
);

export * from "./graphql.schema";